import { PlessHttp } from './../../../shared/http/pless-http.service';
import { Component, OnInit, ViewChild, ViewEncapsulation, ViewContainerRef, ElementRef, ComponentRef, HostListener, AfterViewInit } from '@angular/core';
import { FlexGrid, CellRangeEventArgs, SelectionMode, CellType, CellRange } from '@grapecity/wijmo.grid';
import { Menu } from '@grapecity/wijmo.input';
import { TabPanel } from '@grapecity/wijmo.nav';
import { WjInputDate } from '@grapecity/wijmo.angular2.input';
import { CellMaker } from '@grapecity/wijmo.grid.cellmaker';

import { CommonSetting } from './../../../commons/kymw00/common-setting';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { PlessViewUtilsSub } from './../../../commons/kymw00/pless-view-utils-sub.service';
import { PlessViewHelperSub } from './../../../commons/kymw00/pless-view-helper-sub';
import { PlessDialogServiceSub } from './../../../commons/kymw00/pless-dialog-service-sub';
import { GoodsLockService } from './../../../commons/kymw00/api-services/goods-lock.service';
import { CheckNgWordsService } from './../../../commons/kymw02/check-ng-words/api-services/check-ng-words.service';
import { FileDownloadConfirmService } from './../../../commons/kymw02/file-download-confirm/file-download-confirm.service';
import { FileUploadService, FileAccept } from './../../../commons/kymw02/file-upload/file-upload.service';
import { KYMW0C00InputModel } from './../../../commons/kymw0c/kymw0c00/vo/kymw0c00-input.model';
import { KYMW0301InputModel } from '../../../commons/kymw03/kymw0301/vo/kymw0301-input.model';
import { KYMW0D00Component } from './../../../commons/kymw0d/kymw0d00/kymw0d00.component';
import { KYMW0400Component } from './../../../commons/kymw04/kymw0400/kymw0400.component';
import { NotNullTextAreaComponent } from './../../../commons/kymw02/not-null-text-area/not-null-text-area.component';
import { CheckboxLabelComponent } from './../../../commons/kymw02/checkbox-label/checkbox-label.component';
import { RadioLabelComponent } from './../../../commons/kymw02/radio-label/radio-label.component';
import { SmallClassCodeComboBoxComponent } from './../../../commons/kymw02/combo-box/small-class-code-combo-box/small-class-code-combo-box.component';
import { MiddleClassCodeComboBoxComponent } from './../../../commons/kymw02/combo-box/middle-class-code-combo-box/middle-class-code-combo-box.component';
import { ClassCodeComboBoxComponent } from './../../../commons/kymw02/combo-box/class-code-combo-box/class-code-combo-box.component';
import { LargeClassCodeComboBoxComponent } from './../../../commons/kymw02/combo-box/large-class-code-combo-box/large-class-code-combo-box.component';
import { CodeComboBoxComponent } from './../../../commons/kymw02/combo-box/code-combo-box/code-combo-box.component';
import { NotNullTextInputComponent } from './../../../commons/kymw02/not-null-text-input/not-null-text-input.component';
import { KYMW0800InputModel } from '../../../commons/kymw08/kymw0800/vo/kymw0800-input.model';
import { KYMW0700InputModel } from '../../../commons/kymw07/kymw0700/vo/kymw0700-input.model';
import { KYMW0600InputModel } from '../../../commons/kymw06/kymw0600/vo/kymw0600-input.model';
import { KYMW0500InputModel } from '../../../commons/kymw05/kymw0500/vo/kymw0500-input.model';
import { KYMW0400InputModel } from '../../../commons/kymw04/kymw0400/vo/kymw0400-input.model';
import { KYMW0300InputModel } from '../../../commons/kymw03/kymw0300/vo/kymw0300-input.model';
import { KYMW0300OutputModel } from '../../../commons/kymw03/kymw0300/vo/kymw0300-output.model';
import { KYMW0D00InputModel } from '../../../commons/kymw0d/kymw0d00/vo/kymw0d00-input.model';
import { KYMW0700OutputModel } from '../../../commons/kymw07/kymw0700/vo/kymw0700-output.model';
import { KYMW0600OutputModel } from '../../../commons/kymw06/kymw0600/vo/kymw0600-output.model';
import { KYMW0400OutputModel } from '../../../commons/kymw04/kymw0400/vo/kymw0400-output.model';
import { KYMW0600Component } from './../../../commons/kymw06/kymw0600/kymw0600.component';
import { KYMW0C00Component } from './../../../commons/kymw0c/kymw0c00/kymw0c00.component';
import { KYMW0500Component } from './../../../commons/kymw05/kymw0500/kymw0500.component';
import { KYMW0800Component } from './../../../commons/kymw08/kymw0800/kymw0800.component';
import { KYMW0700Component } from './../../../commons/kymw07/kymw0700/kymw0700.component';
import { KYMW0300Component } from '../../../commons/kymw03/kymw0300/kymw0300.component';

import { KYMW1100ProofOutputModel } from './vo/kymw1100-proof-output.model';
import { DeleteGoodsService } from './api-services/delete-goods.service';
import { DeleteNutrientCompositionService } from './api-services/delete-nutrient-composition.service';
import { OutputGoodsMasterProofService } from './api-services/output-master-proof-list.service';
import { RegistGoodsDetailCopyService } from './api-services/regist-goods-detail-copy.service';
import { GetSupplierService } from './api-services/get-supplier.service';
import { DeleteGoodsDetailService } from './api-services/delete-goods-detail.service';
import { RegistGoodsBaseCopyService } from './api-services/regist-goods-base-copy.service';
import { RegistGoodsService } from './api-services/regist-goods.service';
import { RegistEBaseDataService } from './api-services/regist-ebase-data.service';
import { CreateEBaseDataService } from './api-services/create-ebase-data.service';
import { UpdateEBaseDataService } from './api-services/update-ebase-data.service';
import { GetInitDataService } from './api-services/get-init-data.service';
import { GetConsumeTaxInfoService } from './api-services/get-consume-tax-info.service';
import { GetPurchasePriceService } from './api-services/get-purchase-price.service';
import { GetJANCodeService } from './api-services/get-jan-code.service';
import { GetGoodsDetailService } from './api-services/get-goods-detail.service';
import { GetGoodsBaseService } from './api-services/get-goods-base.service';
import { KYMW1100Model } from './kymw1100.model';
import { KYMW1100InputModel } from './vo/kymw1100-input.model';
import { KYMW1103InputModel } from './vo/kymw1103-input.model';
import { KYMW1104InputModel } from './vo/kymw1104-input.model';
import { KYMW1105InputModel } from './vo/kymw1105-input.model';
import { KYMW1107InputModel } from './vo/kymw1107-input.model';
import { KYMW1600InputModel } from '../../kymw16/kymw1600/vo/kymw1600-input.model';
import { KYMW1100OutputModel } from './vo/kymw1100-output.model';
import { KYMW1103OutputModel } from './vo/kymw1103-output.model';
import { KYMW1104OutputModel } from './vo/kymw1104-output.model';
import { KYMW1105OutputModel } from './vo/kymw1105-output.model';
import { KYMW1107OutputModel } from './vo/kymw1107-output.model';
import { KYMW1102Component } from '../kymw1102/kymw1102.component';
import { KYMW1103Component } from '../kymw1103/kymw1103.component';
import { KYMW1104Component } from '../kymw1104/kymw1104.component';
import { KYMW1105Component } from '../kymw1105/kymw1105.component';
import { KYMW1107Component } from '../kymw1107/kymw1107.component';
import { KYMW1108InputModel } from '../kymw1108/vo/kymw1108-input.model';
import { KYMW1108OutputModel } from '../kymw1108/vo/kymw1108-output.model';
import { KYMW1108Component } from '../kymw1108/kymw1108.component';
import { KYMW1600Component } from '../../kymw16/kymw1600/kymw1600.component';
import { EventArgs } from '@grapecity/wijmo';
import { FMenu } from 'src/app/commons/kymw02/function-menu/fmenu';
import { FunctionMenuService } from 'src/app/commons/kymw02/function-menu/function-menu.service';
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { CanDeactivateType } from 'src/app/shared/utils/leave-confirm.guard';
import { Subject } from 'rxjs';
import { WjFlexGrid } from '@grapecity/wijmo.angular2.grid';
import { GetCandidateGoodsListService } from './api-services/get-candidate-goods-list.service';
import { DataGridUtil } from './../../../commons/kymw00/data-grid-util';
import { CwsPlanCategoryCodeComboBoxComponent } from '../../../../app/commons/kymw02/combo-box/cws-plan-category-code-combo-box/cws-plan-category-code-combo-box.component';
import { KYMW0002Component } from './../../../commons/kymw00/kymw0002/kymw0002.component';
import { GetTagListService } from './api-services/get-tag-list.service';
import { KYMW1202Component } from '../../kymw12/kymw1202/kymw1202.component';
import { KYMW1202InputModel } from '../../kymw12/kymw1202/vo/kymw1202-input.model';
import { GetPublishMediumInfoService } from './api-services/get-publish-medium-info.service';
import { GetOldGoodsTagListService } from './api-services/get-old-goods-tag-list.service';
import { UpdateCoopGoodsUrlDataService } from './api-services/update-coop-goods-url-data.service';
import { GetCoopGoodsUrlDataService } from './api-services/get-coop-goods-url-data.service';
import { KYMW4701Component } from '../../kymw47/kymw4701/kymw4701.component';
import { CandidateGoodsSearchConditionModel } from './vo/candidate-goods-search-condition.model';
import { MakeCandidateGoodsFileService } from './api-services/make-candidate-goods-file.service';

import type { EBaseImportGoodsInfo } from './vo/update-ebase-data-request.model';
import type { SelectableEBaseGoodsInfo } from '../kymw1108/vo/selectable-ebase-goods-info.model';
import { KYMW0300Model } from '../../../commons/kymw03/kymw0300/kymw0300.model';

/** 消費税切り替え制御フラグ */
const KEY_TAX_CHANGE_FLG: string = <string>'TAX_CHANGE_FLG';
/** EC非表示区分「1:価格のみ非表示」 */
const EC_NON_DISP_PRICE: string = <string>'1';

/**
 * 商品マスタ画面を管理するクラス
 *
 * @export KYMW1100Component
 * @class KYMW1100Component
 */
@Component({
  selector: 'app-kymw1100',
  templateUrl: 'kymw1100.component.html',
  styleUrls: ['kymw1100.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1100Component extends PlessViewHelperSub implements OnInit, AfterViewInit {

  // 画面全体タブ
  @ViewChild('tab_KYMW1100', { static: false }) tab_KYMW1100: TabPanel;
  // 画面左側タブ
  @ViewChild('tab_pCode', { static: false }) tab_pCode: TabPanel;
  // 画面右側タブ
  @ViewChild('tab_item', { static: false }) tab_item: TabPanel;

  // 共通部領域
  @ViewChild('btn_GoodsPCode', { static: false }) btn_GoodsPCode: ElementRef;
  @ViewChild('btn_Seach', { static: false }) btn_Seach: ElementRef;
  @ViewChild('btn_Copy', { static: false }) btn_Copy: ElementRef;
  @ViewChild('btn_History', { static: false }) btn_History: ElementRef;
  @ViewChild('btn_himotuke', { static: false }) btn_himotuke: ElementRef;
  @ViewChild('btn_Delete', { static: false }) btn_Delete: ElementRef;
  @ViewChild('btn_Print', { static: false }) btn_Print: ElementRef;
  @ViewChild('btn_Image', { static: false }) btn_Image: ElementRef;
  @ViewChild('btn_Image2', { static: false }) btn_Image2: ElementRef;
  @ViewChild('btn_GoodsInfoOut', { static: false }) btn_GoodsInfoOut: ElementRef;
  @ViewChild('btn_ProofOut', { static: false }) btn_ProofOut: ElementRef;
  @ViewChild('btn_RelationPcode', { static: false }) btn_RelationPcode: ElementRef;
  @ViewChild('cmb_RatechangeBox', { static: false }) cmb_RatechangeBox: CodeComboBoxComponent;
  @ViewChild('btn_MultiGoods', { static: false }) btn_MultiGoods: ElementRef;
  @ViewChild('btn_MediumType', { static: false }) btn_MediumType: ElementRef;
  @ViewChild('btn_Out', { static: false }) btn_Out: ElementRef;

  // 左側タブ内パネル(div)
  @ViewChild('cnv_BaseInfoTab', { static: false }) cnv_BaseInfoTab: ElementRef;
  @ViewChild('cnv_MarkInfoTab', { static: false }) cnv_MarkInfoTab: ElementRef;
  @ViewChild('cnv_AddInfoTab', { static: false }) cnv_AddInfoTab: ElementRef;
  @ViewChild('cnv_DivInfoTab', { static: false }) cnv_DivInfoTab: ElementRef;
  @ViewChild('cnv_GoodsListingTab', { static: false }) cnv_GoodsListingTab: ElementRef;
  @ViewChild('cnv_DnaInfoTab', { static: false }) cnv_DnaInfoTab: ElementRef;
  @ViewChild('cnv_HealthPromotionTab', { static: false }) cnv_HealthPromotionTab: ElementRef;
  @ViewChild('cnv_PageInfoTab', { static: false }) cnv_PageInfoTab: ElementRef;

  // pCode共通部領域
  @ViewChild('txti_Pcode', { static: false }) txti_Pcode: ElementRef;
  @ViewChild('cmb_BuyerCode', { static: false }) cmb_BuyerCode: CodeComboBoxComponent;
  @ViewChild('cmb_ClassCode', { static: false }) cmb_ClassCode: ClassCodeComboBoxComponent;
  @ViewChild('cmb_LargeClassCode', { static: false }) cmb_LargeClassCode: LargeClassCodeComboBoxComponent;
  @ViewChild('cmb_MiddleClassCode', { static: false }) cmb_MiddleClassCode: MiddleClassCodeComboBoxComponent;
  @ViewChild('cmb_SmallClassCodeList', { static: false }) cmb_SmallClassCodeList: SmallClassCodeComboBoxComponent;
  @ViewChild('rdb_AdmitStatus0', { static: false }) rdb_AdmitStatus0: RadioLabelComponent;
  @ViewChild('rdb_AdmitStatus1', { static: false }) rdb_AdmitStatus1: RadioLabelComponent;
  @ViewChild('rdb_AdmitStatus2', { static: false }) rdb_AdmitStatus2: RadioLabelComponent;
  @ViewChild('chk_PackMaterialShowFlg', { static: false }) chk_PackMaterialShowFlg: ElementRef;
  @ViewChild('chk_EndFlag', { static: false }) chk_EndFlag: ElementRef;
  @ViewChild('dtf_AppkyTermEnd', { static: false }) dtf_AppkyTermEnd: WjInputDate;
  @ViewChild('chk_DummyGoods', { static: false }) chk_DummyGoods: ElementRef;
  @ViewChild('dtf_AppkyTermStart', { static: false }) dtf_AppkyTermStart: WjInputDate;
  @ViewChild('cmb_CategoryCode', { static: false }) cmb_CategoryCode: CwsPlanCategoryCodeComboBoxComponent;



  // 基本情報タブ
  @ViewChild('chk_eFriendsSendDiv', { static: false }) chk_eFriendsSendDiv: ElementRef;
  @ViewChild('cmb_CycleTerm', { static: false }) cmb_CycleTerm: CodeComboBoxComponent;
  @ViewChild('cmb_UnitPriceDiv', { static: false }) cmb_UnitPriceDiv: CodeComboBoxComponent;
  @ViewChild('cmb_EdlpDiv', { static: false }) cmb_EdlpDiv: CodeComboBoxComponent;
  @ViewChild('cmb_GuideTempZoneDiv', { static: false }) cmb_GuideTempZoneDiv: CodeComboBoxComponent;
  @ViewChild('cmb_BlindDiv', { static: false }) cmb_BlindDiv: CodeComboBoxComponent;
  @ViewChild('cmb_EcNonDispDiv', { static: false }) cmb_EcNonDispDiv: CodeComboBoxComponent;
  @ViewChild('cmb_LiquorCode', { static: false }) cmb_LiquorCode: CodeComboBoxComponent;
  @ViewChild('cmb_ContainerForm', { static: false }) cmb_ContainerForm: CodeComboBoxComponent;
  @ViewChild('txti_SeasonConsumeTerm', { static: false }) txti_SeasonConsumeTerm: ElementRef;
  @ViewChild('dtf_SeasonConsumeTermFrom', { static: false }) dtf_SeasonConsumeTermFrom: WjInputDate;
  @ViewChild('dtf_SeasonConsumeTermTo', { static: false }) dtf_SeasonConsumeTermTo: WjInputDate;
  @ViewChild('chk_SeasonConsumeDiv', { static: false }) chk_SeasonConsumeDiv: ElementRef;
  @ViewChild('cmb_ConsumeTaxDivList', { static: false }) cmb_ConsumeTaxDivList: CodeComboBoxComponent;
  @ViewChild('txti_DeliveryGoodsNameKanji', { static: false }) txti_DeliveryGoodsNameKanji: NotNullTextInputComponent;
  @ViewChild('txti_DeliveryStandardNameKanji', { static: false }) txti_DeliveryStandardNameKanji: NotNullTextInputComponent;
  @ViewChild('txti_OcrGoodsName', { static: false }) txti_OcrGoodsName: NotNullTextInputComponent;
  @ViewChild('txti_LeaveConsumeTerm', { static: false }) txti_LeaveConsumeTerm: ElementRef;
  @ViewChild('txti_AlocoholType', { static: false }) txti_AlocoholType: ElementRef;
  @ViewChild('txti_ContainerCapacity', { static: false }) txti_ContainerCapacity: ElementRef;
  @ViewChild('txti_ConsumeTaxDivRate', { static: false }) txti_ConsumeTaxDivRate: ElementRef;
  @ViewChild('txti_RelationPcodeOld', { static: false }) txti_RelationPcodeOld: ElementRef;
  @ViewChild('txti_RelationPcodeNew', { static: false }) txti_RelationPcodeNew: ElementRef;
  @ViewChild('txta_MediumText', { static: false }) txta_MediumText: NotNullTextAreaComponent;

  // 付加情報タブ
  @ViewChild('txta_TextInfo1', { static: false }) txta_TextInfo1: NotNullTextAreaComponent;
  @ViewChild('txta_TextInfo2', { static: false }) txta_TextInfo2: NotNullTextAreaComponent;
  @ViewChild('txta_TextInfo3', { static: false }) txta_TextInfo3: NotNullTextAreaComponent;
  @ViewChild('txta_TextInfo4', { static: false }) txta_TextInfo4: NotNullTextAreaComponent;
  @ViewChild('txta_TextInfo5', { static: false }) txta_TextInfo5: NotNullTextAreaComponent;
  @ViewChild('txta_TextInfo6', { static: false }) txta_TextInfo6: NotNullTextAreaComponent;
  @ViewChild('txta_TextInfo7', { static: false }) txta_TextInfo7: NotNullTextAreaComponent;
  @ViewChild('txta_TextInfo8', { static: false }) txta_TextInfo8: NotNullTextAreaComponent;
  @ViewChild('txta_TextInfo9', { static: false }) txta_TextInfo9: NotNullTextAreaComponent;
  @ViewChild('txta_TextInfo10', { static: false }) txta_TextInfo10: NotNullTextAreaComponent;
  @ViewChild('txta_TextInfo11', { static: false }) txta_TextInfo11: NotNullTextAreaComponent;
  @ViewChild('txta_TextInfo12', { static: false }) txta_TextInfo12: NotNullTextAreaComponent;
  @ViewChild('txta_TextInfo13', { static: false }) txta_TextInfo13: NotNullTextAreaComponent;
  @ViewChild('txta_TextInfo14', { static: false }) txta_TextInfo14: NotNullTextAreaComponent;
  @ViewChild('txta_TextInfo15', { static: false }) txta_TextInfo15: NotNullTextAreaComponent;
  @ViewChild('txta_TextInfo16', { static: false }) txta_TextInfo16: NotNullTextAreaComponent;
  @ViewChild('txta_TextInfo17', { static: false }) txta_TextInfo17: NotNullTextAreaComponent;
  @ViewChild('txta_TextInfo18', { static: false }) txta_TextInfo18: NotNullTextAreaComponent;
  @ViewChild('txta_TextInfo19', { static: false }) txta_TextInfo19: NotNullTextAreaComponent;
  @ViewChild('lnb_TextInfo1', { static: false }) lnb_TextInfo1: ElementRef;
  @ViewChild('lnb_TextInfo2', { static: false }) lnb_TextInfo2: ElementRef;
  @ViewChild('lnb_TextInfo3', { static: false }) lnb_TextInfo3: ElementRef;
  @ViewChild('lnb_TextInfo8', { static: false }) lnb_TextInfo8: ElementRef;
  @ViewChild('lnb_TextInfo9', { static: false }) lnb_TextInfo9: ElementRef;

  @ViewChild('lbl_Cnt_TextInfo1', { static: false }) lbl_Cnt_TextInfo1: ElementRef;
  @ViewChild('lbl_Cnt_TextInfo2', { static: false }) lbl_Cnt_TextInfo2: ElementRef;
  @ViewChild('lbl_Cnt_TextInfo3', { static: false }) lbl_Cnt_TextInfo3: ElementRef;
  @ViewChild('lbl_Cnt_TextInfo8', { static: false }) lbl_Cnt_TextInfo8: ElementRef;
  @ViewChild('lbl_Cnt_TextInfo9', { static: false }) lbl_Cnt_TextInfo9: ElementRef;

  // 発注情報タブ
  @ViewChild('cmb_StinkGoodsDivList', { static: false }) cmb_StinkGoodsDivList: CodeComboBoxComponent;
  @ViewChild('cmb_SetDivList', { static: false }) cmb_SetDivList: CodeComboBoxComponent;
  @ViewChild('cmb_CaseSupplyDivList', { static: false }) cmb_CaseSupplyDivList: CodeComboBoxComponent;
  @ViewChild('cmb_LongKeepDivList', { static: false }) cmb_LongKeepDivList: CodeComboBoxComponent;
  @ViewChild('cmb_AssortTempdivList', { static: false }) cmb_AssortTempdivList: CodeComboBoxComponent;
  @ViewChild('cmb_ArrivalAreaDivList', { static: false }) cmb_ArrivalAreaDivList: CodeComboBoxComponent;
  @ViewChild('cmb_DutiesFormDailyDivList', { static: false }) cmb_DutiesFormDailyDivList: CodeComboBoxComponent;
  @ViewChild('cmb_FragileFlgList', { static: false }) cmb_FragileFlgList: CodeComboBoxComponent;
  @ViewChild('txti_ArrivalAdminDays', { static: false }) txti_ArrivalAdminDays: ElementRef;
  @ViewChild('txti_FcmcFee', { static: false }) txti_FcmcFee: ElementRef;
  @ViewChild('txti_InstallmentTimes', { static: false }) txti_InstallmentTimes: ElementRef;
  @ViewChild('txti_SetQuantity', { static: false }) txti_SetQuantity: ElementRef;

  // 表組
  @ViewChild('txti_ListingGoodsName', { static: false }) txti_ListingGoodsName: NotNullTextInputComponent;


  // 保健機能
  @ViewChild('lnb_LicencedDescription', { static: false }) lnb_LicencedDescription: ElementRef;
  @ViewChild('txta_LicencedDescription', { static: false }) txta_LicencedDescription: NotNullTextAreaComponent;
  @ViewChild('txti_LicencedNo', { static: false }) txti_LicencedNo: NotNullTextInputComponent;

  // 関連ページ
  @ViewChild('txti_CoopGoodsTitle', { static: false }) txti_CoopGoodsTitle: NotNullTextAreaComponent;
  @ViewChild('txta_CoopGoodsUrl', { static: false }) txta_CoopGoodsUrl: NotNullTextInputComponent;
  @ViewChild('txti_PageTitle', { static: false }) txti_PageTitle: NotNullTextAreaComponent;
  @ViewChild('txta_PageUrl', { static: false }) txta_PageUrl: NotNullTextInputComponent;

  // 【アイテム情報編集】領域
  @ViewChild('txti_ItemCode', { static: false }) txti_ItemCode: ElementRef;
  @ViewChild('cmb_ItemCode', { static: false }) cmb_ItemCode: ElementRef;
  @ViewChild('chk_JanCodeDiv', { static: false }) chk_JanCodeDiv: ElementRef;
  @ViewChild('btn_ItemCopy', { static: false }) btn_ItemCopy: ElementRef;
  @ViewChild('btn_GoodsItem', { static: false }) btn_GoodsItem: ElementRef;
  @ViewChild('btn_Install', { static: false }) btn_Install: ElementRef;
  @ViewChild('btn_OrderClient', { static: false }) btn_OrderClient: ElementRef;
  @ViewChild('btn_PayeeClient', { static: false }) btn_PayeeClient: ElementRef;
  @ViewChild('btn_StatusUpdate', { static: false }) btn_StatusUpdate: ElementRef;
  @ViewChild('btn_StatusDelete', { static: false }) btn_StatusDelete: ElementRef;

  // 右側タブ内パネル(div)
  @ViewChild('cnv_itemTab', { static: false }) cnv_itemTab: ElementRef;
  @ViewChild('cnv_CoopInfoTab', { static: false }) cnv_CoopInfoTab: ElementRef;
  @ViewChild('cnv_Spec1Tab', { static: false }) cnv_Spec1Tab: ElementRef;
  @ViewChild('cnv_Spec2Tab', { static: false }) cnv_Spec2Tab: ElementRef;
  @ViewChild('cnv_NutrientTab', { static: false }) cnv_NutrientTab: ElementRef;
  @ViewChild('cnv_MultiNutrientTab', { static: false }) cnv_MultiNutrientTab: ElementRef;
  @ViewChild('cnv_EcologyTab', { static: false }) cnv_EcologyTab: ElementRef;

  // アイテムタブ
  @ViewChild('cmb_BrandType', { static: false }) cmb_BrandType: CodeComboBoxComponent;
  @ViewChild('cmb_SpecialOrderTypeList', { static: false }) cmb_SpecialOrderTypeList: CodeComboBoxComponent;
  @ViewChild('cmb_StockTypeList', { static: false }) cmb_StockTypeList: CodeComboBoxComponent;
  @ViewChild('cmb_OrderUnitType', { static: false }) cmb_OrderUnitType: CodeComboBoxComponent;
  @ViewChild('cmb_PriceType', { static: false }) cmb_PriceType: CodeComboBoxComponent;
  @ViewChild('txti_OrderClientCode', { static: false }) txti_OrderClientCode: ElementRef;
  @ViewChild('txti_OrderClientName', { static: false }) txti_OrderClientName: ElementRef;
  @ViewChild('txti_PayeeClientCode', { static: false }) txti_PayeeClientCode: ElementRef;
  @ViewChild('txti_PayeeClientName', { static: false }) txti_PayeeClientName: ElementRef;
  @ViewChild('txti_PdPilingUpDays', { static: false }) txti_PdPilingUpDays: ElementRef;
  @ViewChild('txti_ItfCode', { static: false }) txti_ItfCode: ElementRef;

  // 仕様書１
  @ViewChild('cmb_GeneRecombinationDiv', { static: false }) cmb_GeneRecombinationDiv: CodeComboBoxComponent;
  @ViewChild('chk_MakerNamePublishType', { static: false }) chk_MakerNamePublishType: ElementRef;

  // 仕様書２
  @ViewChild('cmb_AllergenTargetType', { static: false }) cmb_AllergenTargetType: CodeComboBoxComponent;

  // 利用生協タブ
  @ViewChild('txti_SupplyPriceCoefficient', { static: false }) txti_SupplyPriceCoefficient: ElementRef;
  @ViewChild('txti_SupplyPriceSpecial1', { static: false }) txti_SupplyPriceSpecial1: ElementRef;
  @ViewChild('txti_SupplyPriceSpecial2', { static: false }) txti_SupplyPriceSpecial2: ElementRef;
  @ViewChild('txti_CostPricecoefficient', { static: false }) txti_CostPricecoefficient: ElementRef;
  @ViewChild('txti_CostPriceSpecial1', { static: false }) txti_CostPriceSpecial1: ElementRef;
  @ViewChild('txti_CostPriceSpecial2', { static: false }) txti_CostPriceSpecial2: ElementRef;
  @ViewChild('txti_BundlePrice', { static: false }) txti_BundlePrice: ElementRef;
  @ViewChild('btn_SupplyPrice', { static: false }) btn_SupplyPrice: ElementRef;
  @ViewChild('chk_Zeikomi', { static: false }) chk_Zeikomi: ElementRef;
  @ViewChild('txti_ConsumeMessage', { static: false }) txti_ConsumeMessage: ElementRef;

  // 栄養
  @ViewChild('chk_HasMultiNutrientInfo', { static: false }) chk_HasMultiNutrientInfo: CheckboxLabelComponent;

  // 栄養成分・分析単位のグリッド
  @ViewChild('dtg_Mark', { static: false }) dtg_Mark: FlexGrid;
  @ViewChild('dtg_SelectedMark', { static: false }) public dtg_SelectedMark: FlexGrid;
  @ViewChild('dtg_ListingList', { static: false }) dtg_ListingList: FlexGrid;
  @ViewChild('dtg_DnaInfoList', { static: false }) dtg_DnaInfoList: FlexGrid;
  @ViewChild('dtg_UseCoopInfoList', { static: false }) dtg_UseCoopInfoList: FlexGrid;
  @ViewChild('dtg_GoodsAllergenList', { static: false }) dtg_GoodsAllergenList: FlexGrid;
  @ViewChild('dtg_NutrientUnitList', { static: false }) dtg_NutrientUnitList: FlexGrid;
  @ViewChild('dtg_NutrientDetailList', { static: false }) dtg_NutrientDetailList: FlexGrid;
  @ViewChild('dtg_NutrientUnitListMulti', { static: false }) dtg_NutrientUnitListMulti: FlexGrid;
  @ViewChild('dtg_NutrientDetailListMulti', { static: false }) dtg_NutrientDetailListMulti: FlexGrid;
  @ViewChild('dtg_GoodsEcologyList', { static: false }) dtg_GoodsEcologyList: FlexGrid;
  @ViewChild('dtg_GoodsGWStopList', { static: false }) dtg_GoodsGWStopList: FlexGrid;
  @ViewChild('dtg_ContainPackingList', { static: false }) dtg_ContainPackingList: FlexGrid;

  // タグ情報のグリッド
  @ViewChild('dtg_Tag', { static: false }) dtg_Tag: FlexGrid;

  // 環境関連
  @ViewChild('rdb_Ecology1', { static: false }) rdb_Ecology1: RadioLabelComponent;
  @ViewChild('rdb_Ecology2', { static: false }) rdb_Ecology2: RadioLabelComponent;

  @ViewChild('txti_EbaseSpecCode', { static: false }) txti_EbaseSpecCode: ElementRef;
  @ViewChild('txti_JanCode', { static: false }) txti_JanCode: ElementRef;
  @ViewChild('txti_GuideGoodsName', { static: false }) txti_GuideGoodsName: NotNullTextInputComponent;
  @ViewChild('txti_GuideStandardName', { static: false }) txti_GuideStandardName: NotNullTextInputComponent;
  @ViewChild('txti_FixContainNum', { static: false }) txti_FixContainNum: ElementRef;
  @ViewChild('dtf_SpecApplyDate', { static: false }) dtf_SpecApplyDate: ElementRef;
  @ViewChild('txti_ConsumeTerm', { static: false }) txti_ConsumeTerm: ElementRef;
  @ViewChild('txti_ConsumeByDate', { static: false }) txti_ConsumeByDate: ElementRef;
  @ViewChild('txti_PeaceSizeLength', { static: false }) txti_PeaceSizeLength: ElementRef;
  @ViewChild('txti_PeaceSizeWidth', { static: false }) txti_PeaceSizeWidth: ElementRef;
  @ViewChild('txti_PeaceSizeHight', { static: false }) txti_PeaceSizeHight: ElementRef;
  @ViewChild('txti_PeaceWeight', { static: false }) txti_PeaceWeight: ElementRef;
  @ViewChild('txti_CaseSizeLength', { static: false }) txti_CaseSizeLength: ElementRef;
  @ViewChild('txti_CaseSizeWidth', { static: false }) txti_CaseSizeWidth: ElementRef;
  @ViewChild('txti_CaseSizeHight', { static: false }) txti_CaseSizeHight: ElementRef;
  @ViewChild('txti_CaseWeight', { static: false }) txti_CaseWeight: ElementRef;
  @ViewChild('txti_MakerName', { static: false }) txti_MakerName: NotNullTextInputComponent;
  @ViewChild('txti_ArrivalGoodsTemp', { static: false }) txti_ArrivalGoodsTemp: ElementRef;
  @ViewChild('txti_UnitPriceCoefficient', { static: false }) txti_UnitPriceCoefficient: ElementRef;
  @ViewChild('txti_UnitPriceUnit', { static: false }) txti_UnitPriceUnit: NotNullTextInputComponent;
  @ViewChild('txti_MakerPrice', { static: false }) txti_MakerPrice: ElementRef;
  @ViewChild('txti_DeliveryGoodsNameKana', { static: false }) txti_DeliveryGoodsNameKana: NotNullTextInputComponent;
  @ViewChild('txti_DeliveryStandardNameKana', { static: false }) txti_DeliveryStandardNameKana: NotNullTextInputComponent;
  @ViewChild('txti_RegistCatalogRound', { static: false }) txti_RegistCatalogRound: ElementRef;
  @ViewChild('txta_StringValue1', { static: false }) txta_StringValue1: ElementRef;
  @ViewChild('txta_StringValue2', { static: false }) txta_StringValue2: ElementRef;
  @ViewChild('txta_StringValue3', { static: false }) txta_StringValue3: ElementRef;
  @ViewChild('txta_StringValue5', { static: false }) txta_StringValue5: ElementRef;
  @ViewChild('txta_StringValue6', { static: false }) txta_StringValue6: NotNullTextAreaComponent;

  // 右下
  @ViewChild('btn_eBASE', { static: false }) btn_eBASE: ElementRef;
  @ViewChild('lbl_UpdateDate', { static: false }) lbl_UpdateDate: ElementRef;
  @ViewChild('lbl_RegistDate', { static: false }) lbl_RegistDate: ElementRef;

  // 各タブのリンク
  @ViewChild('a_BaseInfoTab', { static: false }) a_BaseInfoTab: ElementRef;
  @ViewChild('a_MarkInfoTab', { static: false }) a_MarkInfoTab: ElementRef;
  @ViewChild('a_AddInfoTab', { static: false }) a_AddInfoTab: ElementRef;
  @ViewChild('a_DivInfoTab', { static: false }) a_DivInfoTab: ElementRef;
  @ViewChild('a_GoodsListingTab', { static: false }) a_GoodsListingTab: ElementRef;
  @ViewChild('a_DnaInfoTab', { static: false }) a_DnaInfoTab: ElementRef;
  @ViewChild('a_HealthPromotionTab', { static: false }) a_HealthPromotionTab: ElementRef;
  @ViewChild('a_itemTab', { static: false }) a_itemTab: ElementRef;
  @ViewChild('a_CoopInfoTab', { static: false }) a_CoopInfoTab: ElementRef;
  @ViewChild('a_Spec1Tab', { static: false }) a_Spec1Tab: ElementRef;
  @ViewChild('a_Spec2Tab', { static: false }) a_Spec2Tab: ElementRef;
  @ViewChild('a_NutrientTab', { static: false }) a_NutrientTab: ElementRef;
  @ViewChild('a_MultiNutrientTab', { static: false }) a_MultiNutrientTab: ElementRef;
  @ViewChild('a_EcologyTab', { static: false }) a_EcologyTab: ElementRef;
  @ViewChild('a_CandidateGoodsListTab', { static: false }) a_CandidateGoodsListTab: ElementRef;
  @ViewChild('a_GoodsMasterTab', { static: false }) a_GoodsMasterTab: ElementRef;
  @ViewChild('a_TagInfoTab', { static: false }) a_TagInfoTab: ElementRef;
  @ViewChild('a_PageInfoTab', { static: false }) a_PageInfoTab: ElementRef;
  
  // 候補リスト
  @ViewChild('dtg_CandidateGoodsList', { static: false }) dtg_CandidateGoodsList: WjFlexGrid;

  lnk_PCode = CellMaker.makeLink({
    click: (e, ctx) => this.setCandidateGoodsListParameter(ctx.item.Pcode)
  });

  iconQuestion = faQuestionCircle;

  /** 編集済みかをチェックするカウンタ */
  public editFlag: boolean = <boolean>false;

  /** 権限「1」は閲覧モード「２」フルコントロール */
  public funcPermission: string = <string>'2';

  /** 登録ボタン【0】、OKボタン【1】 */
  public ExecFlag: string = <string>'0';

  isComposing = false;

  /**
   * searchPCode検索後、コピーした時に貰うPCode
   * successPCode排他制御して成功したPCode
   */
  public searchPCode: string = <string>'';
  public successPCode: string = <string>'';

  /**
   * 排他制御のロックが'2' 成功、'1'失敗
   * lockNum:2 子画面のボタンが活性になる
   * lockNum:1 子画面のボタンが非活性になる
   */
  public lockNum: string = <string>'2';

  private kymw0300InputVO: KYMW0300InputModel = null;		// 商品検索画面のVO
  private kymw0400InputVO: KYMW0400InputModel = null;		// 取引先検索画面のVO
  private kymw0500InputVO: KYMW0500InputModel = null;		// 紐付設定画面のVO
  private kymw0600InputVO: KYMW0600InputModel = null;		// 関連商品設定画面のVO
  private kymw0700InputVO: KYMW0700InputModel = null;		// 文字情報選択画面のVO
  private kymw0800InputVO: KYMW0800InputModel = null;		// 実績履歴画面のVO
  private kymw1103InputVO: KYMW1103InputModel = null;		// 実績履歴画面のVO
  private kymw1104InputVO: KYMW1104InputModel = null;		// アイテム付替のVO
  private kymw1105InputVO: KYMW1105InputModel = null;						// eBASEデータ画面のVO
  private kymw1600InputVO: KYMW1600InputModel = null;		// 画像確認画面のVO

  // タブ内のDataGrid生成を判断するためのフラグ
  /**
   * マークタブ生成済フラグ
   */
  private makeMarkTab: boolean = <boolean>false;

  /**
   * 表組情報タブ生成済フラグ
   */
  private makeGoodsListingTab: boolean = <boolean>false;

  /**
   * 商品DNA情報タブ生成済フラグ
   */
  private makeDnaInfoTab: boolean = <boolean>false;

  /**
   * 利用生協生成済フラグ
   */
  private makeCoopInfoTab: boolean = <boolean>false;

  /**
   * 仕様書２生成済フラグ
   */
  private makeSpec2Tab: boolean = <boolean>false;

  /**
   * 誌面栄養成分生成済フラグ
   */
  private makeNutrientTab: boolean = <boolean>false;

  /**
   * 複数栄養成分生成済フラグ
   */
  private makeMultiNutrientTab: boolean = <boolean>false;

  /**
   * 環境関連生成済フラグ
   */
  private makeEcologyTab: boolean = <boolean>false;

  // 定数
  /**
   * 在庫繰越区分 繰越なし
   */
  private readonly STOCK_TYPE_NONE: string = '0';
  /**
   * 発注単位区分 最終日バラ
   */
  private readonly ORDER_UNIT_TYPE_BARA_FINAL: string = '2';
  /**
   * 発注単位区分 4回以降バラ
   */
  private readonly ORDER_UNIT_TYPE_BARA_AF_4TH: string = '6';

  // 消費税切替後埋め込み文字列(ワーク)
  private taxChangeWkMsg: string = CommonSetting.getVal('TAX_CHANGE_WK_MSG');

  // contextmenu
  public cmDtgNutrientUnitList: Menu = null;
  public cmDtgNutrientUnitListMulti: Menu = null;

  // 親画面からの連携値
  public param: any;

  public kymw1100Model: KYMW1100Model = new KYMW1100Model();
  public kymw0300Model: KYMW0300Model = new KYMW0300Model();

  public kymw0300ComponentRef: ComponentRef<any> = null;
  public kymw0300Component: KYMW0300Component;
  public kymw0800ComponentRef: ComponentRef<any> = null;
  public kymw0800Component: KYMW0800Component = null;

  // 利用生協グリッド　ヘッダー前部文字
  public coopHeaderPreText: string = <string>'';

  // コンテキストメニュー
  private contextMenu: Menu;

  public dispDialog = false;
  // モーダル表示の初期表示かどうかをチェック
  public dispDialogOpen = false;

  public _procDone = false;
  private kymw1100InputVO: KYMW1100InputModel = null;

  /**
   * ウィンドウ内のクリック・右クリック時にイベントを追加
   *
   * @param {*} event
   * @memberof KYMW1100Component
   */
  @HostListener('click', ['$event'])
  @HostListener('contextmenu', ['$event'])
  private onClickOut(event: Event): void {
    // モードレスのコンテキストメニューを非表示
    if (this.kymw0800Component !== null) {
      this.kymw0800Component.contextMenu.hide();
    }
  }

  /**
   * DataGridの列名とテーブル物理名を紐付ける連想配列Object
   */
  private tableName: Object;

  /**
   * Creates an instance of KYMW1100Component.
   * @param {PlessDialogServiceSub} dialogService ダイアログサービス
   * @memberof KYMW1100Component
   */
  constructor(
    public dialogService: PlessDialogServiceSub,
    public kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    public viewContainerRef: ViewContainerRef,
    public fileDownloadConfirmService: FileDownloadConfirmService,
    private getInitDataService: GetInitDataService,
    private getGoodsBaseService: GetGoodsBaseService,
    private getGoodsDetailService: GetGoodsDetailService,
    private getSupplierService: GetSupplierService,
    private deleteGoodsService: DeleteGoodsService,
    private deleteGoodsDetailService: DeleteGoodsDetailService,
    private getJANCodeService: GetJANCodeService,
    private registGoodsBaseCopyService: RegistGoodsBaseCopyService,
    private registGoodsDetailCopyService: RegistGoodsDetailCopyService,
    public getPurchasePriceService: GetPurchasePriceService,
    private getConsumeTaxInfoService: GetConsumeTaxInfoService,
    private registGoodsService: RegistGoodsService,
    private outputGoodsMasterProofService: OutputGoodsMasterProofService,
    private deleteNutrientCompositionService: DeleteNutrientCompositionService,
    private checkNgWordsService: CheckNgWordsService,
    protected goodsLockServiceSub: GoodsLockService,
    private registEBaseDataService: RegistEBaseDataService,
    private createEBaseDataService: CreateEBaseDataService,
    private updateEBaseDataService: UpdateEBaseDataService,
    private makeCandidateGoodsFileService: MakeCandidateGoodsFileService,
    private fileUploadService: FileUploadService,
    private plessHttp: PlessHttp,
    private fmenuService: FunctionMenuService,
    private getCandidateGoodsListService: GetCandidateGoodsListService,
    private getTagListService: GetTagListService,
    private getPublishMediumInfoService: GetPublishMediumInfoService,
    private getOldGoodsTagListService: GetOldGoodsTagListService,
    private updateCoopGoodsUrlDataService: UpdateCoopGoodsUrlDataService,
    private getCoopGoodsUrlDataService: GetCoopGoodsUrlDataService,
  ) {
    super(kymw00Model);
  
    this.tableName = new Object();
    this.tableName['Pcode'] = 'pcode';
    this.tableName['GuideGoodsName'] = 'guideGoodsName';
    this.tableName['GuideStandardName'] = 'guideStandardName';
    this.tableName['LatestOrderCode'] = 'latestOrderCode';
    this.tableName['LatestDelivCatalogId'] = 'latestDelivCatalogId';
    this.tableName['FirstOrderCode'] = 'firstOrderCode';
    this.tableName['FirstDelivCatalogId'] = 'firstDelivCatalogId';
    this.tableName['RegistDate'] = 'registDate';
    this.tableName['UpdateDate'] = 'updateDate';
  }

  /**
   * 初期処理
   *
   * @memberof KYMW1100Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1100';
    this.kymw1100Model.kymw1100Component = this;
    this.goodsLockService = this.goodsLockServiceSub;

    // 商品マスタの初期表示情報を取得する。
    this.getInitDataService.execute(this.kymw1100Model, (data: any) => {
      this.successGoodsPCodeInit(data);
      // モーダル表示 初期検索
      if (this.dispDialog) {
        if (!this.kymw0300InputVO) {
          this.kymw0300InputVO = new KYMW0300InputModel();
        }
        const vo = new KYMW0300OutputModel();
        vo.pcode = this.kymw1100Model.pCode;
        // kymw1200からの画面遷移時に商品マスタメンテナンスタブを開いた状態としたいとの要望対応
        // setKYMW0300Parameterの中のgetCandidateGoodsList(1)で検索後、
        // 候補リストに表示された商品の一つ目のデータをコード上で疑似的にクリックし、
        // 商品マスタメンテナンスタブで表示する
        this.dispDialogOpen = true;
        this.setKYMW0300Parameter(vo);
        
      }
    });

    this.funcPermission = super.getFuncPermission();

    if (this.funcPermission === '1') {
      if (this.btn_GoodsPCode) {
        this.btn_GoodsPCode.nativeElement.disabled = true;
      }
      this.kymw1100Model.enabledGoodsPcodeFlg = false;
      this.kymw1100Model.enabledGoodsSpecFlg = false;
      this.kymw1100Model.enabledGoodsKYMW1104Flg = false;
    }

    // メニュー初期設定
    if (!this.dispDialog) {
      this.initMenuBar();
    }

    // 画面非活性設定
    this.kymw1100Model.enabledInfo1Flg = false;
    this.kymw1100Model.enabledInfo2Flg = false;
  }
  
  /**
   * ビュー初期化
  *
  * @memberof KYMW1100Component
  */
 public ngAfterViewInit(): void {
    // 栄養成分タブ初期化
    this.createNutrientUnitListContextMenu();
    // 複数栄養成分タブ初期化
    this.createNutrientUnitListMultiContextMenu();
  
    this.dtg_Mark.selectionMode =SelectionMode.Row;
    this.dtg_SelectedMark.selectionMode = SelectionMode.Row;
    this.dtg_ListingList.selectionMode = SelectionMode.Row;
    this.dtg_DnaInfoList.selectionMode = SelectionMode.Row;
    this.dtg_UseCoopInfoList.selectionMode = SelectionMode.Row;
    this.dtg_GoodsAllergenList.selectionMode = SelectionMode.Row;
    this.dtg_NutrientUnitList.selectionMode = SelectionMode.Row;
    this.dtg_NutrientDetailList.selectionMode = SelectionMode.Row;
    this.dtg_NutrientUnitListMulti.selectionMode = SelectionMode.Row;
    this.dtg_NutrientDetailListMulti.selectionMode = SelectionMode.Row;
    this.dtg_GoodsEcologyList.selectionMode = SelectionMode.Row;
    this.dtg_GoodsGWStopList.selectionMode = SelectionMode.Row;
    this.dtg_ContainPackingList.selectionMode = SelectionMode.Row;
  
    this.dtg_UseCoopInfoList.columnHeaders.rows[0].height = 50;
  
    // 栄養成分　分析単位
    this.dtg_NutrientUnitList.rows.defaultSize = 73;
  
    // 複数栄養成分　分析単位
    this.dtg_NutrientUnitListMulti.rows.defaultSize = 73;
  
    this.eventListenerSetting();
  
    this.btn_StatusUpdate.nativeElement.disabled = true;
  
    // グリッドの初期選択行はなしとする
    this.dtg_Mark.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_Mark.select(-1, -1);
    });
    this.dtg_SelectedMark.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_SelectedMark.select(-1, -1);
    });
    this.dtg_ListingList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_ListingList.select(-1, -1);
    });
    this.dtg_DnaInfoList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_DnaInfoList.select(-1, -1);
    });
    this.dtg_UseCoopInfoList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_UseCoopInfoList.select(-1, -1);
    });
    this.dtg_GoodsAllergenList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_GoodsAllergenList.select(-1, -1);
    });
    this.dtg_NutrientUnitList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_NutrientUnitList.select(-1, -1);
    });
    this.dtg_NutrientDetailList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_NutrientDetailList.select(-1, -1);
    });
    this.dtg_NutrientDetailListMulti.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_NutrientDetailListMulti.select(-1, -1);
    });
    this.dtg_GoodsEcologyList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_GoodsEcologyList.select(-1, -1);
    });
    this.dtg_GoodsGWStopList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_GoodsGWStopList.select(-1, -1);
    });
    this.dtg_ContainPackingList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_ContainPackingList.select(-1, -1);
    });
    this.dtg_Tag.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_Tag.select(-1, -1);
    });
  
    this.dtg_Mark.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      var ht = this.dtg_Mark.hitTest(e);
      if ((0 <= ht.row) && (0 == ht.col) && ht.target.className !== 'wj-cell wj-header wj-align-center') {
        document.getElementById(`cb_mark_${ht.row}`).click();
      }
    });
    this.dtg_DnaInfoList.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      var ht = this.dtg_DnaInfoList.hitTest(e);
      if ((0 <= ht.row) && (0 == ht.col) && ht.target.className !== 'wj-cell wj-header wj-align-center') {
        document.getElementById(`cb_dna_${ht.row}`).click();
      }
    });
    this.dtg_UseCoopInfoList.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      var ht = this.dtg_UseCoopInfoList.hitTest(e);
      if ((0 <= ht.row) && (1 == ht.col)) {
        if (!ht.target.className.includes('wj-cell') && !ht.target.className.includes('wj-header') && !ht.target.className.includes('wj-align-center') && !ht.target.className.includes('all-coop-setting-checkbox')) {
          document.getElementById(`cb_use_coop_${ht.row}`).click();
        }
      }
    });
    this.dtg_GoodsAllergenList.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      var ht = this.dtg_GoodsAllergenList.hitTest(e);
      if (0 <= ht.row && ht.target.className !== 'wj-cell wj-header wj-align-center') {
        switch (ht.col) {
          case 0:
            document.getElementById(`cb_goods_algen_1_${ht.row}`).click();
            break;
          case 1:
            document.getElementById(`cb_goods_algen_2_${ht.row}`).click();
            break;
        }
      }
    });
    this.dtg_GoodsEcologyList.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      var ht = this.dtg_GoodsEcologyList.hitTest(e);
      if ((0 <= ht.row) && (0 == ht.col) && ht.target.className !== 'wj-cell wj-header wj-align-center') {
        document.getElementById(`cb_goods_eco_${ht.row}`).click();
      }
    });
    this.dtg_GoodsGWStopList.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      var ht = this.dtg_GoodsGWStopList.hitTest(e);
      if ((0 <= ht.row) && (0 == ht.col) && ht.target.className !== 'wj-cell wj-header wj-align-center') {
        document.getElementById(`cb_goods_gw_stop_${ht.row}`).click();
      }
    });
    this.dtg_ContainPackingList.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      var ht = this.dtg_ContainPackingList.hitTest(e);
      if ((0 <= ht.row) && (0 == ht.col) && ht.target.className !== 'wj-cell wj-header wj-align-center') {
        document.getElementById(`cb_contain_pack_${ht.row}`).click();
      }
    });

  }


  eventListenerSetting() {
    /**
     * 編集済みチェック用に、イベントを割り当て
     */
    const changeObj: Array<any> = [
      // pCode情報エリア
      'txti_GuideGoodsName', 'txti_GuideStandardName',
      'txti_DeliveryGoodsNameKanji', 'txti_DeliveryGoodsNameKana',
      'txti_DeliveryStandardNameKanji', 'txti_DeliveryStandardNameKana', 'txti_OcrGoodsName',

      'txti_ConsumeTaxDivRate', 'txti_UnitPriceCoefficient', 'txti_UnitPriceUnit',
      'txti_ConsumeTerm', 'txti_ConsumeByDate', 'txti_SeasonConsumeTerm', 'txti_LeaveConsumeTerm',
      'txti_RelationPcodeOld', 'txti_RelationPcodeNew', 'txti_AlocoholType', 'txti_ContainerCapacity',

      'txta_TextInfo1', 'txta_TextInfo2', 'txta_TextInfo3', 'txta_TextInfo4', 'txta_TextInfo5',
      'txta_TextInfo6', 'txta_TextInfo7', 'txta_TextInfo8', 'txta_TextInfo9',
      'txti_ArrivalGoodsTemp', 'txti_ArrivalAdminDays', 'txti_ListingGoodsName',
      'txti_LicencedNo', 'txta_LicencedDescription',
      'txta_TextInfo10','txta_TextInfo11','txta_TextInfo12','txta_TextInfo13','txta_TextInfo14',
      'txta_TextInfo15','txta_TextInfo16','txta_TextInfo17','txta_TextInfo18','txta_TextInfo19',
      'txti_PageTitle','txta_PageUrl','txta_MediumText',

      // アイテム情報エリア
      'txti_JanCode', 'txti_FcmcFee', 'txti_InstallmentTimes', 'txti_PdPilingUpDays', 'txti_ItfCode',
      'txti_MakerPrice', 'txti_OrderClientCode', 'txti_OrderClientName', 'txti_PayeeClientCode', 'txti_PayeeClientName',
      'txti_FixContainNum', 'txti_SetQuantity',
      'txti_SupplyPriceCoefficient', 'txti_SupplyPriceSpecial1', 'txti_SupplyPriceSpecial2', 'txti_CostPricecoefficient',
      'txti_CostPriceSpecial1', 'txti_CostPriceSpecial2', 'txti_BundlePrice',

      'txti_EbaseSpecCode', 'txti_RegistCatalogRound', 'txti_MakerName',
      'txti_PeaceSizeLength', 'txti_PeaceSizeWidth', 'txti_PeaceSizeHight', 'txti_PeaceWeight',
      'txti_CaseSizeLength', 'txti_CaseSizeWidth', 'txti_CaseSizeHight', 'txti_CaseWeight',

      'txta_StringValue1', 'txta_StringValue2', 'txta_StringValue3',
      'txta_StringValue5', 'txta_StringValue6',

      'rdb_AdmitStatus0', 'rdb_AdmitStatus1', 'rdb_AdmitStatus2',
      'rdb_Ecology1', 'rdb_Ecology2',
      'chk_PackMaterialShowFlg', 'chk_DummyGoods', 'chk_EndFlag', 'chk_SeasonConsumeDiv', 'chk_eFriendsSendDiv',
      'chk_MakerNamePublishType', 'chk_JanCodeDiv',

      // pCode情報エリア
      'cmb_BuyerCode', 'cmb_ClassCode', 'cmb_LargeClassCode',
      'cmb_MiddleClassCode', 'cmb_SmallClassCodeList','cmb_CategoryCode',

      'cmb_ConsumeTaxDivList', 'cmb_CycleTerm', 'cmb_EdlpDiv', 'cmb_UnitPriceDiv',
      'cmb_GuideTempZoneDiv', 'cmb_BlindDiv', 'cmb_LiquorCode', 'cmb_ContainerForm',
      'cmb_EcNonDispDiv',
      'cmb_StinkGoodsDivList', 'cmb_SetDivList', 'cmb_CaseSupplyDivList',
      'cmb_LongKeepDivList', 'cmb_AssortTempdivList', 'cmb_ArrivalAreaDivList',
      'cmb_DutiesFormDailyDivList',
      'cmb_FragileFlgList',
      // アイテム情報エリア
      'cmb_ItemCode',
      'cmb_BrandType', 'cmb_SpecialOrderTypeList', 'cmb_StockTypeList',
      'cmb_OrderUnitType', 'cmb_PriceType', 'cmb_GeneRecombinationDiv', 'cmb_AllergenTargetType',

      // 日付情報エリア
      'dtf_AppkyTermStart', 'dtf_AppkyTermEnd', 'dtf_SeasonConsumeTermFrom', 'dtf_SeasonConsumeTermTo', 'dtf_SpecApplyDate'
    ];
    for (let i = Number(0); i < changeObj.length; i++) {
      document.getElementById(changeObj[i]).addEventListener('change', () => this.eventEditHandler());
    }
  }

  /**
 * メニュー初期化処理
 *
 * @private
 * @memberof KYMW1100Component
 */
  private initMenuBar(): void {
    // ［ファイル］メニューを作成します
    const menuFile = new FMenu('#menuFile', {
      header: 'ファイル',
      displayMemberPath: 'header',
      subItemsPath: 'items',
      selectedValuePath: 'menuID',
      dropDownCssClass: 'menubar-items',
      openOnHover: false,
      isAnimated: true,
      itemsSource: [
        { header: '新規作成', menuID: 'mi_GoodsPCode', enabled: this.kymw1100Model.enabledGoodsPcodeFlg },
        { header: '表示商品をコピー', menuID: 'mi_GoodsCopy', enabled: this.kymw1100Model.enabledGoodsCopyFlg },
        { header: 'eBASE取込（新規のみ）', menuID: 'mi_GoodsSpec', enabled: this.kymw1100Model.enabledGoodsSpecFlg },
        { header: 'eBASE取込（新規＋更新）', menuID: 'mi_EBaseImport', enabled: this.kymw1100Model.enabledEBaseImportFlg },
      ],
      command: this.getFormatMenuCommand(),
      // イベント設定
      itemClicked: () => {
        this.eventMenuBarHandler(menuFile);
      }
    });

    // ［コープ商品URL取込］メニューを作成します
    const menuCoopGoodsUrl = new FMenu('#menuCoopGoodsUrl', {
      header: 'コープ商品URL取込',
      displayMemberPath: 'header',
      subItemsPath: 'items',
      selectedValuePath: 'menuID',
      dropDownCssClass: 'menubar-items',
      openOnHover: false,
      isAnimated: true,
      itemsSource: [
        { header: '食品', menuID: 'mi_Foods', enabled: this.kymw1100Model.enabledFoodsFlg },
        { header: '日用品', menuID: 'mi_Household', enabled: this.kymw1100Model.enabledHouseholdFlg },
        { header: '化粧品', menuID: 'mi_Cosmetics', enabled: this.kymw1100Model.enabledCosmeticsFlg },
      ],
      command: this.getFormatMenuCommand(),
      // イベント設定
      itemClicked: () => {
        this.eventMenuBarHandler(menuCoopGoodsUrl);
      }
    });

    // ［編集］メニューを作成します
    const menuDisp = new FMenu('#menuDisp', {
      header: '編集',
      displayMemberPath: 'header',
      subItemsPath: 'items',
      selectedValuePath: 'menuID',
      dropDownCssClass: 'menubar-items',
      openOnHover: false,
      isAnimated: true,
      itemsSource: [
        { header: '削除', menuID: 'mi_GoodsDelete' },
        { header: 'アイテム付替', menuID: 'mi_Goods_KYMW1104' },
      ],
      command: this.getFormatMenuCommand(),
      // イベント設定
      itemClicked: () => {
        this.eventMenuBarHandler(menuDisp);
      }
    });

    this.fmenuService.menus = [menuFile, menuCoopGoodsUrl, menuDisp];
  }

  /**
   * メニュー項目活性・非活性制御
   *
   * @private
   * @returns
   * @memberof KYMW1100Component
   */
  private getFormatMenuCommand(): any {
    return {
      canExecuteCommand: (param) => {
        // 各項目の活性制御
        switch (param.menuID) {
          case 'mi_GoodsPCode':
            return this.kymw1100Model.enabledGoodsPcodeFlg;
          case 'mi_GoodsCopy':
            return this.kymw1100Model.enabledGoodsCopyFlg;
          case 'mi_GoodsSpec':
            return this.kymw1100Model.enabledGoodsSpecFlg;
          case 'mi_EBaseImport':
            return this.kymw1100Model.enabledEBaseImportFlg;
          case 'mi_GoodsDelete':
            return this.kymw1100Model.enabledGoodsDeleteFlg;
          case 'mi_Goods_KYMW1104':
            return this.kymw1100Model.enabledGoodsKYMW1104Flg;
          case 'mi_Foods':
            return this.kymw1100Model.enabledFoodsFlg;
          case 'mi_Household':
            return this.kymw1100Model.enabledHouseholdFlg;
          case 'mi_Cosmetics':
            return this.kymw1100Model.enabledCosmeticsFlg;
          default:
            return true;
        }
      }
    };
  }

  /**
   * メニュー項目活性・非活性制御
   *
   * @private
   * @returns
   * @memberof KYMW1100Component
   */
  private getFormatContextMenuCommand(): any {
    return {
      canExecuteCommand: (param) => {
        // 各項目の活性制御
        return (param.enabled === false) ? false : true;
      }
    };
  }

  canDeactivate(): CanDeactivateType {
    const result = new Subject<boolean>();
    this.kymw1100Model.initPhase = false;

    // 「閲覧モードではない」かつ「排他失敗(他ユーザがロック)モードではない」かつ「内容が変更されている」時は確認メッセージを表示
    if (!this.isDispOnlyModeOrLockMode() && this.editFlag) {
      this.dialogService.openAlertGetMessage(
        'Q0107', ['商品情報'],
        (closeDetail: any): void => {
          if (closeDetail === PlessAlert.Yes) {
            this.doClose();
            result.next(true);
          }
          else {
            result.next(false);
          }
        });
      return result;
    }
    else {
      this.doClose();
      return true;
    }
  }

  /**
   * 「終了」実行
   */
  public doClose(): void {
    // ロック処理が成功したPCodeに関して解除処理を行う。
    if (!PlessViewUtilsSub.isEmpty(this.successPCode)) {
      // ロックが成功したPCodeと検索したPCodeと異なった場合商品解除を行う。
      if (this.successPCode === this.searchPCode) {
        super.LockUtilForGoods('RELEASE', this.successPCode, null, null, null, null, false);
      }
    }
  }

  /** タブキーによるフォーカス移動（タブの最後の項目→次のタブ先頭） */
  public nextFocus(event: any): void {
    let nextFlag = true;

    if (event.keyCode === 9 && !event.shiftKey) {
      // 左側タブ
      if (event.target.id === 'txti_ContainerCapacity') {
        // 基本→マーク
        this.tab_pCode.selectedIndex = 1;
      } else if (event.target.id === 'dtg_SelectedMark') {
        // マーク→付加
        this.tab_pCode.selectedIndex = 2;
        // 付加→発注
      } else if ((event.target.id === 'txta_TextInfo7_sub' && this.lnb_TextInfo9.nativeElement.disabled)
        || event.target.id === 'lnb_TextInfo9') {
        this.tab_pCode.selectedIndex = 3;
      } else if (event.target.id === 'cmb_FragileFlgList_sub') {
        // 発注→表組
        this.tab_pCode.selectedIndex = 4;
      } else if (event.target.id === 'dtg_ListingList') {
        // 表組タブ→商品DNAタブ
        this.tab_pCode.selectedIndex = 5;
      } else if (event.target.id === 'dtg_DnaInfoList') {
        // 商品DNAタブ→保健機能タブ
        this.tab_pCode.selectedIndex = 6;

        // 右側タブ
      } else if (event.target.id === 'txti_SetQuantity') {
        // アイテム→利用生協
        this.tab_item.selectedIndex = 1;
      } else if (this.getFuncPermission() === '2' && event.target.id === 'btn_SupplyPrice'
        || this.getFuncPermission() !== '2' && event.target.id === 'txti_BundlePrice') {
        // 利用生協→仕様書１
        this.tab_item.selectedIndex = 2;
      } else if (event.target.id === 'txta_StringValue6_sub') {
        // 仕様書１→仕様書２
        this.tab_item.selectedIndex = 3;
      } else if (event.target.id === 'dtg_GoodsAllergenList') {
        // 仕様書２→栄養成分
        this.tab_item.selectedIndex = 4;
      } else if (event.target.id === 'chk_HasMultiNutrientInfo_sub') {
        if (this.kymw1100Model.hasMultiNutrientInfo) {
          // 栄養成分→複数栄養成分
          this.tab_item.selectedIndex = 5;
        } else {
          // 栄養成分→環境関連
          this.tab_item.selectedIndex = 6;
        }
        // 複数栄養成分→環境関連
      } else if (event.target.id === 'dtg_NutrientDetailListMulti') {
        // 商品DNAタブ→保健機能タブ
        this.tab_item.selectedIndex = 6;
      } else {
        // タブ遷移をしたら本来のタブ移動処理をおこなう
        nextFlag = false;
      }

      if (event.shiftKey && event.target.id === 'txti_BundlePrice') {
        const kymw1100component = this;
        setTimeout(() => {
          kymw1100component.txti_CostPriceSpecial2.nativeElement.focus();
        }, 100);
      }

      // タブ遷移をしたら本来のタブ移動処理はキャンセルとする
      if (nextFlag) {
        // 後続のデフォルトイベントをキャンセル
        event.preventDefault();
      }
    }
  }

  /**
   * 複数栄養成分ありチェックボックスのクリック時に呼び出されるイベントハンドラ
   * @param event
   *
   */
  public eventHasMultiNutrientInfo_CLICKHandler(): void {
    if (this.kymw1100Model.hasMultiNutrientInfo) {
      this.tab_item.selectedIndex = 5;
      this.cnv_MultiNutrientTab.nativeElement.focus();

    } else {
      if (!PlessViewUtilsSub.isEmptyArray(this.kymw1100Model.nutrientUnitListMulti)) {
        // 削除確認メッセージを表示
        this.dialogService.openAlertGetMessage('Q0153', ['複数栄養成分情報'],
          (closeDetail: any) => {
            if (closeDetail === PlessAlert.Yes) {
              this.kymw1100Model.hasMultiNutrientInfo = false;
              this.removeAllNutrientInfoListMulti();
            } else {
              this.kymw1100Model.hasMultiNutrientInfo = true;
            }
          }
        );
      }
    }
  }

  /**
   * 選択された項目に対応する機能を呼び出す(ひとつだけ)
   *
   * @param event 選択時イベント
   */
  public eventMenuBarHandler(menu: FMenu): void {
    this.kymw1100Model.initPhase = false;
    if (menu === null) {
      return;
    }
    switch (String(menu.selectedItem.menuID)) {
      case 'mi_GoodsPCode':
        // 新規作成ボタンのイベントを呼び出す
        this.eventGoodsPCode_CLICKHandler();
        break;
      case 'mi_GoodsCopy':
        // コピーボタンのイベントを呼び出す
        this.eventCopy_CLICKHandler();
        break;
      case 'mi_GoodsSpec':
        // eBASE取込（新規のみ）ボタンのイベントを呼び出す
        this.eventFileSelectHandler();
        break;
      case 'mi_EBaseImport':
        // eBASE取込（新規＋更新）ボタンのイベントを呼び出す
        this.eventEBaseImportSelectHandler();
        break;
      case 'mi_GoodsDelete':
        // 削除ボタンのイベントを呼び出す
        this.eventDelete_CLICKHandler();
        break;
      case 'mi_Goods_KYMW1104':
        // アイテム付換画面を呼び出す
        if (this.kymw1104InputVO === null) {
          this.kymw1104InputVO = new KYMW1104InputModel();
        }

        this.kymw1104InputVO.pCode = this.kymw1100Model.pCode;
        this.kymw1104InputVO.guideGoodsName = this.kymw1100Model.guideGoodsName;
        this.kymw1104InputVO.guideStandardName = this.kymw1100Model.guideStandardName;
        this.kymw1104InputVO.goodsMasterEditFlag = this.editFlag;

        const componentRef = this.dialogService.openModal(KYMW1104Component);
        const instance = componentRef.componentInstance as KYMW1104Component;
        instance.parent = this;
        instance.setInterfaceParam(this.kymw1104InputVO);
        instance.setKYMW1104Parameter = (outputVO: KYMW1104OutputModel) => this.setKYMW1104Parameter(outputVO);
        instance.closeFunction = () => {
          componentRef.close();
        };
        break;
        case 'mi_Foods':
          // コープ商品URL取込（食品）ボタンのイベントを呼び出す
          this.eventCoopGoodsUrlFoodsHandler();
          break;
        case 'mi_Household':
          // コープ商品URL取込（日用品）ボタンのイベントを呼び出す
          this.eventCoopGoodsUrlHouseholdHandler();
          break;
        case 'mi_Cosmetics':
          // コープ商品URL取込（化粧品）ボタンのイベントを呼び出す
          this.eventCoopGoodsUrlCosmeticsHandler();
          break;
      }
  }

  /**
   * アイテム付換処理
   *
   * @param event 選択時イベント
   */
  public setKYMW1104Parameter(outputVO: KYMW1104OutputModel): void {
    // setKYMW1104Parameterが呼び出したら全項目を再表示する。
    this.getGoodsBaseService.execute(this.kymw1100Model, this.kymw1100Model.pCode);
  }

  /**
     * 商品仕様取込処理
     *
     * @param event 選択時イベント
     */
  public eventFileSelectHandler(): void {
    if (!this.isDispOnlyModeOrLockMode() && this.editFlag) {
      this.dialogService.openAlertGetMessage('Q0107', ['商品情報'], (closeEvent: any) => {
        if (closeEvent === PlessAlert.Yes) {
          this.fileSelectHandler();
        }
      })
    } else {
      this.fileSelectHandler()
    }
  }

  /** 商品仕様取込 */
  fileSelectHandler(): void {
    // ファイル選択ダイアログを開く
    // ファイルはmultipleの場合を考慮して配列で保持、１件のみならselectedFiles[0]で使用
    this.fileUploadService.upload((selectedFiles: File[]) => {
      // 重複時登録確認ダイアログの表示
      this.dialogService.openAlertGetMessage('Q0148', ['eBASE訂正元仕様書NO'],
        (closeEvent: any) => {
          let overlapChkFlag;
          // ダイアログ選択結果をチェック
          if (closeEvent === PlessAlert.Yes) {
            // 重複時登録するを設定
            overlapChkFlag = '1';
          } else {
            // 重複時登録しないを設定
            overlapChkFlag = '0';
          }

          // 商品仕様取込を実行
          this.registEBaseDataService.execute(this.kymw1100Model, selectedFiles[0], overlapChkFlag);
        });
    }, [FileAccept.CSV]);
  }

  /** eBASE取込（新規＋更新）処理 */
  eventEBaseImportSelectHandler(): void {
    if (!this.isDispOnlyModeOrLockMode() && this.editFlag) {
      this.dialogService.openAlertGetMessage('Q0107', ['商品情報'], (closeEvent: any) => {
        if (closeEvent === PlessAlert.Yes) {
          this.eBaseImportSelectHandler();
        }
      })
    } else {
      this.eBaseImportSelectHandler()
    }
  }

  /** eBASEファイル取込 */
  eBaseImportSelectHandler(): void {
    // ファイル選択ダイアログを開く
    // ファイルはmultipleの場合を考慮して配列で保持、１件のみならselectedFiles[0]で使用
    this.fileUploadService.upload((selectedFiles: File[]) => {
      const eBaseImportFile = selectedFiles[0];
      // eBASE取込データ作成API実行
      this.createEBaseDataService.execute(this.kymw1100Model, eBaseImportFile, (response) => {        
        let newGoodsNum = 0;
        let updateSingleGoodsNum = 0;
        const selectableEBaseGoodsList = [] as SelectableEBaseGoodsInfo[]; // 取込先選択対象
        const eBaseImportGoodsList = [] as EBaseImportGoodsInfo[]; // 一括取込対象
        for (const info of response.EbaseListGoodsInfo) {
          if (info.ProcessFlag === "2") {
            selectableEBaseGoodsList.push({
              eBaseSpecCode: info.CaEbaseSpecCode,
              janCode: info.JanCode,
              goodsName: info.GuideGoodsName,
              standardName: info.GuideStandardName,
              containNum: Number(info.FixContainNum),
              makerName: info.MakerName,
            });
          } else {
            if (info.ProcessFlag === "1") {
              updateSingleGoodsNum++;
            } else {
              newGoodsNum++;
            }

            eBaseImportGoodsList.push({
              JanCode: info.JanCode,
              LinkedPcode: info.LinkedPcode,
              LinkedItemCode: info.LinkedItemCode,
              ProcessFlag: info.ProcessFlag,
            });
          }
        }

        if (selectableEBaseGoodsList.length > 0) {
          // 取込先選択件数が1件以上の場合、取引先選択のダイアログ表示
          const input: KYMW1108InputModel = {
            processFlag: "2",
            newGoodsNum,           // 新規登録件数
            updateSingleGoodsNum,  // 更新対象1件件数
            selectableGoodsNum: selectableEBaseGoodsList.length, // 取込先選択件数
            selectableEBaseGoodsList,
          };
    
          // 商品仕様取込画面（取引先選択ダイアログ）をモーダルで表示
          const componentRef = this.dialogService.openModal(KYMW1108Component);
          const instance = componentRef.componentInstance as KYMW1108Component;
          instance.setInterfaceParam(input);
          // ダイアログ内「取込」実行時処理
          instance.setKYMW1108Parameter = (output: KYMW1108OutputModel) => {
            for (const data of output.selectedGoodsInfoList) {
              eBaseImportGoodsList.push({
                JanCode: data.janCode,
                LinkedPcode: data.pCode,
                LinkedItemCode: data.itemCode,
                ProcessFlag: "2", // 固定「2:取込先選択」
              });
            }
            // eBASE一括取込API実行
            this.updateEBaseDataService.execute(this.kymw1100Model, eBaseImportGoodsList, eBaseImportFile, () => {
              // 検索結果の表示一覧を更新（候補リストを 1ページ目で再取得）
              this.getCandidateGoodsList(1);
              // 商品マスタメンテナンスタブの表示商品も再検索
              if (this.searchPCode) {
                this.setCandidateGoodsListParameter(this.searchPCode);
              }
            });

            componentRef.close(); // ダイアログを閉じる
          };
          // ダイアログが閉じられる際の処理
          instance.parent = this;
          instance.closeFunction = (isCanceled: boolean) => {
            componentRef.close();
            if (isCanceled) {
              // エラーメッセージ「取込先商品選択がキャンセルされたため、eBASE取込を中止しました。」
              this.dialogService.openAlertGetMessage('E0590');
            }
          };
        } else {
          // 取込先選択件数が0件以上の場合、新規登録 & 更新対象1件 のデータのみを対象する
          // eBASE一括取込API実行
          this.updateEBaseDataService.execute(this.kymw1100Model, eBaseImportGoodsList, eBaseImportFile, () => {
            // 検索結果の表示一覧を更新（候補リストを 1ページ目で再取得）
            this.getCandidateGoodsList(1);
            // 商品マスタメンテナンスタブの表示商品も再検索
            if (this.searchPCode) {
              this.setCandidateGoodsListParameter(this.searchPCode);
            }
          });
        }
      });
    }, [FileAccept.CSV]);
  }

  /**
   * 商品仕様取込成功した時にログの画面を呼び出す
   */
  public eventKYMW0D00(inputVO: KYMW0D00InputModel): void {
    // ログ画面(モーダル)を表示する。
    const componentRef = this.dialogService.openModal(KYMW0D00Component, this.viewContainerRef);
    const instance = componentRef.componentInstance as KYMW0D00Component;
    instance.parent = this;
    instance.setInterfaceParam(inputVO);
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 新規作成処理
   *
   * @param event 選択時イベント
   */
  public eventGoodsPCode_CLICKHandler(): void {
    this.kymw1100Model.initPhase = false;
    // ロック処理が成功したPCodeに関して解除処理を行う。
    if (!PlessViewUtilsSub.isEmpty(this.successPCode)) {
      // ロックが成功したPCodeと検索したPCodeと異なった場合商品解除を行う。
      if (this.successPCode === this.searchPCode) {
        super.LockUtilForGoods('RELEASE', this.successPCode, null, null, null, null, false);
      }
    }

    if (!this.isDispOnlyModeOrLockMode() && this.editFlag) {
      this.dialogService.openAlertGetMessage('Q0107', ['商品情報'],
        (closeDetail: any): void => {
          if (closeDetail === PlessAlert.Yes) {
            // 商品マスタの初期表示情報を取得する。
            this.setWindowVisible('NEW');
          }
        });
    } else {
      // 商品マスタの初期表示情報を取得する。
      // 編集はしていないので、そのまま新規
      this.setWindowVisible('NEW');
    }
  }

  public eventSearch_CLICKHandler(): void {
    this.kymw1100Model.initPhase = false;
    if (this.kymw0300InputVO === null) {
      this.kymw0300InputVO = new KYMW0300InputModel();
    }
    // 企画関連条件を表示しない（企画検索フラグ:0）
    this.kymw0300InputVO.catalogSearchFlg = 0;

    // 商品検索画面(モーダル)を表示する。
    const componentRef = this.dialogService.openModal(KYMW0300Component);
    const instance = componentRef.componentInstance as KYMW0300Component;
    instance.parent = this;
    instance.setInterfaceParam(this.kymw0300InputVO);
    instance.setKYMW0300Parameter = (outputVO: KYMW0300OutputModel) => this.setKYMW0300Parameter(outputVO);

    instance.closeFunction = ()=>{
      componentRef.close();
    }

  }

  public setKYMW0300Parameter(outputVO: KYMW0300OutputModel): void {
    // 前回の検索条件を保持
    this.kymw0300InputVO = this.kymw0300Model.getKYMW0300SearchHistory(outputVO);

    // 候補リストを取得(1ページ目)
    this.getCandidateGoodsList(1);
  }

  /**
   * データグリッド行の背景色設定
   *
   * @param grid 処理対象データグリッド
   */
  public setColorPattern(): void {
    const grid = this.dtg_CandidateGoodsList;
    const selectedIndexList = grid.selectedRows.map((row) => row.index);

    for (let loop = Number(0); loop < grid.rows.length; loop++) {
      // 状態のチェック(0：通常、1：他のユーザーが使用、2：取扱終了日が指定されている)
      if (grid.rows[loop].dataItem.DataKbn === '1') {                        // 「1：他のユーザーが使用」の場合
        if (selectedIndexList.indexOf(loop) !== -1) {
          grid.rows[loop].cssClass = '';
        } else {
          grid.rows[loop].cssClass = 'lbl_using';
        }
      } else if (grid.rows[loop].dataItem.DataKbn === '2') {                 // 「2：取扱終了日が指定されている」の場合
        if (selectedIndexList.indexOf(loop) !== -1) {
          grid.rows[loop].cssClass = '';
        } else {
          grid.rows[loop].cssClass = 'lbl_expire';
        }
      } else {                                                                  // 上記以外の場合
        if (selectedIndexList.indexOf(loop) !== -1) {
          grid.rows[loop].cssClass = '';
        } else {
          grid.rows[loop].cssClass = 'lbl_usually';
        }
      }
    }
  }

  /**
   * 前へをクリックした時に呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   */
  public eventBackHandler(event: Event): void {
    // 現在のページ番号-1を設定し、リストを取得
    const pageNo = (this.kymw1100Model.pageNo < 1) ? 1 : this.kymw1100Model.pageNo - 1;
    this.getCandidateGoodsList(pageNo);
  }

  /**
   * 次へをクリックした時に呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   */
  public eventNextHandler(): void {
    // 現在のページ番号+1を設定し、リストを取得
    const pageNo = (this.kymw1100Model.pageNo < 1) ? 1 : this.kymw1100Model.pageNo + 1;
    this.getCandidateGoodsList(pageNo);
  }

  /**
   * データグリッドヘッダークリックした時に呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   */
  public eventCandidateGoodsListHandler(e: MouseEvent, grid: FlexGrid): void {

    // 後続のデフォルトイベントをキャンセル
    e.preventDefault();

    // データが0件の場合は何もしない
    if (PlessViewUtilsSub.isEmptyArray(this.kymw1100Model.candidateGoodsList)) {
      return;
    }

    // ヘッダーがクリックされた場合はソート処理を実施
    if (grid.hitTest(e.pageX, e.pageY).cellType === CellType.ColumnHeader) {

      if (!DataGridUtil.isSortable(e, grid)) {
        return;
      }

      // データグリッドのヘッダテキストを描画し、ASCとDESCをVOに設定
      // クリックされたデータグリッドの列から、DBの物理項目を取得
      this.kymw1100Model.sortKey = this.tableName[this.dtg_CandidateGoodsList.columns[grid.hitTest(e).col].binding];
      // 取得できなかったら何もしない
      if (!this.kymw1100Model.sortKey) {
        return;
      }

      this.kymw1100Model.orderKey = DataGridUtil.switchHeaderText(e, grid);

      // ページカウンタの初期化
      this.kymw1100Model.pageNo = 1;
      // １ページ目を検索
      this.getCandidateGoodsList(1);
    } else {
      this.setColorPattern();
    }
  }

  /**
   * 候補リストを取得する
   *
   * @private
   * @param {number} pageNo
   * @memberof KYMW0301Component
   */
  private getCandidateGoodsList(pageNo: number): void {
    this.kymw1100Model.pageNo = pageNo;

    // 検索条件を設定
    const searchVo: CandidateGoodsSearchConditionModel = new CandidateGoodsSearchConditionModel();
    searchVo.pageNo = pageNo;
    searchVo.pcode = this.kymw0300InputVO.pcode;
    searchVo.itemCode = this.kymw0300InputVO.itemCode;
    searchVo.janCode = this.kymw0300InputVO.janCode;
    searchVo.makerName = this.kymw0300InputVO.makerName;
    searchVo.guideGoodsNameList = this.kymw0300InputVO.guideGoodsNameList;
    searchVo.guideStandardNameList = this.kymw0300InputVO.guideStandardNameList;
    searchVo.tagIdList = this.kymw0300InputVO.tagId;
    searchVo.tagSearchType = this.kymw0300InputVO.tagSearchType;
    searchVo.goodsMarkCodeList = this.kymw0300InputVO.goodsMark;
    searchVo.goodsMarkSearchType = this.kymw0300InputVO.goodsMarkSearchType;
    searchVo.dataKbnFlg = this.kymw0300InputVO.dataKbnFlg;
    searchVo.goodsDiv = this.kymw0300InputVO.goodsDiv;
    searchVo.coopCodeList = this.kymw0300InputVO.coopCodeList;
    searchVo.buyerCode = this.kymw0300InputVO.buyerCode;
    searchVo.admitStatus = this.kymw0300InputVO.admitStatus;
    searchVo.registDateFrom = PlessViewUtilsSub.nullToBlank(this.kymw0300InputVO.registDateFrom);
    searchVo.registDateTo = PlessViewUtilsSub.nullToBlank(this.kymw0300InputVO.registDateTo);
    searchVo.updateDateFrom = PlessViewUtilsSub.nullToBlank(this.kymw0300InputVO.updateDateFrom);
    searchVo.updateDateTo = PlessViewUtilsSub.nullToBlank(this.kymw0300InputVO.updateDateTo);
    searchVo.classCode = this.kymw0300InputVO.classCode;
    searchVo.middleClassCode = this.kymw0300InputVO.middleClassCode;
    searchVo.smallClassCode = this.kymw0300InputVO.smallClassCode;
    searchVo.ordrClientCode = this.kymw0300InputVO.ordrClientCode;
    searchVo.ordrClientKanji = this.kymw0300InputVO.ordrClientKanji;
    searchVo.payeeClientCode = this.kymw0300InputVO.payeeClientCode;
    searchVo.payeeClientKanji = this.kymw0300InputVO.payeeClientKanji;
    searchVo.dutiesList = this.kymw0300InputVO.duties;
    searchVo.pcodeList = this.kymw0300InputVO.pcodeList;
    searchVo.itemCodeList = this.kymw0300InputVO.itemCodeList;
    searchVo.sortKey = this.kymw1100Model.sortKey;
    searchVo.orderKey = this.kymw1100Model.orderKey;


    // 検索実行
    this.getCandidateGoodsListService.execute(searchVo, this.kymw1100Model, (data: any) => {
      this.kymw1100Model.updateCandidateGoodsList(data);
      // 複数選択可否の設定
      this.dtg_CandidateGoodsList.selectionMode = SelectionMode.Row;

      this.dtg_CandidateGoodsList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
        // データグリッド行の初期選択無し
        this.dtg_CandidateGoodsList.selection = new CellRange(-1, -1, -1, -1);
        // データグリッド行の背景色設定処理
        this.setColorPattern();
        this.dtg_CandidateGoodsList.focus();

        // kymw1200からの画面遷移時に商品マスタメンテナンスタブを開いた状態としたいとの要望対応
        // 候補リストに表示された商品の一つ目のデータのPコードをコード上で疑似的にクリックし、
        // 商品マスタメンテナンスタブで表示する
        if (this.dispDialog && this.dispDialogOpen) {
          this.dispDialogOpen = false;
          this.dtg_CandidateGoodsList.scrollIntoView(0,0);
          // 一つ目の商品データのPコードのセル情報を取得
          let cell = this.dtg_CandidateGoodsList.cells.getCellElement(0,0);
          // セル内のリンクである'a'タグを取得
          if (cell) {
            let btn = cell.getElementsByTagName('a')[0];
            if (btn) {
              // リンクをクリック
              btn.click();
            }
          }
        }
      });
      // 正常終了時に候補リストタブを表示
      this.tab_KYMW1100.selectedIndex = 0;
    },
    () => {
      // 0件時は候補リストタブを表示、コールバック関数化しservice側で処理する
      this.tab_KYMW1100.selectedIndex = 0;
    });

  }
  public setCandidateGoodsListParameter(pcode: string): void {
    // 選択した商品がなければ以降の処理は行わない。
    if (PlessViewUtilsSub.isEmpty(pcode)) {
      return;
    }

    const pCodeParam: Array<any> = new Array<any>();
    pCodeParam[0] = pcode;

    this.searchPCode = pcode;

    // ロック処理が成功したPCodeに関して解除処理を行う。
    if (!PlessViewUtilsSub.isEmpty(this.successPCode)) {
      // ロックが成功したPCodeと検索したPCodeと異なった場合商品解除を行う。
      if (this.successPCode !== this.searchPCode) {
        super.LockUtilForGoods('RELEASE', this.successPCode,
          () => {
            this.registLock(pCodeParam);
          }, null,
          () => {
            this.registLock(pCodeParam);
          }, null,
          false);
      } else {
        this.registLock(pCodeParam);
      }
    } else {
      this.registLock(pCodeParam);
    }
  }

  /**
   * ロック登録
   */
  private registLock(pCodeParam: Array<any>) {
    // 検索したPCodeのロックイベントを発生する。
    // ロックが失敗した場合は他のところで使用している商品。
    super.LockUtilForGoods('REGIST', this.searchPCode,
      (event: any) => {
        this.successSeachLock(event);
      },
      pCodeParam,
      (event: any) => {
        this.faultSeachLock(event);
      }, null, false);
  }

  /**
   * ロック成功
   */
  public successSeachLock(event: any): void {
    this.successPCode = event[0];
    this.lockNum = '2';
    this.Seach();
  }

  /**
   * ロック失敗
   */
  public faultSeachLock(event: any): void {
    this.successPCode = '';
    this.lockNum = '1';
    this.Seach();
  }

  /**
   * 検索を行う。
   */
  public Seach(): void {
    // 検索ボタンの表示設定。
    this.getGoodsBaseService.execute(this.kymw1100Model, this.searchPCode, (data: any) => {
      if (this.isEmpty(this.kymw1100Model.pCode)) {
        this.tab_KYMW1100.selectedIndex = 0;
      } else {
        this.tab_KYMW1100.selectedIndex = 1;
      }
    });
  }

  /**
   * コピーボタンイベント
   *
   * @param event 選択時イベント
   */
  public eventCopy_CLICKHandler(): void {
    this.kymw1100Model.initPhase = false;
    if (this.editFlag) {
      this.dialogService.openAlertGetMessage('Q0107', ['商品情報'],
        (closeEvent: any) => {
          if (closeEvent === PlessAlert.Yes) {
            // 検索ボタンの表示設定。
            this.CopyJANCode();
          }
        });
    } else {
      this.dialogService.openAlertGetMessage('Q0117', ['商品情報'],
        (closeEvent: any) => {
          if (closeEvent === PlessAlert.Yes) {
            // 検索ボタンの表示設定。
            this.CopyJANCode();
          }
        });
    }
  }

  /**
   * コピーボタン押した時にJANCodeをコピーするかどうか判断する
   */
  public CopyJANCode(): void {
    this.dialogService.openAlertGetMessage('Q0117', ['JANコード'],
      (closeEvent: any) => {
        if (closeEvent === PlessAlert.Yes) {
          const vo: Array<any> = new Array<any>();
          // 検索ボタンの表示設定。
          vo[0] = this.kymw1100Model.pCode;
          vo[1] = this.kymw1100Model.janCode;
          vo[2] = '1';								// eBASE仕様書情報コピー判定フラグ「1(コピーする)」「0(コピーしない)」

          this.registGoodsBaseCopyService.execute(this.kymw1100Model, vo);
        } else {
          const vo: Array<any> = new Array<any>();
          vo[0] = this.kymw1100Model.pCode;
          vo[1] = '';
          vo[2] = '1';							// eBASE仕様書情報コピー判定フラグ「1(コピーする)」「0(コピーしない)」
          this.registGoodsBaseCopyService.execute(this.kymw1100Model, vo);
        }
      });
  }

  /**
   * コピーロックイベント
   *
   * @param event 選択時イベント
   */
  public eventLockCopy(): void {
    const pCodeParam: Array<any> = new Array<any>();
    pCodeParam[0] = this.kymw1100Model.pCode;

    this.searchPCode = pCodeParam[0];

    // ロック処理が成功したPCodeに関して解除処理を行う。
    if (!PlessViewUtilsSub.isEmpty(this.successPCode)) {
      // ロックが成功したPCodeと検索したPCodeと異なった場合商品解除を行う。
      if (this.successPCode !== this.searchPCode) {
        super.LockUtilForGoods('RELEASE', this.successPCode,
          () => {
            this.registLockCopy(pCodeParam);
          }, null,
          () => {
            this.registLockCopy(pCodeParam);
          }, null,
          false);
      } else {
        this.registLockCopy(pCodeParam);
      }
    } else {
      this.registLockCopy(pCodeParam);
    }
  }

  /**
   * コピー時のロック登録
   *
   * @param pCodeParam PCODE
   */
  private registLockCopy(pCodeParam: Array<any>) {
    // コピーしたPCodeのロックイベントを発生する。
    // ロックが失敗した場合は他のところで使用している商品。
    super.LockUtilForGoods('REGIST', this.searchPCode, (event: any) => this.successCopyLock(event),
      pCodeParam, this.faultCopyLock, null, false);
  }

  /**
   * ロック成功
   */
  public successCopyLock(event: any): void {
    this.successPCode = event[0];
    this.lockNum = '2';

    // ロック成功した時のボタン制御。
    this.setSeachButton();
  }

  /**
   * ロック失敗
   */
  public faultCopyLock(event: any): void {
    this.successPCode = '';
    this.lockNum = '1';

    // ロック失敗した時のボタン制御。
    this.setSeachButton();
  }

  /**
   * 実績履歴画面呼び出す
   *
   * @param event 選択時イベント
   */
  public eventHistory_CLICKHandler(): void {
    this.kymw1100Model.initPhase = false;
    if (this.kymw0800InputVO === null) {
      this.kymw0800InputVO = new KYMW0800InputModel();
    }

    const pCode: Array<any> = new Array<any>();
    const vo = {
      PCode: PlessViewUtilsSub.escapeXML(this.kymw1100Model.pCode),
      GuideGoodsName: PlessViewUtilsSub.escapeXML(this.kymw1100Model.guideGoodsName),
      GuideStandardName: PlessViewUtilsSub.escapeXML(this.kymw1100Model.guideStandardName)
    };
    pCode.push(vo);

    this.kymw0800InputVO.funcID = 'KYMW1100';
    this.kymw0800InputVO.pCodeList = pCode;

    // 実績履歴画面(モーダル)を表示する。
    const componentRef = this.dialogService.openModal(KYMW0800Component);
    const instance = componentRef.componentInstance as KYMW0800Component;
    instance.parent = this;
    instance.setInterfaceParam(this.kymw0800InputVO);

    instance.closeFunction = ()=>{
      componentRef.close();
    }

  }

  /**
   * 紐付画面呼び出す
   *
   * @param event 選択時イベント
   */
  public eventHimotuke_CLICKHandler(): void {
    this.kymw1100Model.initPhase = false;
    if (this.kymw0500InputVO === null) {
      this.kymw0500InputVO = new KYMW0500InputModel();
    }

    this.kymw0500InputVO.mainPCode = this.kymw1100Model.pCode;
    this.kymw0500InputVO.processDiv = '1';
    this.kymw0500InputVO.editMode = true;

    // 紐付画面を起動
    const componentRef = this.dialogService.openModal(KYMW0500Component);
    const instance = componentRef.componentInstance as KYMW0500Component;
    instance.parent = this;
    instance.setInterfaceParam(this.kymw0500InputVO);
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
     * 出力ボタンイベント
     *
     * @param event 選択時イベント
     */
  public eventStatusOut_CLICKHandler(): void {
    this.kymw1100Model.initPhase = false;
    // 候補リスト出力条件項目を初期設定
    const vo: CandidateGoodsSearchConditionModel = new CandidateGoodsSearchConditionModel;
    // 候補リスト出力条件にPコードを設定
    vo.pcode = this.kymw1100Model.pCode;
    vo.itemCode = <string>'';
    vo.janCode = <string>'';
    vo.makerName = <string>'';
    vo.guideGoodsNameList = new Array<string>();
    vo.guideStandardNameList = new Array<string>();
    vo.tagIdList = new Array<string>();
    vo.tagSearchType = <string>'';
    vo.goodsMarkCodeList = new Array<string>();
    vo.goodsMarkSearchType = <string>'';
    vo.dataKbnFlg = <boolean>true;
    vo.goodsDiv = <string>'';
    vo.coopCodeList = new Array<string>();
    vo.buyerCode = <string>'';
    vo.admitStatus = <string>'';
    vo.registDateFrom = <string>'';
    vo.registDateTo = <string>'';
    vo.updateDateFrom = <string>'';
    vo.updateDateTo = <string>'';
    vo.classCode = <string>'';
    vo.middleClassCode = <string>'';
    vo.smallClassCode = <string>'';
    vo.ordrClientCode = <string>'';
    vo.ordrClientKanji = <string>'';
    vo.payeeClientCode = <string>'';
    vo.payeeClientKanji = <string>'';
    vo.dutiesList = new Array<string>();
    vo.pcodeList = new Array<string>();
    vo.itemCodeList = new Array<string>();

    // 商品情報出力先区分(0:候補リスト画面、1:商品マスタ画面)に商品マスタ画面を設定
    vo.goodsInfoOutDiv = '1';

    // 候補リスト取得イベント
    this.makeCandidateGoodsFileService.execute(vo, (data: any) => {

      // ファイル名の設定
      const fileName = '商品情報_' + PlessViewUtilsSub.formatedNowDate('YYYYMMDD') + '.txt';

      this.fileDownloadConfirmService.show(data.FileUrl, fileName);
    });
  }

  /**
   * 削除ボタンイベント
   *
   * @param event 選択時イベント
   */
  public eventDelete_CLICKHandler(): void {
    this.kymw1100Model.initPhase = false;

    if (this.editFlag) {
      this.dialogService.openAlertGetMessage('Q0107', ['商品情報'], (closeEvent: any) => {
        if (closeEvent === PlessAlert.Yes) {
          this.releaseLock();
          this.delete_Click();
        }
      });
    } else {
      this.dialogService.openAlertGetMessage('Q0106', ['商品情報'], (closeEvent: any) => {
        if (closeEvent === PlessAlert.Yes) {
          this.releaseLock();
          this.delete_Click();
        }
      });
    }
  }

  public releaseLock(): void {
    // ロック処理が成功したPCodeに関して解除処理を行う。
    if (!PlessViewUtilsSub.isEmpty(this.successPCode)) {
      // ロックが成功したPCodeと検索したPCodeと異なった場合商品解除を行う。
      if (this.successPCode === this.searchPCode) {
        super.LockUtilForGoods('RELEASE', this.successPCode, null, null, null, null, false);
      }
    }
  }

  /**
   * 「削除」実行
   */
  public delete_Click(): void {
    this.deleteGoodsService.execute(this.kymw1100Model, this.kymw1100Model.pCode);
  }

  /**
   * JanCodeのクリックイベント
   *
   * @param event 選択時イベント
   */
  public eventJanCodeDiv_CLICKHandler(): void {
    // ボタンの制御を行う
    // 「閲覧モードではない」かつ「排他失敗(他ユーザがロック)モードではない」かつ「内容が変更されている」時は確認メッセージを表示
    if (this.isDispOnlyModeOrLockMode() || this.kymw1100Model.janCodeDiv) {
      this.btn_Install.nativeElement.disabled = true;
    } else {
      this.btn_Install.nativeElement.disabled = false;
    }
  }

  /**
   * Itemコピーボタンイベント
   *
   * @param event 選択時イベント
   */
  public eventItemCopy_CLICKHandler(): void {
    if (this.editFlag) {
      this.dialogService.openAlertGetMessage('Q0107', ['アイテムコード'], (closeEvent: any) => {
        if (closeEvent === PlessAlert.Yes) {
          this.ItemCopyJANCode();
        }
      });
    } else {
      this.dialogService.openAlertGetMessage('Q0117', ['アイテム情報'], (closeEvent: any) => {
        if (closeEvent === PlessAlert.Yes) {
          this.ItemCopyJANCode();
        }
      });
    }
  }

  public ItemCopyJANCode(): void {
    this.dialogService.openAlertGetMessage('Q0117', ['JANコード'], (closeEvent: any) => {
      const vo: Array<any> = new Array<any>();
      if (closeEvent === PlessAlert.Yes) {
        vo[0] = this.kymw1100Model.pCode;
        vo[1] = this.kymw1100Model.itemCode;
        vo[2] = this.kymw1100Model.janCode;
        vo[3] = '1';							// eBASE仕様書情報コピー判定フラグ「1(コピーする)」「0(コピーしない)」
        this.registGoodsDetailCopyService.execute(this.kymw1100Model, vo);
      } else {
        vo[0] = this.kymw1100Model.pCode;
        vo[1] = this.kymw1100Model.itemCode;
        vo[2] = '';
        vo[3] = '1';						// eBASE仕様書情報コピー判定フラグ「1(コピーする)」「0(コピーしない)」
        this.registGoodsDetailCopyService.execute(this.kymw1100Model, vo);
      }
    });
  }

  /**
   * Item新規作成ボタンイベント
   *
   * @param event 選択時イベント
   */
  public eventGoodsItemNew_CLICKHandler(): void {
    if (this.editFlag) {

      this.dialogService.openAlertGetMessage('Q0107', ['アイテムコード'], (closeEvent: any) => {
        if (closeEvent === PlessAlert.Yes) {
          // 商品マスタのItem初期情報を取得する。
          this.setWindowVisible('ITEM_NEW');
        }
      });
    } else {
      // 商品マスタのItem初期情報を取得する。
      this.setWindowVisible('ITEM_NEW');
    }
  }

  /**
   * インスト採番ボタンを押した時にJANコードを取得する。
   *
   * @param event 選択時イベント
   */
  public eventInstall_CLICKHandler(): void {
    if ((PlessViewUtilsSub.isEmpty(this.kymw1100Model.janCode))) {
      this.getJANCodeService.execute(this.kymw1100Model);
      this.editFlag = true;
    } else {
      this.dialogService.openAlertGetMessage('E0169', [''], null);
    }
  }

  public setKYMW1103Parameter(outputVO: KYMW1103OutputModel): void {
    // 子画面から情報をもらっているので編集カウントをカウントする。
    this.eventEditHandler();

    // もらった情報を画面で表示する。
    this.cmb_FragileFlgList.setCodeValue(outputVO.fragileFlg);		// 割れ物フラグ
    this.kymw1100Model.ebaseSpecCode = outputVO.eBaseSpecCode;
    this.kymw1100Model.janCode = outputVO.janCode;
    this.kymw1100Model.guideGoodsName = outputVO.guideGooodsName;
    this.kymw1100Model.guideStandardName = outputVO.guideStandardName;
    this.kymw1100Model.fixContainNum = outputVO.fixContainNum;

    this.kymw1100Model.specApplyDate = outputVO.specApplyDate;
    this.cmb_GuideTempZoneDiv.setCodeValue(outputVO.guideTempZoneDiv);
    this.kymw1100Model.consumeTerm = outputVO.consumeTerm;
    this.kymw1100Model.consumeByDate = outputVO.consumeByDate;
    this.kymw1100Model.peaceSizeLength = outputVO.peaceSizeLength;
    this.kymw1100Model.peaceSizeWidth = outputVO.peaceSizeWidth;
    this.kymw1100Model.peaceSizeHight = outputVO.peaceSizeHight;
    this.kymw1100Model.peaceSizeWeight = outputVO.PeaceSizeWeight;
    this.kymw1100Model.caseSizeLength = outputVO.caseSizeLength;
    this.kymw1100Model.caseSizeWidth = outputVO.caseSizeWidth;
    this.kymw1100Model.caseSizeHight = outputVO.caseSizeHight;
    this.kymw1100Model.caseSizeWeight = outputVO.caseSizeWeight;
    this.kymw1100Model.ebaseSpecCodeRev = outputVO.eBASESpecCodeRev;	// eBASE仕様書コード(改訂)
    this.kymw1100Model.makerName = outputVO.makerName;
    this.kymw1100Model.analysisUnit = outputVO.analysisUnit;
    this.kymw1100Model.calorie = outputVO.calorie;
    this.kymw1100Model.protein = outputVO.protein;
    this.kymw1100Model.lipid = outputVO.lipid;
    this.kymw1100Model.carbohydrate = outputVO.carbohydrate;
    this.kymw1100Model.sodium = outputVO.sodium;
    this.cmb_GeneRecombinationDiv.setCodeValue(outputVO.geneRecombinationDiv);
    this.cmb_AssortTempdivList.setCodeValue(outputVO.assortTempDiv);
    this.kymw1100Model.arrivalGoodsTemp = outputVO.arrivalGoodsTemp;
    this.kymw1100Model.unitPriceCoefficient = outputVO.unitPriceCoefficient;
    this.kymw1100Model.unitPriceUnit = outputVO.unitPriceUnit;
    this.cmb_UnitPriceDiv.setCodeValue(outputVO.unitPriceDiv);
    this.cmb_ClassCode.setClassCode(outputVO.classCode);
    this.kymw1100Model.orderClientCode = outputVO.orderClientCode;
    this.kymw1100Model.payeeClientCode = outputVO.pyeeClientCode;

    if (!this.isEmpty(outputVO.makerPrice) && outputVO.makerPrice !== '0') {
      this.kymw1100Model.makerPrice = outputVO.makerPrice;
      this.cmb_PriceType.setCodeValue('1');	// [1：メーカー希望価格]を設定します。
    }

    this.kymw1100Model.deliveryGoodsNameKana = outputVO.deliveryGoodsNameKana;
    this.kymw1100Model.deliveryStandardNameKana = outputVO.deliveryStandardNameKana;
    this.kymw1100Model.registCatalogRound = outputVO.registCatalogRound;
    this.kymw1100Model.ebaseGetDate = outputVO.eBaseGetDate;

    this.kymw1100Model.stringValue1 = outputVO.StringValue1;
    this.kymw1100Model.stringValue2 = outputVO.StringValue2;
    this.kymw1100Model.stringValue3 = outputVO.StringValue3;
    this.kymw1100Model.stringValue4 = outputVO.StringValue4;
    this.kymw1100Model.stringValue5 = outputVO.StringValue5;
    this.kymw1100Model.stringValue6 = outputVO.StringValue6;

    if (outputVO.allergenTargetType != null) {
      const allergenCheck: Array<any> = this.kymw1100Model.allergenList;
      const markList32: Array<any> = new Array<any>();
      for (let i = Number(0); i < allergenCheck.length; i++) {
        const check = this.isExistAllergenDiv(outputVO.allergenTargetType, allergenCheck[i].AllergenCode);
        const componentAllergenCheck = this.isExistAllergenDiv(outputVO.componentAllergenList, allergenCheck[i].AllergenCode);

        const vo = {
          Check: check,
          AllergenCode: PlessViewUtilsSub.escapeXML(allergenCheck[i].AllergenCode.toString()),
          AllergenName: PlessViewUtilsSub.escapeXML(allergenCheck[i].AllergenName.toString()),
          PublishDiv: PlessViewUtilsSub.escapeXML(allergenCheck[i].PublishDiv.toString()),
          ComponentCheck: componentAllergenCheck
        };

        markList32.push(vo);
      }
      // 「アレルゲン調査対象区分」初期値
      this.cmb_AllergenTargetType.setCodeValue('1');
      if (outputVO.allergenTargetType) {
        for (let j = Number(0); j < outputVO.allergenTargetType.length; j++) {
          if ((outputVO.allergenTargetType[j].AllergenCode === '001')
            || (outputVO.allergenTargetType[j].AllergenCode === '002')
            || (outputVO.allergenTargetType[j].AllergenCode === '003')
            || (outputVO.allergenTargetType[j].AllergenCode === '004')
            || (outputVO.allergenTargetType[j].AllergenCode === '005')
            || (outputVO.allergenTargetType[j].AllergenCode === '009')
            || (outputVO.allergenTargetType[j].AllergenCode === '011')) {
            // 「アレルゲン調査対象区分」設定
            this.cmb_AllergenTargetType.setCodeValue('0');
            break;
          }
        }
      }
      this.kymw1100Model.allergenList = markList32;
    }
    this.kymw1100Model.pieceSizeLength = outputVO.peaceSizeLength;      // ピースサイズ(縦)
    this.kymw1100Model.pieceSizeWidth = outputVO.peaceSizeWidth;        // ピースサイズ(横)
    this.kymw1100Model.pieceSizeHeight = outputVO.peaceSizeHight;       // ピースサイズ(高)
    this.kymw1100Model.pieceWeight = outputVO.PeaceSizeWeight;          // ピース重量
    this.kymw1100Model.pieceContainNum = outputVO.pieceContainNum;      // ピース入数
    this.kymw1100Model.pieceJanCode = outputVO.janCode;                 // ピースＪＡＮコード
    this.kymw1100Model.packSizeLength = outputVO.packSizeLength;        // パックサイズ(縦)
    this.kymw1100Model.packSizeWidth = outputVO.packSizeWidth;          // パックサイズ(横)
    this.kymw1100Model.packSizeHeight = outputVO.packSizeHeight;        // パックサイズ(高)
    this.kymw1100Model.packWeight = outputVO.packWeight;                // パック重量
    this.kymw1100Model.packContainNum = outputVO.packContainNum;        // パック入数
    this.kymw1100Model.packJanCode = outputVO.packJanCode;              // パックＪＡＮコード
    this.kymw1100Model.bowlSizeLength = outputVO.bowlSizeLength;        // ボールサイズ(縦)
    this.kymw1100Model.bowlSizeWidth = outputVO.bowlSizeWidth;          // ボールサイズ(横)
    this.kymw1100Model.bowlSizeHeight = outputVO.bowlSizeHeight;        // ボールサイズ(高)
    this.kymw1100Model.bowlWeight = outputVO.bowlWeight;                // ボール重量
    this.kymw1100Model.bowlContainNum = outputVO.bowlContainNum;        // ボール入数
    this.kymw1100Model.bowlJanCode = outputVO.bowlJanCode;              // ボールＪＡＮコード
    this.kymw1100Model.caseSizeLengthEbase = outputVO.caseSizeLength;   // ケースサイズ(縦)
    this.kymw1100Model.caseSizeWidthEbase = outputVO.caseSizeWidth;     // ケースサイズ(横)
    this.kymw1100Model.caseSizeHeightEbase = outputVO.caseSizeHight;    // ケースサイズ(高)
    this.kymw1100Model.caseWeightEbase = outputVO.caseSizeWeight;       // ケース重量
    this.kymw1100Model.caseContainNumEbase = outputVO.caseContainNum;   // ケース入数
    this.kymw1100Model.caseJanCodeEbase = outputVO.caseJanCode;         // ケースＪＡＮコード
    this.kymw1100Model.factoryAddress = outputVO.factoryAddress;        // 工場住所
    this.kymw1100Model.fragileFlg = outputVO.fragileFlg;                // 割れ物フラグ
    this.kymw1100Model.textInfo15 = outputVO.approximateCookingTime	// 調理時間の目安
    this.kymw1100Model.textInfo16 = outputVO.servingsInformation// ○人前情報
    this.kymw1100Model.textInfo17 = outputVO.material // 材料
    this.kymw1100Model.textInfo18 = outputVO.prepareHome // ご家庭で用意いただくもの
    // 仕様反映フラグの設定
    this.eventEbaseDataComplete();

    // eBASEデータボタンの活性制御
    this.setEbaseBtnEnabled();
    this.eventOrderClient_FOCUSOUTHandler();
    this.eventPayeeClient__FOCUSOUTHandler();
  }

  /**
   * Pコードがある時にtrueを返す。
   */
  public isExistAllergenDiv(allergenCodeList: any, allergenDiv: string): boolean {
    if (allergenCodeList) {
      for (let i = Number(0); i < allergenCodeList.length; i++) {
        if (allergenCodeList[i].AllergenCode === allergenDiv) {
          return true;
        }
      }
    }

    return false;
  }

  /**
   * 商品更新処理。
   *
   * ①特殊発注区分が「00：通常」で
   * 部門が「09:ﾊﾟﾝ生菓子」、「11:米」の場合は、確認メッセージを表示する。
   * a)'いいえ'を選択した場合、処理を終了する。
   * @param event 選択時イベント
   */
  public eventStatusUpdate_CLICKHandler(): void {
    this.kymw1100Model.initPhase = false;

    this.kymw1100Model.saveConsumeTaxDivAndRate();
    this.kymw1100Model.savedCoopConsumeTaxPrice();


    // 値変更フラグ（VO）が '0'（変更なし）の場合
    if (!this.editFlag) {
      // エラーメッセージを表示する。（メッセージID：E0162）
      this.dialogService.openAlertGetMessage('E0162');
    } else {
      // 値変更フラグ（VO）が '1'（変更あり）の場合
      // メーカー希望小売価格取込仕様変更 2009.09.07 KIL START
      let makerPrice: number = <number>0;
      try {
        makerPrice = Number(this.kymw1100Model.makerPrice);
      } catch (e) { }
      const priceType: string = this.cmb_PriceType.selectedCodeValue;
      if ((this.isEmpty(priceType) && makerPrice > 0) ||
        (!this.isEmpty(priceType) && makerPrice === 0)
      ) {
        this.dialogService.openAlertGetMessage('E0183', ['メーカー希望小売価格（参考）', '区分と', '価格', '一緒に設定']);
        return;
      }
      // メーカー希望小売価格取込仕様変更 2009.09.07 KIL END

      // 部門が「09:ﾊﾟﾝ生菓子」、「11:米」で、特殊発注区分が「00：通常」の場合はエラー
      if ((PlessViewUtilsSub.trim(this.cmb_ClassCode.selectedClassCode) === '09') ||
        (PlessViewUtilsSub.trim(this.cmb_ClassCode.selectedClassCode) === '11')) {
        if (PlessViewUtilsSub.trim(this.cmb_SpecialOrderTypeList.selectedCodeValue) === '00') {
          this.dialogService.openAlertGetMessage('Q0132', ['部門', '特殊発注区分'],
            (closeEvent: any) => {
              if (closeEvent === PlessAlert.Yes) {
                this.Show_StockType();
              }
            }
          );
        } else {
          this.Show_StockType();
        }
      } else {
        this.Show_StockType();
      }
    }
  }
  /**
   * ②在庫繰越区分が「0:繰越なし」で
   * 発注単位区分が「2:最終日バラ」、「6:4回以降バラ」の場合は、確認メッセージを表示する。
   * a)'いいえ'を選択した場合、処理を終了する。
   */
  public Show_StockType(): void {
    // 各項目値を取得
    const stockType: string = this.cmb_StockTypeList.selectedCodeValue;		// 在庫繰越区分
    const orderUnitType: string = this.cmb_OrderUnitType.selectedCodeValue;		// 発注単位区分

    if ((this.STOCK_TYPE_NONE === stockType && this.ORDER_UNIT_TYPE_BARA_FINAL === orderUnitType)		// 「0:繰越なし」、「2:最終日バラ」
      || (this.STOCK_TYPE_NONE === stockType && this.ORDER_UNIT_TYPE_BARA_AF_4TH === orderUnitType)) {		// 「0:繰越なし」、「6:4回以降バラ」

      // ワーニングメッセージを表示
      this.dialogService.openAlertGetMessage('Q0149', ['在庫繰越区分', '発注単位区分'], (closeEvent: any) => {
        // 項番2231 START 障害管理NO.U01274対応
        if (closeEvent === PlessAlert.Yes) {
          // 項番2231 END 障害管理NO.U01274対応
          this.Show_OrderClientCode();
        }
      });
    } else {
      this.Show_OrderClientCode();
    }
  }
  /**
   *③発注先取引先の取引停止区分が「0：通常」で無い場合、確認メッセージを表示する。
   *ID = Q0122%1 =    '発注先取引先'
   * a)'いいえ'を選択した場合、処理を終了する。
   */
  public Show_OrderClientCode(): void {
    if (!PlessViewUtilsSub.isEmpty(this.kymw1100Model.orderClientCode)) {
      if (this.kymw1100Model.tradeStopDivOrder !== '0') {
        this.dialogService.openAlertGetMessage('Q0122', ['発注先取引先'], (closeEvent: any) => {
          if (closeEvent === PlessAlert.Yes) {
            this.Show_PayeeClientCode();
          }
        });
      } else {
        this.Show_PayeeClientCode();
      }
    } else {
      this.Show_PayeeClientCode();
    }
  }
  /**
   *④支払先取引先の取引停止区分が「0：通常」で無い場合、確認メッセージを表示する。
   * ID = Q0122%1 =    '支払先取引先'
   * a)'いいえ'を選択した場合、処理を終了する。
   */
  public Show_PayeeClientCode(): void {
    if (!PlessViewUtilsSub.isEmpty(this.kymw1100Model.payeeClientCode)) {
      if (this.kymw1100Model.tradeStopDivPayee !== '0') {
        this.dialogService.openAlertGetMessage('Q0122', ['支払先取引先'], (closeEvent: any) => {
          if (closeEvent === PlessAlert.Yes) {
            this.Show_BundlePrice();
          }
        });
      } else {
        this.Show_BundlePrice();
      }
    } else {
      this.Show_BundlePrice();
    }
  }
  /**
   *⑤確定入数＜価格バンドルの場合、確認メッセージを表示する。
   * ID = Q0123
   * a)'いいえ'を選択した場合、処理を終了する。
   */
  public Show_BundlePrice(): void {
    const fixNum = Number(this.kymw1100Model.fixContainNum);
    const bundleNum = Number(this.kymw1100Model.bundlePrice);

    if (!PlessViewUtilsSub.isEmpty(this.kymw1100Model.fixContainNum)
      && !PlessViewUtilsSub.isEmpty(this.kymw1100Model.bundlePrice)) {
      if (fixNum < bundleNum) {
        this.dialogService.openAlertGetMessage('Q0123', null, (closeEvent: any) => {
          if (closeEvent === PlessAlert.Yes) {
            this.Show_SupplyPriceStandard();
          }
        });
      } else {
        this.Show_SupplyPriceStandard();
      }
    } else {
      this.Show_SupplyPriceStandard();
    }
  }

  /**
   *⑥供給価格（通常）≦仕入価格（通常）の確認を行う
   */
  public check_SupplyPriceStandardWitthArray(coopInfoList: Array<any>): number {
    let checkFlag: number = <number>0;

    if (coopInfoList != null) {
      for (let i = Number(0); i < coopInfoList.length; i++) {
        if (coopInfoList[i].Check === true) {
          const supplyPriceStandardTmp = Number(coopInfoList[i].SupplyPriceStandard);
          const consignPriceStandardTmp = Number(coopInfoList[i].ConsignPriceStandard);

          if (supplyPriceStandardTmp === 0 && consignPriceStandardTmp === 0) {
            continue;
          }

          if (supplyPriceStandardTmp <= consignPriceStandardTmp) {
            checkFlag++;
          }
        }
      }
    }

    return checkFlag;
  }

  /**
   *⑥-1 供給価格（通常）≦仕入価格（通常）の場合、確認メッセージを表示する。
   * ID = Q0125%1 =    '供給価格（通常）'　%2 =    '仕入価格（通常）'
   * a)'いいえ'を選択した場合、処理を終了する。
   */
  public Show_SupplyPriceStandard(): void {
    const coopInfoList: Array<any> = this.kymw1100Model.coopInfoList;
    const checkFlag: number = this.check_SupplyPriceStandardWitthArray(coopInfoList);

    if (checkFlag > 0) {
      this.dialogService.openAlertGetMessage('Q0125', ['供給価格(通常)', '仕入価格(通常)'], (closeEvent: any) => {
        if (closeEvent === PlessAlert.Yes) {
          this.Show_SupplyPriceStandard_2();
        }
      });
    } else {
      this.Show_SupplyPriceStandard_2();
    }
  }


  /**
   *⑥-2 供給価格（通常）≦仕入価格（通常）の場合、確認メッセージを表示する。
   * ID = Q0125%1 =    '供給価格（通常）'　%2 =    '仕入価格（通常）'
   * a)'いいえ'を選択した場合、処理を終了する。
   */
  public Show_SupplyPriceStandard_2(): void {
    if (this.isEnableChangeTax()) {
      const coopInfoList: Array<any> = this.kymw1100Model.coopInfoWkList;
      const checkFlag: number = this.check_SupplyPriceStandardWitthArray(coopInfoList);

      if (checkFlag > 0) {
        this.dialogService.openAlertGetMessage('Q0125',
          // '供給価格(通常)(8%)','仕入価格(通常)(8%)');
          ['供給価格(通常)(' + this.taxChangeWkMsg + ')', '仕入価格(通常)(' + this.taxChangeWkMsg + ')'],
          (closeEvent: any) => {
            if (closeEvent === PlessAlert.Yes) {
              this.Show_SupplyPriceSpecial1();
            }
          });
      } else {
        this.Show_SupplyPriceSpecial1();
      }
    } else {
      this.Show_SupplyPriceSpecial1();
    }
  }

  /**
   *⑦供給価格（特価１）≦仕入価格（特価１）のチェックをする
   */
  public chesk_SupplyPriceSpecial1WithArray(coopInfoList: Array<any>): number {
    let checkFlag: number = <number>0;

    if (coopInfoList != null) {
      for (let i = Number(0); i < coopInfoList.length; i++) {
        if (coopInfoList[i].Check === true) {
          const supplyPriceSpecial1Tmp = Number(coopInfoList[i].SupplyPriceSpecial1);
          const consignPriceSpecial1Tmp = Number(coopInfoList[i].ConsignPriceSpecial1);

          if (supplyPriceSpecial1Tmp === 0 && consignPriceSpecial1Tmp === 0) {
            continue;
          }

          if (supplyPriceSpecial1Tmp <= consignPriceSpecial1Tmp) {
            checkFlag++;
          }
        }
      }
    }

    return checkFlag;
  }

  /**
   *⑦-1 供給価格（特価１）≦仕入価格（特価１）の場合、確認メッセージを表示する。
   * ID = Q0125%1 =    '供給価格（特価１）'　%2 =    '仕入価格（特価１）'
   * a)'いいえ'を選択した場合、処理を終了する。
   */
  public Show_SupplyPriceSpecial1(): void {
    const coopInfoList: Array<any> = this.kymw1100Model.coopInfoList;
    const checkFlag: number = this.chesk_SupplyPriceSpecial1WithArray(coopInfoList);

    if (checkFlag > 0) {
      this.dialogService.openAlertGetMessage('Q0125',
        // '供給価格(通常)(8%)','仕入価格(通常)(8%)');
        ['供給価格(特価１)', '仕入価格(特価１)'],
        (closeEvent: any) => {
          if (closeEvent === PlessAlert.Yes) {
            this.Show_SupplyPriceSpecial2();
          }
        });
    } else {
      this.Show_SupplyPriceSpecial1_2();
    }
  }


  /**
   *⑦-2 供給価格（特価１）≦仕入価格（特価１）の場合、確認メッセージを表示する。
   * ID = Q0125%1 =    '供給価格（特価１）'　%2 =    '仕入価格（特価１）'
   * a)'いいえ'を選択した場合、処理を終了する。
   */
  public Show_SupplyPriceSpecial1_2(): void {
    if (this.isEnableChangeTax()) {
      const coopInfoList: Array<any> = this.kymw1100Model.coopInfoWkList;
      const checkFlag: number = this.chesk_SupplyPriceSpecial1WithArray(coopInfoList);

      if (checkFlag > 0) {
        this.dialogService.openAlertGetMessage('Q0125',
          // '供給価格(特価１)(8%)','仕入価格(特価１)(8%)');
          ['供給価格(特価１)(' + this.taxChangeWkMsg + ')', '仕入価格(特価１)(' + this.taxChangeWkMsg + ')'],
          (closeEvent: any) => {
            if (closeEvent === PlessAlert.Yes) {
              this.Show_SupplyPriceSpecial2();
            }
          });
      } else {
        this.Show_SupplyPriceSpecial2();
      }
    } else {
      this.Show_SupplyPriceSpecial2();
    }
  }

  /**
   *⑧供給価格（特価２）≦仕入価格（特価２）のチェックをする。
   */
  public check_SupplyPriceSpecial2(coopInfoList: Array<any>): number {
    let checkFlag: number = <number>0;

    if (coopInfoList != null) {
      for (let i = Number(0); i < coopInfoList.length; i++) {
        if (coopInfoList[i].Check === true) {
          const supplyPriceSpecial2Tmp = Number(coopInfoList[i].SupplyPriceSpecial2);
          const consignPriceSpecial2Tmp = Number(coopInfoList[i].ConsignPriceSpecial2);

          if (supplyPriceSpecial2Tmp === 0 && consignPriceSpecial2Tmp === 0) {
            continue;
          }

          if (supplyPriceSpecial2Tmp <= consignPriceSpecial2Tmp) {
            checkFlag++;
          }
        }
      }
    }
    return checkFlag;
  }

  /**
   *⑧-1 供給価格（特価２）≦仕入価格（特価２）の場合、確認メッセージを表示する。
   * ID = Q0125%1 =    '供給価格（特価２）'　%2 =    '仕入価格（特価２）'
   * a)'いいえ'を選択した場合、処理を終了する。
   */
  public Show_SupplyPriceSpecial2(): void {
    const coopInfoList: Array<any> = this.kymw1100Model.coopInfoList;
    const checkFlag: number = this.check_SupplyPriceSpecial2(coopInfoList);

    if (checkFlag > 0) {
      this.dialogService.openAlertGetMessage('Q0125',
        // '供給価格(通常)(8%)','仕入価格(通常)(8%)');
        ['供給価格(特価２)', '仕入価格(特価２)'],
        (closeEvent: any) => {
          if (closeEvent === PlessAlert.Yes) {
            this.Show_SupplyPriceSpecial2_2();
          }
        });
    } else {
      this.Show_SupplyPriceSpecial2_2();
    }
  }

  /**
   *⑧-2 供給価格（特価２）≦仕入価格（特価２）の場合、確認メッセージを表示する。
   * ID = Q0125%1 =    '供給価格（特価２）'　%2 =    '仕入価格（特価２）'
   * a)'いいえ'を選択した場合、処理を終了する。
   */
  public Show_SupplyPriceSpecial2_2(): void {
    if (this.isEnableChangeTax()) {
      const coopInfoList: Array<any> = this.kymw1100Model.coopInfoWkList;
      const checkFlag: number = this.check_SupplyPriceSpecial2(coopInfoList);

      if (checkFlag > 0) {
        this.dialogService.openAlertGetMessage('Q0125',
          // '供給価格(特価１)(8%)','仕入価格(特価１)(8%)');
          ['供給価格(特価２)(' + this.taxChangeWkMsg + ')', '仕入価格(特価２)(' + this.taxChangeWkMsg + ')'],
          (closeEvent: any) => {
            if (closeEvent === PlessAlert.Yes) {
              this.show_UnitPriceCoefficient();
            }
          });
      } else {
        this.show_UnitPriceCoefficient();
      }
    } else {
      this.show_UnitPriceCoefficient();
    }
  }

  /**
   *⑨部門コード０３の場合、ユニットプライス係数の入力確認
   */
  public show_UnitPriceCoefficient(): void {
    if (this.cmb_ClassCode.selectedClassCode === '03' && this.kymw1100Model.unitPriceCoefficient.replace(' ', '') === '') {
      this.dialogService.openAlertGetMessage('Q0131',
        // '供給価格(通常)(8%)','仕入価格(通常)(8%)');
        ['部門'
          , '03：畜産'
          , 'ユニットプライス係数'
          , '未設定'],
        (closeEvent: any) => {
          if (closeEvent === PlessAlert.Yes) {
            this.show_UnitPriceUnit();
          }
        });
    } else {
      this.show_UnitPriceUnit();
    }
  }
  /**
   *⑩部門コード０３の場合、ユニットプライス単位の入力確認
   */
  public show_UnitPriceUnit(): void {
    if (this.cmb_ClassCode.selectedClassCode === '03' && this.kymw1100Model.unitPriceUnit.replace(' ', '') === '') {
      this.dialogService.openAlertGetMessage('Q0131',
        // '供給価格(通常)(8%)','仕入価格(通常)(8%)');
        ['部門'
          , '03：畜産'
          , 'ユニットプライス単位'
          , '未設定'],
        (closeEvent: any) => {
          if (closeEvent === PlessAlert.Yes) {
            this.Show_ConsumeTax();
          }
        });
    } else {
      this.Show_ConsumeTax();
    }
  }

  /**
   * 12-1 選択されている小分類に紐づくデフォルト消費税率と異なる場合、確認メッセージを表示する。
   * ID = Q0154
   * a)'いいえ'を選択した場合、処理を終了する。
   */
  public Show_ConsumeTax(): void {
    const def_Rate: string = this.kymw1100Model.def_ConsumeTaxRate;		// 小分類に紐づくデフォルト消費税率
    const txt_Rate: string = this.kymw1100Model.consumeTaxDivRate;		// 画面で入力された消費税率

    if (def_Rate !== txt_Rate) {
      this.dialogService.openAlertGetMessage('Q0154',
        null, (closeEvent: any) => {
          if (closeEvent === PlessAlert.Yes) {
            this.Show_ConsumeTax_2();
          }
        });
    } else {
      this.Show_ConsumeTax_2();
    }
  }

  /**
   * 12-2 選択されている小分類に紐づくデフォルト消費税率と異なる場合、確認メッセージを表示する。
   * ID = Q0154
   * a)'いいえ'を選択した場合、処理を終了する。
   */
  public Show_ConsumeTax_2(): void {
    if (this.isEnableChangeTax()) {

      const def_Rate: string = this.kymw1100Model.def_ConsumeTaxRate_2;	// 小分類に紐づくデフォルト消費税率
      const txt_Rate: string = this.kymw1100Model.consumeTaxRateWk;		// 画面で入力された消費税率

      if (def_Rate !== txt_Rate) {
        this.dialogService.openAlertGetMessage('Q0154',
          null, (closeEvent: any) => {
            if (closeEvent === PlessAlert.Yes) {
              this.Show_Update();
            }
          });
      } else {
        this.Show_Update();
      }
    } else {
      this.Show_Update();
    }
  }

  /**
   * ⑪共通　新規作成ボタン後による登録時、確認メッセージを表示する。
   * ⑫商品検索から選択した商品の更新時、確認メッセージを表示する。
   * a)'いいえ'を選択した場合、処理を終了する。
   */
  public Show_Update(): void {
    let qCode;
    if (!PlessViewUtilsSub.isEmpty(this.kymw1100Model.pCode)) {
      qCode = 'Q0105';
    } else {
      qCode = 'Q0104';
    }
    this.dialogService.openAlertGetMessage(qCode,
      ['商品情報'], (closeEvent: any) => {
        if (closeEvent === PlessAlert.Yes) {
          this.updateGoods();
        }
      });

  }

  /**
   * 入力項目のチェックを行う。
   * 更新する。
   */
  public updateGoods(): void {
    // 必須項目をチェックする
    if (this.validateGoodsData() === 'OK') {
      const vo = this.updateVO();
      this.registGoodsService.execute(this.kymw1100Model, vo, (data: any) => {
        // KYMW1200から遷移して更新の場合
        if (this.kymw1100InputVO !== null && this.kymw1100Model.pCode === this.kymw1100InputVO.pCode) {
          this._procDone = true;
        } 
        // JANコード重複チェック
        if (data.JanCodeDuplicateFlag === "1") {
          this.dialogService.openAlertGetMessage('I0509', [], () => {
            // 商品名完全一致の商品有無チェック
            if (typeof data.GoodsNameExactMatchFlag !== undefined && data.GoodsNameExactMatchFlag === "1") {
              this.dialogService.openAlertGetMessage('I0510', [], () => {
                this.dialogService.openAlertGetMessage('I0511');
              });
            }
          });
        } else {
          // 商品名完全一致の商品有無チェック
          if (typeof data.GoodsNameExactMatchFlag !== undefined && data.GoodsNameExactMatchFlag === "1") {
            this.dialogService.openAlertGetMessage('I0510', [], () => {
              this.dialogService.openAlertGetMessage('I0511');
            });
          }
        }

        if (this.kymw1100Model.totalNum !== 0) {
          // 候補リスト再検索実行
          this.getCandidateGoodsList(this.kymw1100Model.pageNo);
        }
      });
    }
  }

  /**
   * 商品更新処理。
   * 新規登録の時に排他制御の処理を行う。
   */
  public eventUpdate(): void {
    const pCodeParam: Array<any> = [];
    pCodeParam[0] = this.kymw1100Model.pCode;

    this.searchPCode = pCodeParam[0];

    // 新規作成して商品登録が成功したときのPCodeのロックイベントを発生する。
    super.LockUtilForGoods('REGIST', this.searchPCode,
      (event: any) => {
        this.successUpdateLock(event);
      }, pCodeParam,
      (event: any) => {
        this.faultUpdateLock(event);
      }, null, false);
  }

  // ロック成功
  public successUpdateLock(event: any): void {
    this.successPCode = event[0];
    this.lockNum = '2';
  }

  // ロック失敗
  public faultUpdateLock(event: any): void {
    this.successPCode = '';
    this.lockNum = '1';
  }
  /**
       * 更新用VO
      */
  public updateVO(): any {
    const vo = {
      pCodeInfoVO: this.sendData_pCodeInfo(),			// 基本情報
      itemInfoVO: this.sendData_itemInfo()			// 提案情報
    };

    return vo;
  }

  public sendData_pCodeInfo(): any {
    const vo: any = {
      pCode: '',
      buyerCode: this.cmb_BuyerCode.selectedCodeValue,
      classDivNum: this.cmb_ClassCode.selectedClassDivNum,
      classCode: this.cmb_ClassCode.selectedClassCode,
      largeClassCode: this.cmb_LargeClassCode.selectedLargeClassCode,
      middleClassCode: this.cmb_MiddleClassCode.selectedMiddleClassCode,
      smallClassCodeList: this.cmb_SmallClassCodeList.selectedSmallClassCode,
      admintStatus: this.kymw1100Model.admitStatus,
      packMaterialShowFlg: '0',
      goodsDiv: '0',
      dataType: <string>'',
      appkyTermStart: PlessViewUtilsSub.editDate(this.kymw1100Model.appkyTermStart, '1'),
      endFlag: '1',
      appkyTermEnd: '99999999',
      guideGoodsName: this.kymw1100Model.guideGoodsName,
      guideStandardName: this.kymw1100Model.guideStandardName,
      categoryCode: this.cmb_CategoryCode.selectedCategoryCode,
      goodsBaseVO: this.sendData_goodsBase(),
      markInfoVO: this.sendData_markInfo(),
      // 付加情報タブVO
      additionInfoVO: this.sendData_additionInfo(),
      // 発注物流タブVO
      orderDistributeVO: this.sendData_orderDistribute(),
      // 表組タブVO
      goodsListingVO: this.sendData_goodsListing(),
      // 商品DNA情報タブVO
      goodsDnaInfoVO: this.sendData_goodsDna(),
      // タグ情報タブVO
      goodsTagInfoVO: this.sendData_goodsTag(),
      // 関連ページタブVO
      goodsPageInfoVO: this.sendData_goodsPage(),
      // 登録ボタン【0】、OKボタン【1】
      execFlag: this.ExecFlag,
    };

    if (!PlessViewUtilsSub.isEmpty(this.kymw1100Model.pCode)) {
      vo.pCode = this.kymw1100Model.pCode;
    }

    if (this.kymw1100Model.packMaterialShowFlg) {
      vo.packMaterialShowFlg = '1';
    }

    if (this.kymw1100Model.dummyGoods) {
      vo.goodsDiv = '1';
    }

    if (!this.kymw1100Model.endFlag) {
      vo.endFlag = '0';
      vo.appkyTermEnd = PlessViewUtilsSub.editDate(this.kymw1100Model.appkyTermEnd, '1');
    }

    return vo;
  }

  public sendData_goodsBase(): any {
    const vo: any = {
      deliveryGoodsNameKanji: this.kymw1100Model.deliveryGoodsNameKanji,
      deliveryGoodsNameKana: this.kymw1100Model.deliveryGoodsNameKana,
      deliveryStandardNameKanji: this.kymw1100Model.deliveryStandardNameKanji,
      deliveryStandardNameKana: this.kymw1100Model.deliveryStandardNameKana,
      ocrGoodsName: this.kymw1100Model.ocrGoodsName,
      ecNonDispDiv: this.cmb_EcNonDispDiv.selectedCodeValue,
      consumeTaxDivList: this.kymw1100Model.consumeTaxDivList,
      consumeTaxDivRate: this.kymw1100Model.consumeTaxDivRate,
      consumeTaxDivListWk: this.kymw1100Model.consumeTaxDivWk,
      consumeTaxDivRateWk: this.kymw1100Model.consumeTaxRateWk,
      cycleTerm: this.cmb_CycleTerm.selectedCodeValue,
      edlpDiv: this.cmb_EdlpDiv.selectedCodeValue,
      unitPriceDiv: this.cmb_UnitPriceDiv.selectedCodeValue,
      unitPriceCoefficient: this.kymw1100Model.unitPriceCoefficient,
      unitPriceUnit: this.kymw1100Model.unitPriceUnit,
      consumeTerm: this.kymw1100Model.consumeTerm,
      consumeByDate: this.kymw1100Model.consumeByDate,
      seasonConsumeTerm: this.kymw1100Model.seasonConsumeTerm,
      relationPcodeOld: this.kymw1100Model.relationPcodeOld,
      relationPcodeNew: this.kymw1100Model.relationPcodeNew,
      leaveConsumeTerm: this.kymw1100Model.leaveConsumeTerm,
      guideTempZoneDiv: this.cmb_GuideTempZoneDiv.selectedCodeValue,
      blindDiv: this.cmb_BlindDiv.selectedCodeValue,
      eFriendsSendDiv: '0',
      liquorCode: this.cmb_LiquorCode.selectedCodeValue,
      alocoholType: this.kymw1100Model.alocoholType,
      containerForm: this.cmb_ContainerForm.selectedCodeValue,
      containerCapacity: this.kymw1100Model.containerCapacity,
      mediumList: this.kymw1100Model.mediumList,
    };

    if (this.kymw1100Model.seasonConsumeDiv) {
      vo.seasonConsumeDiv = '1';
      vo.seasonConsumeTermTo = this.kymw1100Model.seasonConsumeTermTo;
      vo.seasonConsumeTermFrom = this.kymw1100Model.seasonConsumeTermFrom;
    } else {
      vo.seasonConsumeDiv = '0';
      vo.seasonConsumeTerm = null;
      vo.seasonConsumeTermFrom = null;
    }

    if (this.kymw1100Model.eFriendsSendDiv) {
      vo.eFriendsSendDiv = '1';
    }


    return vo;
  }

  public sendData_markInfo(): any {
    const vo: any = {
      markCodeList: this.kymw1100Model.markList
    };

    return vo;
  }

  public sendData_additionInfo(): any {
    const vo: any = new Object();

    const tempCodeList: Array<any> = new Array<any>();
    const ob0: any = new Object();
    const ob1: any = new Object();
    const ob2: any = new Object();
    const ob3: any = new Object();
    const ob4: any = new Object();
    const ob5: any = new Object();
    const ob6: any = new Object();
    const ob7: any = new Object();
    const ob8: any = new Object();
    const ob9: any = new Object();
    const ob10: any = new Object();
    const ob11: any = new Object();
    const ob12: any = new Object();
    const ob13: any = new Object();
    const ob14: any = new Object();

    // Pコードテキスト情報
    ob0.TextKindID = '019';
    ob0.StringValue = PlessViewUtilsSub.trimDirection(this.kymw1100Model.textInfo4, 1);
    tempCodeList.push(ob0);

    ob1.TextKindID = '008';
    ob1.StringValue = PlessViewUtilsSub.trimDirection(this.kymw1100Model.textInfo5, 1);
    tempCodeList.push(ob1);

    ob2.TextKindID = '023';
    ob2.StringValue = PlessViewUtilsSub.trimDirection(this.kymw1100Model.textInfo6, 1);
    tempCodeList.push(ob2);

    ob3.TextKindID = '022';
    ob3.StringValue = PlessViewUtilsSub.trimDirection(this.kymw1100Model.textInfo7, 1);
    tempCodeList.push(ob3);

    // 届出番号
    ob4.TextKindID = '032';
    ob4.StringValue = PlessViewUtilsSub.trimDirection(this.kymw1100Model.licencedNo, 1);
    tempCodeList.push(ob4);

    // EC用商品説明
    ob5.TextKindID = '034';
    ob5.StringValue = PlessViewUtilsSub.trimDirection(this.kymw1100Model.textInfo10, 1);
    tempCodeList.push(ob5);

    // 月齢情報
    ob6.TextKindID = '035';
    ob6.StringValue = PlessViewUtilsSub.trimDirection(this.kymw1100Model.textInfo11, 1);
    tempCodeList.push(ob6);

    // 健康管理情報
    ob7.TextKindID = '036';
    ob7.StringValue = PlessViewUtilsSub.trimDirection(this.kymw1100Model.textInfo12, 1);
    tempCodeList.push(ob7);

    // 成分情報
    ob8.TextKindID = '037';
    ob8.StringValue = PlessViewUtilsSub.trimDirection(this.kymw1100Model.textInfo13, 1);
    tempCodeList.push(ob8);

    // 吸水量
    ob9.TextKindID = '038';
    ob9.StringValue = PlessViewUtilsSub.trimDirection(this.kymw1100Model.textInfo14, 1);
    tempCodeList.push(ob9);

    // 調理時間の目安
    ob10.TextKindID = '040';
    ob10.StringValue = PlessViewUtilsSub.trimDirection(this.kymw1100Model.textInfo15, 1);
    tempCodeList.push(ob10);

    // ○人前情報
    ob11.TextKindID = '041';
    ob11.StringValue = PlessViewUtilsSub.trimDirection(this.kymw1100Model.textInfo16, 1);
    tempCodeList.push(ob11);

    // 材料
    ob12.TextKindID = '042';
    ob12.StringValue = PlessViewUtilsSub.trimDirection(this.kymw1100Model.textInfo17, 1);
    tempCodeList.push(ob12);

    // ご家庭で用意いただくもの
    ob13.TextKindID = '043';
    ob13.StringValue = PlessViewUtilsSub.trimDirection(this.kymw1100Model.textInfo18, 1);
    tempCodeList.push(ob13);

    // 人気商品情報
    ob14.TextKindID = '039';
    ob14.StringValue = PlessViewUtilsSub.trimDirection(this.kymw1100Model.textInfo19, 1);
    tempCodeList.push(ob14);

    vo.textInfoList = tempCodeList;

    return vo;
  }

  public sendData_orderDistribute(): any {
    const vo: any = {
      stinkGoodsDivList: this.cmb_StinkGoodsDivList.selectedCodeValue,
      setDivList: this.cmb_SetDivList.selectedCodeValue,
      caseSupplyDivList: this.cmb_CaseSupplyDivList.selectedCodeValue,
      longKeepDivList: this.cmb_LongKeepDivList.selectedCodeValue,
      assortTempdivList: this.cmb_AssortTempdivList.selectedCodeValue,
      arrivalAreaDivList: this.cmb_ArrivalAreaDivList.selectedCodeValue,
      arrivalGoodsTemp: this.kymw1100Model.arrivalGoodsTemp,
      arrivalAdminDays: this.kymw1100Model.arrivalAdminDays,
      dutiesFormDailyDiv: this.cmb_DutiesFormDailyDivList.selectedCodeValue,
      fragileFlg: this.cmb_FragileFlgList.selectedCodeValue,
    };

    return vo;
  }

  public sendData_goodsListing(): any {
    const vo: any = {
      listingGoodsName: this.kymw1100Model.listingGoodsName,
      goodsListingList: this.kymw1100Model.listingList,
    };

    return vo;
  }

  // サーバ送信用にデータをVOに設定
  public sendData_goodsDna(): any {
    const vo: any = {
      // マネージャで保持しているリストをVOに格納
      goodsDnaList: this.kymw1100Model.dnaList
    };

    return vo;
  }

  public sendData_goodsTag(): any {
    const vo: any = {
      tagInfo: this.kymw1100Model.tagInfo
    };

    return vo;
  }

  public sendData_goodsPage(): any {
    const vo: any = {
      coopGoodsTitle: this.kymw1100Model.coopGoodsTitle,
      coopGoodsUrl: this.kymw1100Model.coopGoodsUrl,
      pageTitle: this.kymw1100Model.pageTitle,
      pageUrl: this.kymw1100Model.pageUrl
    };

    return vo;
  }

  public sendData_itemInfo(): any {
    const vo: any = {
      itemCode: this.kymw1100Model.itemCode,
      janCode: this.kymw1100Model.janCode,
      janCodeDiv: '0',
      itemVO: this.sendData_item(),
      useCoopVO: this.sendData_useCoop(),
      specifications1VO: this.sendData_specifications1(),
      specifications2VO: this.sendData_specifications2(),
      ecologyVO: this.sendData_ecology(),
      goodsSpecificationInfoVO: this.sendData_goodsSpecificationInfo(),		// 商品仕様書マスタ情報 データ無しの場合null
    };

    if (this.kymw1100Model.janCodeDiv) {
      vo.janCodeDiv = '1';
    }

    return vo;
  }

  public sendData_item(): any {
    const vo: any = {
      brandType: this.cmb_BrandType.selectedCodeValue,
      bundlePrice: this.kymw1100Model.fcmcFee,
      specialOrderTypeList: this.cmb_SpecialOrderTypeList.selectedCodeValue,
      stockTypeList: this.cmb_StockTypeList.selectedCodeValue,
      installmentTimes: this.kymw1100Model.installmentTimes,
      pdPilingUpDays: this.kymw1100Model.pdPilingUpDays,
      itfCode: this.kymw1100Model.itfCode,
      orderUnitType: this.cmb_OrderUnitType.selectedCodeValue,
      priceType: this.cmb_PriceType.selectedCodeValue,
      makerPrice: this.kymw1100Model.makerPrice,
      orderClientCode: this.kymw1100Model.orderClientCode,
      payeeClientCode: this.kymw1100Model.payeeClientCode,
      fixContainNum: this.kymw1100Model.fixContainNum,
      setQuantity: this.kymw1100Model.setQuantity,
    };

    return vo;
  }

  public sendData_useCoop(): any {
    const vo: any = {
      consignBundle: this.kymw1100Model.bundlePrice,
      useCoopInfoList: this.kymw1100Model.coopInfoList,
      useCoopInfoListWk: this.kymw1100Model.coopInfoWkList,
    };

    return vo;
  }

  public sendData_specifications1(): any {
    const vo: any = {
      ebaseSpecCode: this.kymw1100Model.ebaseSpecCode,
      specApplyDate: this.kymw1100Model.specApplyDate,
      ebaseGetDate: this.kymw1100Model.ebaseGetDate,
      registCatalogRound: this.kymw1100Model.registCatalogRound,
      makerName: this.kymw1100Model.makerName,
      makerNamePublishType: '0',
      peaceSizeLength: this.kymw1100Model.peaceSizeLength,
      peaceSizeWidth: this.kymw1100Model.peaceSizeWidth,
      peaceSizeHight: this.kymw1100Model.peaceSizeHight,
      peaceWeight: this.kymw1100Model.peaceSizeWeight,
      caseSizeLength: this.kymw1100Model.caseSizeLength,
      caseSizeWidth: this.kymw1100Model.caseSizeWidth,
      caseSizeHight: this.kymw1100Model.caseSizeHight,
      caseWeight: this.kymw1100Model.caseSizeWeight,
      geneRecombinationDiv: this.cmb_GeneRecombinationDiv.selectedCodeValue,
    };

    if (this.kymw1100Model.makerNamePublishType) {
      vo.makerNamePublishType = '1';
    }

    const tempCodeList: Array<any> = new Array<any>();

    const ob0: any = {
      TextInfoDiv: '005',
      StringValue: PlessViewUtilsSub.trimDirection(this.kymw1100Model.stringValue1, 1),
    };
    tempCodeList.push(ob0);
    const ob1: any = {
      TextInfoDiv: '014',
      StringValue: PlessViewUtilsSub.trimDirection(this.kymw1100Model.stringValue2, 1),
    };
    tempCodeList.push(ob1);
    const ob2: any = {
      TextInfoDiv: '013',
      StringValue: PlessViewUtilsSub.trimDirection(this.kymw1100Model.stringValue3, 1),
    };
    tempCodeList.push(ob2);
    const ob3: any = {
      TextInfoDiv: '010',
      StringValue: PlessViewUtilsSub.trimDirection(this.kymw1100Model.stringValue4, 1),
    };
    tempCodeList.push(ob3);
    const ob4: any = {
      TextInfoDiv: '006',
      StringValue: PlessViewUtilsSub.trimDirection(this.kymw1100Model.stringValue5, 1),
    };
    tempCodeList.push(ob4);
    const ob5: any = {
      TextInfoDiv: '007',
      StringValue: PlessViewUtilsSub.trimDirection(this.kymw1100Model.stringValue6, 1),
    };
    tempCodeList.push(ob5);

    vo.specifications1List = tempCodeList;

    if (!this.isEmpty(this.kymw1100Model.ebaseSpecCodeRev)) {
      vo.ebaseSpecCodeRev = this.kymw1100Model.ebaseSpecCodeRev;		// eBASE仕様書コード(改訂)
    }

    return vo;
  }

  public sendData_specifications2(): any {
    const vo: any = {
      allergenTargetType: this.cmb_AllergenTargetType.selectedCodeValue,
      goodsAllergenList: this.kymw1100Model.allergenList,
      analysisUnit: this.kymw1100Model.analysisUnit,
      calolie: this.kymw1100Model.calorie,
      protein: this.kymw1100Model.protein,
      lipid: this.kymw1100Model.lipid,
      carbohydrate: this.kymw1100Model.carbohydrate,
      sodium: this.kymw1100Model.sodium,
    };
    return vo;
  }
  public sendData_ecology(): any {
    const vo: any = {
      goodsEcologyList: this.kymw1100Model.goodsEcologyList,
      goodsGWStopList: this.kymw1100Model.goodsGWStopList,
      containPackingList: this.kymw1100Model.containPackingList,
    };

    return vo;
  }

  /**
   * 送信データ作成(商品仕様書マスタ情報）
   * 更新ボタン押下時、商品仕様書マスタ情報の送信データを取得する。
   * ※仕様反映直後のみ商品仕様書マスタ情報のデータを取得する。
   */
  public sendData_goodsSpecificationInfo(): any {
    // 変数定義
    let checkFlag: boolean = <boolean>false;										// データ有無の判定用 true:データ有 false:データ無
    let vo: any = null;								// 返却値、商品仕様書マスタ情報格納領域

    // 仕様反映直後かチェック
    if (this.kymw1100Model.ebaseDataReflectionFlag) {
      // 仕様反映データが設定されているかチェック
      // eBASEデータの仕様書情報全ての項目が未入力の場合を考慮
      if (!this.isEmpty(this.kymw1100Model.pieceSizeLength)
        || !this.isEmpty(this.kymw1100Model.pieceSizeWidth)
        || !this.isEmpty(this.kymw1100Model.pieceSizeHeight)
        || !this.isEmpty(this.kymw1100Model.pieceWeight)
        || !this.isEmpty(this.kymw1100Model.pieceContainNum)
        || !this.isEmpty(this.kymw1100Model.pieceJanCode)
        || !this.isEmpty(this.kymw1100Model.packSizeLength)
        || !this.isEmpty(this.kymw1100Model.packSizeWidth)
        || !this.isEmpty(this.kymw1100Model.packSizeHeight)
        || !this.isEmpty(this.kymw1100Model.packWeight)
        || !this.isEmpty(this.kymw1100Model.packContainNum)
        || !this.isEmpty(this.kymw1100Model.packJanCode)
        || !this.isEmpty(this.kymw1100Model.bowlSizeLength)
        || !this.isEmpty(this.kymw1100Model.bowlSizeWidth)
        || !this.isEmpty(this.kymw1100Model.bowlSizeHeight)
        || !this.isEmpty(this.kymw1100Model.bowlWeight)
        || !this.isEmpty(this.kymw1100Model.bowlContainNum)
        || !this.isEmpty(this.kymw1100Model.bowlJanCode)
        || !this.isEmpty(this.kymw1100Model.caseSizeLengthEbase)
        || !this.isEmpty(this.kymw1100Model.caseSizeWidthEbase)
        || !this.isEmpty(this.kymw1100Model.caseSizeHeightEbase)
        || !this.isEmpty(this.kymw1100Model.caseWeightEbase)
        || !this.isEmpty(this.kymw1100Model.caseContainNumEbase)
        || !this.isEmpty(this.kymw1100Model.caseJanCodeEbase)
        || !this.isEmpty(this.kymw1100Model.factoryAddress)
        || !this.isEmpty(this.kymw1100Model.fragileFlg)) {		// 割れ物フラグ
        checkFlag = true;
      }
    }

    if (checkFlag) {
      vo = new Object();
      // 仕様反映データが一つでも入力されている場合は、全てのデータを設定(nullは未設定）
      if (!this.isEmpty(this.kymw1100Model.pieceSizeLength)) {
        vo.pieceSizeLength = this.kymw1100Model.pieceSizeLength;		// ピースサイズ(縦)
      }
      if (!this.isEmpty(this.kymw1100Model.pieceSizeWidth)) {
        vo.pieceSizeWidth = this.kymw1100Model.pieceSizeWidth;		// ピースサイズ(横)
      }
      if (!this.isEmpty(this.kymw1100Model.pieceSizeHeight)) {
        vo.pieceSizeHeight = this.kymw1100Model.pieceSizeHeight;		// ピースサイズ(高)
      }
      if (!this.isEmpty(this.kymw1100Model.pieceWeight)) {
        vo.pieceWeight = this.kymw1100Model.pieceWeight;				// ピース重量
      }
      if (!this.isEmpty(this.kymw1100Model.pieceContainNum)) {
        vo.pieceContainNum = this.kymw1100Model.pieceContainNum;		// ピース入数
      }
      if (!this.isEmpty(this.kymw1100Model.packSizeWidth)) {
        vo.pieceJanCode = this.kymw1100Model.pieceJanCode;			// ピースＪＡＮコード
      }
      if (!this.isEmpty(this.kymw1100Model.packSizeWidth)) {
        vo.packSizeLength = this.kymw1100Model.packSizeLength;		// パックサイズ(縦)
      }
      if (!this.isEmpty(this.kymw1100Model.packSizeWidth)) {
        vo.packSizeWidth = this.kymw1100Model.packSizeWidth;			// パックサイズ(横)
      }
      if (!this.isEmpty(this.kymw1100Model.packSizeHeight)) {
        vo.packSizeHeight = this.kymw1100Model.packSizeHeight;		// パックサイズ(高)
      }
      if (!this.isEmpty(this.kymw1100Model.packWeight)) {
        vo.packWeight = this.kymw1100Model.packWeight;				// パック重量
      }
      if (!this.isEmpty(this.kymw1100Model.packContainNum)) {
        vo.packContainNum = this.kymw1100Model.packContainNum;		// パック入数
      }
      if (!this.isEmpty(this.kymw1100Model.packJanCode)) {
        vo.packJanCode = this.kymw1100Model.packJanCode;				// パックＪＡＮコード
      }
      if (!this.isEmpty(this.kymw1100Model.bowlSizeLength)) {
        vo.bowlSizeLength = this.kymw1100Model.bowlSizeLength;		// ボールサイズ(縦)
      }
      if (!this.isEmpty(this.kymw1100Model.bowlSizeWidth)) {
        vo.bowlSizeWidth = this.kymw1100Model.bowlSizeWidth;			// ボールサイズ(横)
      }
      if (!this.isEmpty(this.kymw1100Model.bowlSizeHeight)) {
        vo.bowlSizeHeight = this.kymw1100Model.bowlSizeHeight;		// ボールサイズ(高)
      }
      if (!this.isEmpty(this.kymw1100Model.bowlWeight)) {
        vo.bowlWeight = this.kymw1100Model.bowlWeight;				// ボール重量
      }
      if (!this.isEmpty(this.kymw1100Model.bowlContainNum)) {
        vo.bowlContainNum = this.kymw1100Model.bowlContainNum;		// ボール入数
      }
      if (!this.isEmpty(this.kymw1100Model.bowlJanCode)) {
        vo.bowlJanCode = this.kymw1100Model.bowlJanCode;				// ボールＪＡＮコード
      }
      if (!this.isEmpty(this.kymw1100Model.caseSizeLengthEbase)) {
        vo.caseSizeLength = this.kymw1100Model.caseSizeLengthEbase;	// ケースサイズ(縦)
      }
      if (!this.isEmpty(this.kymw1100Model.caseSizeWidthEbase)) {
        vo.caseSizeWidth = this.kymw1100Model.caseSizeWidthEbase;		// ケースサイズ(横)
      }
      if (!this.isEmpty(this.kymw1100Model.caseSizeHeightEbase)) {
        vo.caseSizeHeight = this.kymw1100Model.caseSizeHeightEbase;	// ケースサイズ(高)
      }
      if (!this.isEmpty(this.kymw1100Model.caseWeightEbase)) {
        vo.caseWeight = this.kymw1100Model.caseWeightEbase;			// ケース重量
      }
      if (!this.isEmpty(this.kymw1100Model.caseContainNumEbase)) {
        vo.caseContainNum = this.kymw1100Model.caseContainNumEbase;	// ケース入数
      }
      if (!this.isEmpty(this.kymw1100Model.caseJanCodeEbase)) {
        vo.caseJanCode = this.kymw1100Model.caseJanCodeEbase;			// ケースＪＡＮコード
      }
      if (!this.isEmpty(this.kymw1100Model.factoryAddress)) {
        vo.factoryAddress = this.kymw1100Model.factoryAddress;		// 工場住所
      }
      if (!this.isEmpty(this.kymw1100Model.fragileFlg)) {
        vo.fragileFlg = this.kymw1100Model.fragileFlg;				// 割れ物フラグ
      }
    }

    return vo;
  }
  public validateGoodsData(): string {
    let result: string = <string>'NG';

    // Pコード共通基本情報
    if (this.check_pCodeInfo() === 'NG') {
      // PCodeタブの必須項目情報
    } else if (this.check_goodsBaseInfo() === 'NG') {
      // 季節消費期限の必須項目情報
    } else if (this.check__goodsBaseInfo2() === 'NG') {
      // 発生物流タブの必須項目情報
    } else if (this.check__goodsBaseInfo3() === 'NG') {
      // アイテム情報の必須項目チェック
    } else if (this.check_ItemInfo() === 'NG') {
      // 利用生協のDataGrid必須項目チェック
    } else if (this.check_coopInfoList() === 'NG') {
      // 環境関連タブの環境区分必須項目チェック
    } else if (this.check_goodsEcologyList() === 'NG') {
      // 容器包装材の必須項目チェック
    } else if (this.check_containPackingList() === 'NG') {
      // 数値、桁数チェック
    } else if (this.check_isValNum() === 'NG') {
      // 消費税区分エラーチェック
    } else if (this.check_isEerr() === 'NG') {
      // 消費税区分(増税あと)エラーチェック
    } else if (CommonSetting.getVal(KEY_TAX_CHANGE_FLG) === '1'
      && this.check_isEerr_tax8() === 'NG') {
      // セット区分エラーチェック
    } else if (this.check_isEerr2() === 'NG') {

      // ケース供給区分の妥当性チェック
    } else if (this.check_CaseSupplyDiv() === 'NG') {
      // 入荷管理日数の条件必須チェック
    } else if (this.check_ArrivalAdminDays() === 'NG') {
      // 物流滞留日数の条件必須チェック
    } else if (this.check_PdPilingUpDays() === 'NG') {
      // 価格バンドルの妥当性チェック
    } else if (this.check_BundlePrice() === 'NG') {
    } else {
      result = 'OK';
    }
    return result;
  }
  /**
 * eBASEデータボタン押下イベント
 *
 * @param event 選択時イベント
 */
  public eventEBASE_CLICKHandler() {
    // 仕様反映直後の場合、情報メッセージを表示
    if (this.kymw1100Model.ebaseDataReflectionFlag) {
      this.dialogService.openAlertGetMessage('I0107');
      return;
    }

    // eBASEデータ画面を表示
    this.kymw1105InputVO = new KYMW1105InputModel();
    this.kymw1105InputVO.pCode = this.kymw1100Model.pCode;
    this.kymw1105InputVO.itemCode = this.kymw1100Model.itemCode;

    const componentRef = this.dialogService.openModal(KYMW1105Component);
    const instance = componentRef.componentInstance as KYMW1105Component;
    instance.parent = this;
    instance.setInterfaceParam(this.kymw1105InputVO);
    instance.setKYMW1105Parameter = (outputVO: KYMW1105OutputModel) => this.setKYMW1105Parameter(outputVO);
    instance.closeFunction = () => {
      componentRef.close();
    };
  }
  /**
 * eBASEデータ画面 設定内容反映
 *
 * @param outputVO eBASEデータ 出力用VO
 */
  public setKYMW1105Parameter(outputVO: KYMW1105OutputModel): void {
    // 変数設定
    let workStr: string;													// 文字列変換用領域

    // 処理区分判定「1(商品形態)」
    if (outputVO.procDiv === '1') {
      this.kymw1100Model.peaceSizeLength = outputVO.sizeLength;		// ピースサイズ（縦）
      this.kymw1100Model.peaceSizeWidth = outputVO.sizeWidth;			// ピースサイズ（横）
      this.kymw1100Model.peaceSizeHight = outputVO.sizeHeight;			// ピースサイズ（高）
      this.kymw1100Model.peaceSizeWeight = outputVO.weight;				// ピース重量
    } else if (outputVO.procDiv === '2') {
      // 処理区分判定「2(JANコード)」
      this.kymw1100Model.janCode = outputVO.janCode;					// JANコード
      this.kymw1100Model.janCodeDiv = false;						// JANコード識別区分
    } else if (outputVO.procDiv === '3') {
      // 処理区分判定「3(原産国加工地)」
      // 原材料加工地(005:主要原産地) と 原産国加工地を連結する
      workStr = outputVO.textInfo_005 + this.kymw1100Model.stringValue1;

      // 文字数チェック(200文字以降はカットする)
      if (workStr.length > 200) {
        this.kymw1100Model.stringValue1 = workStr.substring(0, 200);
      } else {
        this.kymw1100Model.stringValue1 = workStr;
      }

    }
    // 編集カウントをカウントする。
    this.editFlag = true;
    return;
  }

  /**
   * 商品栄養成分情報 設定内容反映
   *
   * @param outputVO 商品栄養成分情報 出力用VO
   */
  public setKYMW1107Parameter(outputVO: KYMW1107OutputModel): void {
    this.kymw1100Model.updateGoodsNutrientInfoByKYMW1107(outputVO);
    this.enabledNutrientUnitListContextMenu();
    this.enabledNutrientUnitListMultiContextMenu();
  }

  /**
   * pCode基本情報データの入力内容確認
   */
  public check_pCodeInfo(): string {

    let is_err: number = <number>0;
    let result: string;

    if (this.isEmpty(this.cmb_BuyerCode.selectedCodeValue)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0001', ['バイヤーコード'], null);
    } else if (this.isEmpty(this.cmb_ClassCode.selectedClassCode)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0001', ['部門コード'], null);
    } else if (this.isEmpty(this.cmb_LargeClassCode.selectedLargeClassCode)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0001', ['大分類コード'], null);
    } else if (this.isEmpty(this.cmb_MiddleClassCode.selectedMiddleClassCode)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0001', ['中分類コード'], null);
    } else if (this.isEmpty(this.cmb_SmallClassCodeList.selectedSmallClassCode)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0001', ['小分類コード'], null);
    } else if (this.isEmpty(this.kymw1100Model.appkyTermStart)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0001', ['取扱期間(開始)'], null);
    } else if (!this.kymw1100Model.endFlag) {
      // 項番2473 START 連合会問合せNo.109対応
      // if (this.isEmpty(String(this.kymw1100Model.appkyTermEnd))) {
      if (this.isEmpty(this.kymw1100Model.appkyTermEnd)) {
        // 項番2473 END 連合会問合せNo.109対応
        is_err = 1;
        this.dialogService.openAlertGetMessage('W0001', ['取扱期間(終了)'], null);
      }
    } else if (this.isEmpty(this.kymw1100Model.guideGoodsName)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0001', ['商品案内用商品名'], null);
    } else if (this.isEmpty(this.kymw1100Model.guideStandardName)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0001', ['商品案内用規格名'], null);
    }

    if (is_err) {
      result = 'NG';
    } else {
      result = 'OK';
    }

    return result;
  }

  /**
   * 基本情報タブデータの入力内容確認
   */
  public check_goodsBaseInfo(): string {

    let is_err: number = <number>0;
    let result: string;
    // 基本情報タブ
    if (this.isEmpty(this.kymw1100Model.deliveryGoodsNameKanji)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0001', ['お届け明細書用商品名(漢字)'], null);
    } else if (this.isEmpty(this.kymw1100Model.deliveryStandardNameKanji)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0001', ['お届け明細書用規格名(漢字)'], null);
    } else if (this.isEmpty(PlessViewUtilsSub.trim(this.kymw1100Model.deliveryGoodsNameKana))) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0001', ['発注用商品名(カナ)'], null);
    } else if (this.isEmpty(PlessViewUtilsSub.trim(this.kymw1100Model.deliveryStandardNameKana))) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0001', ['発注用規格名(カナ)'], null);
    } else if (this.isEmpty(this.kymw1100Model.ocrGoodsName)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0001', ['OCR商品名'], null);
    } else if (this.isEmpty(this.kymw1100Model.consumeTaxDivList)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0001', ['消費税区分'], null);
    } else if (this.isEmpty(this.kymw1100Model.consumeTaxDivRate)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0001', ['消費税率'], null);
    } else if (this.isEnableChangeTax() && this.isEmpty(this.kymw1100Model.consumeTaxDivWk)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0001', ['消費税区分(' + this.taxChangeWkMsg + ')'], null);
    } else if (this.isEnableChangeTax() && this.isEmpty(this.kymw1100Model.consumeTaxRateWk)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0001', ['消費税率(' + this.taxChangeWkMsg + ')'], null);
    }

    if (is_err) {
      result = 'NG';
    } else {
      result = 'OK';
    }

    return result;
  }

  /**
   * 季節消費期限の必須チェック
   */
  public check__goodsBaseInfo2(): string {
    let is_err: number = <number>0;
    let result: string;

    if (this.kymw1100Model.seasonConsumeDiv) {
      if (this.isEmpty(this.kymw1100Model.seasonConsumeTerm)) {
        is_err = 1;
        this.dialogService.openAlertGetMessage('W0001', ['季節消費期限'], null);
      } else if (this.isEmpty(this.kymw1100Model.seasonConsumeTermFrom)) {
        is_err = 1;
        this.dialogService.openAlertGetMessage('W0001', ['季節消費期限(開始)'], null);
      } else if (this.isEmpty(this.kymw1100Model.seasonConsumeTermTo)) {
        is_err = 1;
        this.dialogService.openAlertGetMessage('W0001', ['季節消費期限(終了)'], null);
      }
    }

    if (is_err) {
      result = 'NG';
    } else {
      result = 'OK';
    }

    return result;
  }


  /**
   * 発生物流タブ必須チェック
   */
  public check__goodsBaseInfo3(): string {
    let is_err: number = <number>0;
    let result: string;

    if (this.isEmpty(this.cmb_SetDivList.selectedCodeValue)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0001', ['セット区分'], null);
    } else if (this.isEmpty(this.cmb_AssortTempdivList.selectedCodeValue)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0001', ['仕分温度帯'], null);
    } else if (this.isEmpty(this.cmb_ArrivalAreaDivList.selectedCodeValue)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0001', ['入荷場所区分'], null);
    }

    if (is_err) {
      result = 'NG';
    } else {
      result = 'OK';
    }

    return result;
  }

  /**
   * アイテムタブデータの入力内容確認
   */
  public check_ItemInfo(): string {
    let is_err: number = <number>0;
    let result: string;

    // 必須項目チェック
    if (this.isEmpty(this.cmb_BrandType.selectedCodeValue)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0001', ['ブランド区分'], null);
    } else if (this.isEmpty(this.cmb_OrderUnitType.selectedCodeValue)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0001', ['発注単位区分'], null);
    } else if (this.isEmpty(this.kymw1100Model.orderClientCode)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0001', ['発注先取引先'], null);
    } else if (this.isEmpty(this.kymw1100Model.payeeClientCode)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0001', ['支払先取引先'], null);
    } else if (this.isEmpty(this.kymw1100Model.fixContainNum)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0001', ['確定入数'], null);
    } else if (this.isEmpty(this.kymw1100Model.setQuantity)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0001', ['組数'], null);
    } else if (this.isEmpty(this.kymw1100Model.bundlePrice)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0001', ['価格バンドル'], null);
    }

    if (is_err) {
      result = 'NG';
    } else {
      result = 'OK';
    }

    return result;
  }

  /**
   * 利用生協の必須項目チェックする。
   * 項番 986:必須チェックはなし
   */
  public check_coopInfoListWithArray(coopInfoList: Array<any>): string {
    return 'OK';
  }

  /**
   * 利用生協の必須項目チェックする。
   */
  public check_coopInfoList(): string {
    let result: string;

    result = this.check_coopInfoListWithArray(this.kymw1100Model.coopInfoList);
    if (result === 'OK') {
      result = this.check_coopInfoListWithArray(this.kymw1100Model.coopInfoWkList);
    }
    return result;
  }

  /**
   * 環境区分必須項目チェックする。
   */
  public check_goodsEcologyList(): string {
    let is_err: number = <number>0;
    let result: string;

    const goodsEcologyList: Array<any> = this.kymw1100Model.goodsEcologyList;
    let checkEcologyFlag: number = <number>0;

    if (goodsEcologyList != null) {
      for (let i = Number(0); i < goodsEcologyList.length; i++) {
        if (goodsEcologyList[i].Enabled === true) {
          if (goodsEcologyList[i].Check === true) {
            checkEcologyFlag++;
          }
        } else {
          checkEcologyFlag++;
        }
      }
    } else {
      checkEcologyFlag++;
    }

    if (this.kymw1100Model.ecology !== '1' && this.kymw1100Model.ecology !== '2') {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0001', ['環境区分']);
    } else if (checkEcologyFlag === 0) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('E0107', ['環境区分あり', '環境配慮商品']);
    }

    if (is_err) {
      result = 'NG';
    } else {
      result = 'OK';
    }
    return result;
  }

  /**
   * 容器包装材の必須項目チェック。
   */
  public check_containPackingList(): string {
    let is_err: number = <number>0;
    let result: string;

    const containPackingList: Array<any> = this.kymw1100Model.containPackingList;
    let containPackingFlag: number = <number>0;

    if (containPackingList != null) {
      for (let i = Number(0); i < containPackingList.length; i++) {
        if (containPackingList[i].Check === true) {
          if (PlessViewUtilsSub.isEmpty(containPackingList[i].PackMaterialWeight)) {
            containPackingFlag++;
          }
        }
      }
    }

    if (containPackingFlag > 0) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('E0106', ['容器包装材', '重量'], null);
    }

    if (is_err) {
      result = 'NG';
    } else {
      result = 'OK';
    }
    return result;
  }

  /**
   * 指定した桁数があってるかチェックする。
   */
  public check_isValNum(): string {
    let is_err: number = <number>0;
    let result: string;

    if (this.isNaNString(this.kymw1100Model.consumeTaxDivRate)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0003', ['消費税率'], null);
    } else if (this.isNaNString(this.kymw1100Model.unitPriceCoefficient)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0003', ['ユニットプライス係数'], null);
    } else if (this.isNaNString(this.kymw1100Model.consumeTerm)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0003', ['賞味期間'], null);
    } else if (this.isNaNString(this.kymw1100Model.consumeByDate)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0003', ['消費期限'], null);
    } else if (this.isNaNString(this.kymw1100Model.seasonConsumeTerm)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0003', ['季節消費期限'], null);
    } else if (this.isNaNString(this.kymw1100Model.leaveConsumeTerm)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0003', ['残賞味期間'], null);
    } else if (this.isNaNString(this.kymw1100Model.alocoholType)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0003', ['アルコール分別'], null);
    } else if (this.isNaNString(this.kymw1100Model.containerCapacity)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0003', ['供給単位総容量'], null);
    } else if (this.isNaNString(this.kymw1100Model.arrivalGoodsTemp)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0003', ['入荷許可品温'], null);
    } else if (this.isNaNString(this.kymw1100Model.arrivalAdminDays)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0003', ['入荷管理日数'], null);
    } else if (this.isNaNString(this.kymw1100Model.fcmcFee)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0003', ['FC・MC手数料'], null);
    } else if (this.isNaNString(this.kymw1100Model.installmentTimes)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0003', ['分納指定回数'], null);
    } else if (this.isNaNString(this.kymw1100Model.pdPilingUpDays)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0003', ['物流滞留日数'], null);
    } else if (this.isNaNString(this.kymw1100Model.makerPrice)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0003', ['メーカー希望小売価格'], null);
    } else if (this.isNaNString(this.kymw1100Model.fixContainNum)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0003', ['確定入数'], null);
    } else if (this.isNaNString(this.kymw1100Model.setQuantity)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0003', ['組数'], null);
    } else if (this.isNaNString(this.kymw1100Model.supplyPriceCoefficient)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0003', ['供給価格(通常)'], null);
    } else if (this.isNaNString(this.kymw1100Model.supplyPriceSpecial1)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0003', ['供給価格(特価１)'], null);
    } else if (this.isNaNString(this.kymw1100Model.supplyPriceSpecial2)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0003', ['供給価格(特価２)'], null);
    } else if (this.isNaNString(this.kymw1100Model.costPricecoefficient)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0003', ['単品仕入価格(通常)'], null);
    } else if (this.isNaNString(this.kymw1100Model.costPriceSpecial1)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0003', ['単品仕入価格(特価１)'], null);
    } else if (this.isNaNString(this.kymw1100Model.costPriceSpecial2)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0003', ['単品仕入価格(特価２)'], null);
    } else if (this.isEnableChangeTax() && this.isNaNString(this.kymw1100Model.consumeTaxRateWk)) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0003', ['消費税率(' + this.taxChangeWkMsg + ')'], null);
    }

    if (is_err) {
      result = 'NG';
    } else {
      result = 'OK';
    }

    return result;
  }

  /**
   * 消費税区分エラーチェックする。
   */
  public check_isEerr(): string {
    let is_err: number = <number>0;
    let result: string;

    // 消費税区分によって消費税率項目のエラーチェックを行う
    if (PlessViewUtilsSub.trim(this.kymw1100Model.consumeTaxDivList) === '0') {
      if (this.kymw1100Model.consumeTaxDivRate === '0') {
        is_err = 1;
        this.dialogService.openAlertGetMessage('E0170', ['外税', '消費税率', '0より大きい値'], null);
      }
    } else if (PlessViewUtilsSub.trim(this.kymw1100Model.consumeTaxDivList) === '9') {
      if (this.kymw1100Model.consumeTaxDivRate === '0') {
        is_err = 1;
        this.dialogService.openAlertGetMessage('E0170', ['内税', '消費税率', '0より大きい値'], null);
      }
    } else if (PlessViewUtilsSub.trim(this.kymw1100Model.consumeTaxDivList) === '1') {
      if (this.kymw1100Model.consumeTaxDivRate !== '0') {
        is_err = 1;
        this.dialogService.openAlertGetMessage('E0170', ['免税', '消費税率', '0'], null);
      }
    } else if (PlessViewUtilsSub.trim(this.kymw1100Model.consumeTaxDivList) === '2') {
      if (this.kymw1100Model.consumeTaxDivRate !== '0') {
        is_err = 1;
        this.dialogService.openAlertGetMessage('E0170', ['非課税', '消費税率', '0'], null);
      }
    } else if (PlessViewUtilsSub.trim(this.kymw1100Model.consumeTaxDivList) === '3') {
      if (this.kymw1100Model.consumeTaxDivRate !== '0') {
        is_err = 1;
        this.dialogService.openAlertGetMessage('E0170', ['課税対象外', '消費税率', '0'], null);
      }
    }

    if (is_err) {
      result = 'NG';
    } else {
      result = 'OK';
    }
    return result;
  }

  /**
   * 消費税区分エラーチェックする。
   */
  public check_isEerr_tax8(): string {
    let result: string = <string>'OK';

    if (this.isEnableChangeTax()) {
      let is_err: number = <number>0;

      // 消費税区分によって消費税率項目のエラーチェックを行う
      if (PlessViewUtilsSub.trim(this.kymw1100Model.consumeTaxDivWk) === '0') {
        if (this.kymw1100Model.consumeTaxRateWk === '0') {
          is_err = 1;
          this.dialogService.openAlertGetMessage('E0170', ['外税(' + this.taxChangeWkMsg + ')',
          '消費税率(' + this.taxChangeWkMsg + ')', '0より大きい値'], null);
        }
      } else if (PlessViewUtilsSub.trim(this.kymw1100Model.consumeTaxDivWk) === '9') {
        if (this.kymw1100Model.consumeTaxRateWk === '0') {
          is_err = 1;
          this.dialogService.openAlertGetMessage('E0170', ['内税(' + this.taxChangeWkMsg + ')',
          '消費税率(' + this.taxChangeWkMsg + ')', '0より大きい値'], null);
        }
      } else if (PlessViewUtilsSub.trim(this.kymw1100Model.consumeTaxDivWk) === '1') {
        if (this.kymw1100Model.consumeTaxRateWk !== '0') {
          is_err = 1;
          this.dialogService.openAlertGetMessage('E0170', ['免税(' + this.taxChangeWkMsg + ')',
          '消費税率(' + this.taxChangeWkMsg + ')', '0'], null);
        }
      } else if (PlessViewUtilsSub.trim(this.kymw1100Model.consumeTaxDivWk) === '2') {
        if (this.kymw1100Model.consumeTaxRateWk !== '0') {
          is_err = 1;
          this.dialogService.openAlertGetMessage('E0170', ['非課税(' + this.taxChangeWkMsg + ')',
          '消費税率(' + this.taxChangeWkMsg + ')', '0'], null);
        }
      } else if (PlessViewUtilsSub.trim(this.kymw1100Model.consumeTaxDivWk) === '3') {
        if (this.kymw1100Model.consumeTaxRateWk !== '0') {
          is_err = 1;
          this.dialogService.openAlertGetMessage('E0170', ['課税対象外(' + this.taxChangeWkMsg + ')',
          '消費税率(' + this.taxChangeWkMsg + ')', '0'], null);
        }
      }

      if (is_err) {
        result = 'NG';
      } else {
        result = 'OK';
      }
    }
    return result;
  }

  /**
   * セット区分エラーチェックする。
   */
  public check_isEerr2(): string {
    let is_err: number = <number>0;
    let result: string;

    // セット区分が【0:セット】の時に入荷場所区分が【01】じゃない時エラー
    if (PlessViewUtilsSub.trim(this.cmb_SetDivList.selectedCodeValue) === '0') {
      if (PlessViewUtilsSub.trim(this.cmb_ArrivalAreaDivList.selectedCodeValue) === '01') {
        is_err = 1;
        this.dialogService.openAlertGetMessage('E0121', ['セット区分', '入荷場所区分'], null);
      }
    }

    if (is_err) {
      result = 'NG';
    } else {
      result = 'OK';
    }
    return result;
  }


  /**
   * ケース供給区分の妥当性チェック
   */
  public check_CaseSupplyDiv(): string {
    // 変数定義
    let is_err: number = <number>0;													// エラーフラグ(0:エラーなし、1:エラーあり)
    let result: string;													// 判定結果
    let assortTempDiv: string;											// 仕分温度帯
    let fixContainNum: string;											// 確定入数
    let bundlePrice: string;												// 価格バンドル
    let caseSupplyDiv: string;											// ケース供給区分

    // 各項目値を取得
    assortTempDiv = this.cmb_AssortTempdivList.selectedCodeValue;	// 仕分温度帯
    fixContainNum = this.kymw1100Model.fixContainNum;					// 確定入数
    bundlePrice = this.kymw1100Model.bundlePrice;					// 価格バンドル
    caseSupplyDiv = this.cmb_CaseSupplyDivList.selectedCodeValue;	// ケース供給区分

    // 「仕分温度帯」が「02：常温」で、
    // 「確定入数」 > 1 で、
    // 「価格バンドル」 = 「確定入数」 で
    // 「ケース供給区分」が「0：－」である場合はエラーとする。
    if (assortTempDiv === '02'
      && Number(fixContainNum) > 1
      && Number(bundlePrice) === Number(fixContainNum)
      && caseSupplyDiv === '0') {
      is_err = 1;
      this.dialogService.openAlertGetMessage('E0113', ['ケース供給区分'], null);
    }

    // エラーフラグのチェック
    if (is_err) {														// エラーありの場合

      // 判定結果を初期化
      result = 'NG';
    } else {															// エラーなしの場合

      // 判定結果を初期化
      result = 'OK';
    }

    // 判定結果を返却
    return result;
  }


  /**
   * 入荷管理日数の条件必須チェック
   */
  public check_ArrivalAdminDays(): string {
    // 変数定義
    let is_err: number = <number>0;													// エラーフラグ(0:エラーなし、1:エラーあり)
    let result: string;													// 判定結果
    let consumeTerm: string;												// 賞味期間
    let arrivalAdminDays: string;										// 入荷管理日数

    // 各項目値を取得
    consumeTerm = this.kymw1100Model.consumeTerm;				// 賞味期間
    arrivalAdminDays = this.kymw1100Model.arrivalAdminDays;			// 入荷管理日数

    // 賞味期間のチェック
    if (this.isEmpty(consumeTerm)) {											// 未入力の場合

      // 判定結果(OK)を返却
      return 'OK';
    }

    // 「賞味期間」が1日以上14日以内の場合、「入荷管理日数」の未入力はエラーとする。
    // ※賞味期間がゼロ、未入力の場合を除く
    // ※入荷管理日数がゼロは入力扱いとする
    if (Number(consumeTerm) >= 1
      && Number(consumeTerm) <= 14) {
      // 入荷管理日数のチェック
      if (this.isEmpty(arrivalAdminDays)) {								// 未入力の場合

        is_err = 1;
        this.dialogService.openAlertGetMessage('E0110', ['入荷管理日数'], null);
      }

    }

    // エラーフラグのチェック
    if (is_err) {														// エラーありの場合

      // 判定結果を初期化
      result = 'NG';
    } else {																// エラーなしの場合

      // 判定結果を初期化
      result = 'OK';
    }

    // 判定結果を返却
    return result;
  }


  /**
   * 物流滞留日数の条件必須チェック
   */
  public check_PdPilingUpDays(): string {
    // 変数定義
    let is_err: number = <number>0;													// エラーフラグ(0:エラーなし、1:エラーあり)
    let result: string;													// 判定結果
    let consumeTerm: string;												// 賞味期間
    let pdPilingUpDays: string;											// 物流滞留日数

    // 各項目値を取得
    consumeTerm = this.kymw1100Model.consumeTerm;				// 賞味期間
    pdPilingUpDays = this.kymw1100Model.pdPilingUpDays;			// 物流滞留日数

    // 賞味期間のチェック
    if (this.isEmpty(consumeTerm)) {											// 未入力の場合

      // 判定結果(OK)を返却
      return 'OK';
    }

    // 「賞味期間」が1日以上の場合、「物流滞留日数」の未入力はエラーとする。
    // ※賞味期間がゼロ、未入力の場合を除く
    // ※物流滞留日数がゼロは入力扱いとする
    if (Number(consumeTerm) >= 1) {
      // 物流滞留日数のチェック
      if (this.isEmpty(pdPilingUpDays)) {								// 未入力の場合

        is_err = 1;
        this.dialogService.openAlertGetMessage('E0110', ['物流滞留日数'], null);
      }
    }

    // エラーフラグのチェック
    if (is_err) {															// エラーありの場合

      // 判定結果を初期化
      result = 'NG';
    } else {																// エラーなしの場合

      // 判定結果を初期化
      result = 'OK';
    }

    // 判定結果を返却
    return result;
  }


  /**
   * 在庫繰越区分・発注単位区分の妥当性チェック
   */
  public check_StockType(): string {
    // 変数定義
    let is_err: number = <number>0;													// エラーフラグ(0:エラーなし、1:エラーあり)
    let result: string;													// 判定結果
    let stockType: string;												// 在庫繰越区分
    let orderUnitType: string;											// 発注単位区分

    // 各項目値を取得
    stockType = this.cmb_StockTypeList.selectedCodeValue;		// 在庫繰越区分
    orderUnitType = this.cmb_OrderUnitType.selectedCodeValue;		// 発注単位区分

    // 以下の場合はエラーとする。
    // 在庫繰越区分が「0:繰越なし」、発注単位区分が「0:バラ」
    // 在庫繰越区分が「0:繰越なし」、発注単位区分が「1:ケースまたはボウル」
    // 在庫繰越区分が「0:繰越なし」、発注単位区分が「2:最終日バラ」
    // 在庫繰越区分が「1:曜日繰越」、発注単位区分が「3:当日精算バラ」
    // 在庫繰越区分が「1:曜日繰越」、発注単位区分が「4:当日精算ケース」
    // 在庫繰越区分が「1:曜日繰越」、発注単位区分が「5:当日精算最終日バラ」
    // 在庫繰越区分が「1:企画繰越」、発注単位区分が「3:当日精算バラ」
    // 在庫繰越区分が「1:企画繰越」、発注単位区分が「4:当日精算ケース」
    // 在庫繰越区分が「1:企画繰越」、発注単位区分が「5:当日精算最終日バラ」
    if (('0' === stockType && '0' === orderUnitType)					// 「0:繰越なし」、「0:バラ」
      || ('0' === stockType && '1' === orderUnitType)					// 「0:繰越なし」、「1:ケースまたはボウル」
      || ('0' === stockType && '2' === orderUnitType)) {					// 「0:繰越なし」、「2:最終日バラ」

      is_err = 1;
      this.dialogService.openAlertGetMessage('E0121', ['在庫繰越区分', '発注単位区分'], null);
    } else if (('1' === stockType && '3' === orderUnitType)				// 「1:曜日繰越」、「3:当日精算バラ」
      || ('1' === stockType && '4' === orderUnitType)				// 「1:曜日繰越」、「4:当日精算ケース」
      || ('1' === stockType && '5' === orderUnitType)) {				// 「1:曜日繰越」、「5:当日精算最終日バラ」

      is_err = 1;
      this.dialogService.openAlertGetMessage('E0121', ['在庫繰越区分', '発注単位区分'], null);
    } else if (('2' === stockType && '3' === orderUnitType)				// 「1:企画繰越」、「3:当日精算バラ」
      || ('2' === stockType && '4' === orderUnitType)				// 「1:企画繰越」、「4:当日精算ケース」
      || ('2' === stockType && '5' === orderUnitType)) {				// 「1:企画繰越」、「5:当日精算最終日バラ」

      is_err = 1;
      this.dialogService.openAlertGetMessage('E0121', ['在庫繰越区分', '発注単位区分'], null);
    }


    // エラーフラグのチェック
    if (is_err) {														// エラーありの場合

      // 判定結果を初期化
      result = 'NG';
    } else {															// エラーなしの場合

      // 判定結果を初期化
      result = 'OK';
    }

    // 判定結果を返却
    return result;
  }


  /**
   * 価格バンドルの妥当性チェック
   */
  public check_BundlePrice(): string {
    // 変数定義
    let is_err: number = <number>0;													// エラーフラグ(0:エラーなし、1:エラーあり)
    let result: string;													// 判定結果
    let bundlePrice: string;												// 価格バンドル

    // 各項目値を取得
    bundlePrice = this.kymw1100Model.bundlePrice;					// 価格バンドル

    // 「価格バンドル」が入力された場合、ゼロはエラー
    if (!this.isEmpty(bundlePrice) && Number(bundlePrice) === 0) {
      is_err = 1;
      this.dialogService.openAlertGetMessage('W0024', ['価格バンドル'], null);
    }

    // エラーフラグのチェック
    if (is_err) {															// エラーありの場合

      // 判定結果を初期化
      result = 'NG';
    } else {															// エラーなしの場合

      // 判定結果を初期化
      result = 'OK';
    }

    // 判定結果を返却
    return result;
  }


  /**
   * 文字列に値があるかどうかを判断する
   * [戻り値]true:空('') or null ／ false:値あり
   *
   * @param value 判定する文字列
   */
  public isEmpty(value: string): boolean {
    return PlessViewUtilsSub.isEmpty(value);
  }

  /**
   * 数値でないかどうかを判定する(String版)
   * [戻り値]true：数値ではない／false：数値
   *
     * @param value 判定する文字列
   */
  public isNaNString(value: string): boolean {
    return isNaN(Number(value));
  }

  /**
   * 商品削除処理。
   *
   * @param event 選択時イベント
   */
  public eventStatusDelete_CLICKHandler(): void {
    if (this.kymw1100Model.itemList.length <= 1) {
      this.dialogService.openAlertGetMessage('E0104');
    } else if (this.editFlag) {
      this.dialogService.openAlertGetMessage('Q0107', ['アイテム'],
        (closeEvent: any) => {
          if (closeEvent === PlessAlert.Yes) {
            this.statusDelete_Click();
          }
        });
    } else {
      this.dialogService.openAlertGetMessage('Q0106', ['アイテム'],
        (closeEvent: any) => {
          if (closeEvent === PlessAlert.Yes) {
            this.statusDelete_Click();
          }
        });
    }
  }

  /**
   * 「削除」実行
   */
  public statusDelete_Click(): void {

    // PCodeがある時
    const vo: Array<any> = new Array<any>();

    vo[0] = this.kymw1100Model.pCode;
    vo[1] = this.kymw1100Model.itemCode;

    this.deleteGoodsDetailService.execute(this.kymw1100Model, vo);
  }

  /**
   * 部門コードComboBoxを押した時の処理。
   *
   * @param event 選択時イベント
   */
  public eventClassCodeComboBoxHandler(): void {
    // 利用生協タブの産地コメント制御
    this.coopListConsignPriceSpecial();
  }

  /**
   * 小分類コードComboBoxを変更した場合の処理。
   *
   * @param event 選択時イベント
   */
  public eventSmallClassCodeComboBoxHandler(): void {
    // 取扱期間（開始）が入力あり、部門コードが入力あり、小分類コードが入力ありの場合
    if (!PlessViewUtilsSub.isEmpty(this.kymw1100Model.appkyTermStart)
      && !PlessViewUtilsSub.isEmpty(this.cmb_ClassCode.selectedClassCode)
      && !PlessViewUtilsSub.isEmpty(this.cmb_SmallClassCodeList.selectedSmallClassCode)) {
      const vo: Array<any> = new Array<any>();
      vo[0] = this.cmb_ClassCode.selectedClassCode;
      vo[1] = this.kymw1100Model.appkyTermStart;
      vo[2] = this.cmb_SmallClassCodeList.selectedSmallClassCode;

      this.getConsumeTaxInfoService.execute(this.kymw1100Model, vo);
    }
  }

  /**
   * 利用生協タブの産地コメント定義
   * 【部門コードComboBoxを押した時の処理。】
   * 【アイテムコードComboBoxを押した時の処理。】
   *  部門コードが農産【01】の場合入力可能、農産以外の場合入力不可。
   */
  public coopListConsignPriceSpecial(): void {
    const classCode = this.checkClassCode();

    const coopClassCodeCheck: Array<any> = this.kymw1100Model.coopInfoListScreen;

    let vo: any;
    const markList32: Array<any> = new Array<any>();
    if (coopClassCodeCheck != null) {
      for (let i = Number(0); i < coopClassCodeCheck.length; i++) {
        if (coopClassCodeCheck[i].Check && classCode) {
          vo = {
            Check: coopClassCodeCheck[i].Check,
            CoopCode: coopClassCodeCheck[i].CoopCode,
            CoopName: coopClassCodeCheck[i].CoopName,
            CoopShortName: coopClassCodeCheck[i].CoopShortName,
            SupplyPriceStandard: coopClassCodeCheck[i].SupplyPriceStandard,
            SupplyPriceSpecial1: coopClassCodeCheck[i].SupplyPriceSpecial1,
            SupplyPriceSpecial2: coopClassCodeCheck[i].SupplyPriceSpecial2,
            SupplyTaxWithStd: (this.kymw1100Model.getConsumePrice(coopClassCodeCheck[i].SupplyPriceStandard.toString())),
            SupplyTaxWithSpc1: (this.kymw1100Model.getConsumePrice(coopClassCodeCheck[i].SupplyPriceSpecial1.toString())),
            SupplyTaxWithSpc2: (this.kymw1100Model.getConsumePrice(coopClassCodeCheck[i].SupplyPriceSpecial2.toString())),
            CostPriceStandard: coopClassCodeCheck[i].CostPriceStandard,
            CostPriceSpecial1: coopClassCodeCheck[i].CostPriceSpecial1,
            CostPriceSpecial2: coopClassCodeCheck[i].CostPriceSpecial2,
            ConsignPriceStandard: coopClassCodeCheck[i].ConsignPriceStandard,
            ConsignPriceSpecial1: coopClassCodeCheck[i].ConsignPriceSpecial1,
            ConsignPriceSpecial2: coopClassCodeCheck[i].ConsignPriceSpecial2,
            ProducingAreaComment1: (this.producingAreaComment(coopClassCodeCheck[i].ProducingAreaComment1.toString())),
            ProducingAreaComment2: (this.producingAreaComment(coopClassCodeCheck[i].ProducingAreaComment2.toString())),
            Enabled: coopClassCodeCheck[i].Enabled,
            ClassCode: classCode,
          };

          markList32.push(vo);
        } else {
          vo = {
            Check: coopClassCodeCheck[i].Check,
            CoopCode: coopClassCodeCheck[i].CoopCode,
            CoopName: coopClassCodeCheck[i].CoopName,
            CoopShortName: coopClassCodeCheck[i].CoopShortName,
            SupplyPriceStandard: coopClassCodeCheck[i].SupplyPriceStandard,
            SupplyPriceSpecial1: coopClassCodeCheck[i].SupplyPriceSpecial1,
            SupplyPriceSpecial2: coopClassCodeCheck[i].SupplyPriceSpecial2,
            SupplyTaxWithStd: (this.kymw1100Model.getConsumePrice(coopClassCodeCheck[i].SupplyPriceStandard.toString())),
            SupplyTaxWithSpc1: (this.kymw1100Model.getConsumePrice(coopClassCodeCheck[i].SupplyPriceSpecial1.toString())),
            SupplyTaxWithSpc2: (this.kymw1100Model.getConsumePrice(coopClassCodeCheck[i].SupplyPriceSpecial2.toString())),
            CostPriceStandard: coopClassCodeCheck[i].CostPriceStandard,
            CostPriceSpecial1: coopClassCodeCheck[i].CostPriceSpecial1,
            CostPriceSpecial2: coopClassCodeCheck[i].CostPriceSpecial2,
            ConsignPriceStandard: coopClassCodeCheck[i].ConsignPriceStandard,
            ConsignPriceSpecial1: coopClassCodeCheck[i].ConsignPriceSpecial1,
            ConsignPriceSpecial2: coopClassCodeCheck[i].ConsignPriceSpecial2,
            ProducingAreaComment1: '',
            ProducingAreaComment2: '',
            Enabled: coopClassCodeCheck[i].Enabled,
            ClassCode: classCode,
          };

          markList32.push(vo);
        }
      }

      this.kymw1100Model.viewUpdateSelectedCoopInfoList(markList32);
    } else {
      this.kymw1100Model.viewUpdateSelectedCoopInfoList(null);
    }
  }

  /**
   * 産地コメント１が【農産01】活性
   * 産地コメント２が【農産以外】非活性
   */
  public checkClassCode(): boolean {
    if (this.cmb_ClassCode?.selectedClassCode !== '01') {
      return false;
    }
    return true;
  }

  /**
   * 産地コメント１が未設定の場合、「★★★★★★★★★★」を設定する。
   * 産地コメント２が未設定の場合、「★★★★★★★★★★」を設定する。
   */
  public producingAreaComment(goodsListing: string): string {
    if (PlessViewUtilsSub.isEmpty(goodsListing)) {
      return '★★★★★★★★★★';
    }
    return goodsListing;
  }

  /**
   * 包材一括表示確認済のチェック処理。
   *
   * @param event 選択時イベント
   */
  public eventPackMaterialShowFlgHandler(): void {
    if (this.kymw1100Model.packMaterialShowFlg) {
      this.rdb_AdmitStatus2.disabled = false;
    } else {
      this.rdb_AdmitStatus2.disabled = true;
      this.kymw1100Model.admitStatus = '1';
      this.eventAdmitStatus0Handler();
    }
  }
  /**
   * 取扱期間(開始)ボタンイベント
   * 「消費税区分」、「消費税率」が未入力の場合、
   * 「部門コード」を基に消費税率を決定し、「消費税区分」と「消費税率」にセットする。
   * @param event 選択時イベント
   */
  public eventAppkyTermStart_CLICKHandler(): void {

    // 取扱期間（開始）が入力あり、部門コードが入力あり、小分類コードが入力ありの場合
    if (!PlessViewUtilsSub.isEmpty(this.kymw1100Model.appkyTermStart)
      && !PlessViewUtilsSub.isEmpty(this.cmb_ClassCode.selectedClassCode)
      && !PlessViewUtilsSub.isEmpty(this.cmb_SmallClassCodeList.selectedSmallClassCode)) {
      const vo: Array<any> = new Array<any>();
      vo[0] = this.cmb_ClassCode.selectedClassCode;
      vo[1] = this.kymw1100Model.appkyTermStart;
      vo[2] = this.cmb_SmallClassCodeList.selectedSmallClassCode;

      this.getConsumeTaxInfoService.execute(this.kymw1100Model, vo);
    }

    // 日付けチェック。
    if (!this.kymw1100Model.endFlag) {
      if (this.isEmpty(this.kymw1100Model.appkyTermStart)
        || this.isEmpty(this.kymw1100Model.appkyTermEnd)) {
        return;
      } else if (this.kymw1100Model.appkyTermStart > this.kymw1100Model.appkyTermEnd) {
        this.dialogService.openAlertGetMessage('E0123', ['取扱期間'],
          (closeEvent: any) => {
            if (closeEvent === PlessAlert.Yes_Error) {
              this.kymw1100Model.appkyTermStart = null;
            }
          });
      }
    }
  }

  /**
   * 取扱期間(終了)ボタンを押下した時に呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   */
  public eventAppkyTermEnd_CLICKHandler(): void {
    if (this.isEmpty(this.kymw1100Model.appkyTermStart)
      || this.isEmpty(this.kymw1100Model.appkyTermEnd)) {
      return;
    } else if (this.kymw1100Model.appkyTermStart > this.kymw1100Model.appkyTermEnd) {
      this.dialogService.openAlertGetMessage('E0123', ['取扱期間'],
        (closeEvent: any) => {
          if (closeEvent === PlessAlert.Yes_Error) {
            this.kymw1100Model.appkyTermEnd = null;
          }
        });
    }
  }

  /**
   * 終了指定なしのチェック処理。
   *
   * @param event 選択時イベント
   */
  public eventEndFlagHandler(): void {
    if (this.kymw1100Model.endFlag) {
      // 日付入力を非活性にする(カレンダーのみ有効)
      this.dtf_AppkyTermEnd.isDisabled = true;
      this.kymw1100Model.appkyTermEnd = null;
      this.dtf_AppkyTermEnd.hostElement.tabIndex = -1;
    } else {
      this.dtf_AppkyTermEnd.isDisabled = false;
      this.dtf_AppkyTermEnd.hostElement.tabIndex = 0;
    }
  }

  /**
   * 季節消費期限の範囲を使用するかどうか判断する。
   *
   * @param event 選択時イベント
   */
  public eventSeasonConsumeDivHandler(): void {
    if (this.kymw1100Model.seasonConsumeDiv) {
      this.txti_SeasonConsumeTerm.nativeElement.disabled = false;
      this.dtf_SeasonConsumeTermFrom.isDisabled = false;
      this.dtf_SeasonConsumeTermTo.isDisabled = false;
      this.dtf_SeasonConsumeTermFrom.hostElement.tabIndex = 0;
      this.dtf_SeasonConsumeTermTo.hostElement.tabIndex = 0;
    } else {
      // 日付入力を非活性にする(カレンダーのみ有効)
      this.txti_SeasonConsumeTerm.nativeElement.disabled = true;
      this.dtf_SeasonConsumeTermFrom.isDisabled = true;
      this.dtf_SeasonConsumeTermTo.isDisabled = true;
      this.kymw1100Model.seasonConsumeTerm = '';
      this.kymw1100Model.seasonConsumeTermFrom = null;
      this.kymw1100Model.seasonConsumeTermTo = null;
    }
  }

  /**
   * 承認状況よる利用生協の処理。
   * eBASE取込後 = 0 活性
   * 仮登録 = 1 活性
   * @param event 選択時イベント
   */
  public eventAdmitStatus0Handler(): void {
    if (this.rdb_AdmitStatus0.disabled || this.rdb_AdmitStatus1.disabled) {
      const coopEnabledCheck: Array<any> = this.kymw1100Model.coopInfoListScreen;
      const markList32: Array<any> = new Array<any>();
      if (coopEnabledCheck != null) {
        for (let i = Number(0); i < coopEnabledCheck.length; i++) {
          const vo = {
            Check: coopEnabledCheck[i].Check,
            CoopCode: coopEnabledCheck[i].CoopCode,
            CoopName: coopEnabledCheck[i].CoopName,
            CoopShortName: coopEnabledCheck[i].CoopShortName,
            SupplyPriceStandard: coopEnabledCheck[i].SupplyPriceStandard,
            SupplyPriceSpecial1: coopEnabledCheck[i].SupplyPriceSpecial1,
            SupplyPriceSpecial2: coopEnabledCheck[i].SupplyPriceSpecial2,
            SupplyTaxWithStd: this.kymw1100Model.getConsumePrice(coopEnabledCheck[i].SupplyPriceStandard.toString()),
            SupplyTaxWithSpc1: this.kymw1100Model.getConsumePrice(coopEnabledCheck[i].SupplyPriceSpecial1.toString()),
            SupplyTaxWithSpc2: this.kymw1100Model.getConsumePrice(coopEnabledCheck[i].SupplyPriceSpecial2.toString()),
            CostPriceStandard: coopEnabledCheck[i].CostPriceStandard,
            CostPriceSpecial1: coopEnabledCheck[i].CostPriceSpecial1,
            CostPriceSpecial2: coopEnabledCheck[i].CostPriceSpecial2,
            ConsignPriceStandard: coopEnabledCheck[i].ConsignPriceStandard,
            ConsignPriceSpecial1: coopEnabledCheck[i].ConsignPriceSpecial1,
            ConsignPriceSpecial2: coopEnabledCheck[i].ConsignPriceSpecial2,
            ProducingAreaComment1: coopEnabledCheck[i].ProducingAreaComment1,
            ProducingAreaComment2: coopEnabledCheck[i].ProducingAreaComment2,
            Enabled: 0,
            ClassCode: coopEnabledCheck[i].ClassCode,
          };

          markList32.push(vo);
        }
        this.kymw1100Model.viewUpdateSelectedCoopInfoList(markList32);
      } else {
        this.kymw1100Model.viewUpdateSelectedCoopInfoList(null);
      }
    }
  }

  /**
   * 承認状況よる利用生協の処理。
   * 本登録のラジオボタンを押した時
   * @param event 選択時イベント
   */
  public eventAdmitStatus2Handler(): void {
    this.kymw1100Model.admitStatus = '2';

    // 利用生協タブのCheckBoxを非活性か活性するか判断する。
    this.eventCoopListEnabled();
  }

  /**
   * 承認状況よる利用生協の処理。
   * 利用生協タブのCheckBoxを非活性か活性するか判断する。
   */
  public eventCoopListEnabled(): void {
    const coopEnabledCheck: Array<any> = this.kymw1100Model.coopInfoListScreen;

    if (coopEnabledCheck != null) {
      if (this.rdb_AdmitStatus2.disabled) {
        let vo: any;
        const markList32: Array<any> = new Array<any>();
        for (let i = Number(0); i < coopEnabledCheck.length; i++) {
          if (coopEnabledCheck[i].Check) {
            vo = {
              Check: coopEnabledCheck[i].Check,
              CoopCode: coopEnabledCheck[i].CoopCode,
              CoopName: coopEnabledCheck[i].CoopName,
              CoopShortName: coopEnabledCheck[i].CoopShortName,
              SupplyPriceStandard: coopEnabledCheck[i].SupplyPriceStandard,
              SupplyPriceSpecial1: coopEnabledCheck[i].SupplyPriceSpecial1,
              SupplyPriceSpecial2: coopEnabledCheck[i].SupplyPriceSpecial2,
              SupplyTaxWithStd: (this.kymw1100Model.getConsumePrice(coopEnabledCheck[i].SupplyPriceStandard.toString())),
              SupplyTaxWithSpc1: (this.kymw1100Model.getConsumePrice(coopEnabledCheck[i].SupplyPriceSpecial1.toString())),
              SupplyTaxWithSpc2: (this.kymw1100Model.getConsumePrice(coopEnabledCheck[i].SupplyPriceSpecial2.toString())),
              CostPriceStandard: coopEnabledCheck[i].CostPriceStandard,
              CostPriceSpecial1: coopEnabledCheck[i].CostPriceSpecial1,
              CostPriceSpecial2: coopEnabledCheck[i].CostPriceSpecial2,
              ConsignPriceStandard: coopEnabledCheck[i].ConsignPriceStandard,
              ConsignPriceSpecial1: coopEnabledCheck[i].ConsignPriceSpecial1,
              ConsignPriceSpecial2: coopEnabledCheck[i].ConsignPriceSpecial2,
              ProducingAreaComment1: coopEnabledCheck[i].ProducingAreaComment1,
              ProducingAreaComment2: coopEnabledCheck[i].ProducingAreaComment2,
              Enabled: 2,
              ClassCode: coopEnabledCheck[i].ClassCode,
            };
            markList32.push(vo);
          } else {
            vo = {
              Check: coopEnabledCheck[i].Check,
              CoopCode: coopEnabledCheck[i].CoopCode,
              CoopName: coopEnabledCheck[i].CoopName,
              CoopShortName: coopEnabledCheck[i].CoopShortName,
              SupplyPriceStandard: coopEnabledCheck[i].SupplyPriceStandard,
              SupplyPriceSpecial1: coopEnabledCheck[i].SupplyPriceSpecial1,
              SupplyPriceSpecial2: coopEnabledCheck[i].SupplyPriceSpecial2,
              SupplyTaxWithStd: (this.kymw1100Model.getConsumePrice(coopEnabledCheck[i].SupplyPriceStandard.toString())),
              SupplyTaxWithSpc1: (this.kymw1100Model.getConsumePrice(coopEnabledCheck[i].SupplyPriceSpecial1.toString())),
              SupplyTaxWithSpc2: (this.kymw1100Model.getConsumePrice(coopEnabledCheck[i].SupplyPriceSpecial2.toString())),
              CostPriceStandard: coopEnabledCheck[i].CostPriceStandard,
              CostPriceSpecial1: coopEnabledCheck[i].CostPriceSpecial1,
              CostPriceSpecial2: coopEnabledCheck[i].CostPriceSpecial2,
              ConsignPriceStandard: coopEnabledCheck[i].ConsignPriceStandard,
              ConsignPriceSpecial1: coopEnabledCheck[i].ConsignPriceSpecial1,
              ConsignPriceSpecial2: coopEnabledCheck[i].ConsignPriceSpecial2,
              ProducingAreaComment1: coopEnabledCheck[i].ProducingAreaComment1,
              ProducingAreaComment2: coopEnabledCheck[i].ProducingAreaComment2,
              Enabled: 0,
              ClassCode: coopEnabledCheck[i].ClassCode,
            };
            markList32.push(vo);
          }
        }
        this.kymw1100Model.viewUpdateSelectedCoopInfoList(markList32);
      }
    } else {
      this.kymw1100Model.viewUpdateSelectedCoopInfoList(null);
    }
  }


  /**
   * 商品名(漢字)を入力後、お届け明細書用商品名(漢字)とOCR商品名が空ならば、
   * 先頭最大文字をコピーする。(親切機能)
   */
  public eventGuideGoodsNameHandler(event: any): void {
    if (this.isEmpty(this.kymw1100Model.deliveryGoodsNameKanji)) {
      this.kymw1100Model.deliveryGoodsNameKanji = event.target.value.substr(0, 15);
    }
    if (this.isEmpty(this.kymw1100Model.ocrGoodsName)) {
      this.kymw1100Model.ocrGoodsName = event.currentTarget.value.substr(0, 16);
    }
  }

  /**
   * 企画名(漢字)を入力後、お届け明細書用規格名(漢字)が空ならば、
   * 先頭最大文字をコピーする。(親切機能)
   */
  public eventGuideStandardNameHandler(event: any): void {
    if (this.isEmpty(this.kymw1100Model.deliveryStandardNameKanji)) {
      this.kymw1100Model.deliveryStandardNameKanji = event.target.value.substr(0, 10);
    }
  }


  /**
   * 消費税区分と消費税率を変更し、画面表示する
   */
  public setConsumeDivAndTax(consumeTaxDivList: string, consumeTaxDivRate: string): void {
    if (consumeTaxDivList != null) {
      this.cmb_ConsumeTaxDivList.setCodeValue(consumeTaxDivList);
    }
    if (consumeTaxDivRate != null) {
      this.kymw1100Model.consumeTaxDivRateScreen = consumeTaxDivRate;
    }

    // 利用生協タブの消費税区分と消費税率の画面反映
    this.updateUseCoopConsumeDivAndTax();
  }

  /**
   * 利用生協タブの消費税区分と消費税率の結合テキストを作成し、画面反映する。
   */
  public updateUseCoopConsumeDivAndTax(): void {
    let text: string = <string>'';

    text = this.cmb_ConsumeTaxDivList.selectedCodeValueName;
    if (!PlessViewUtilsSub.isEmpty(this.kymw1100Model.consumeTaxDivRateScreen)) {
      text += '　' + this.kymw1100Model.consumeTaxDivRateScreen + '%';
    }
    this.kymw1100Model.consumeMessage = text;
  }

  /**
   * 利用生協の価格表カラムラベルの変更処理
   *
   */
  public updateUseCoopInfoListColumnHeader(): void {
    if (this.kymw1100Model.consumeTaxDivList === '0') {
      this.coopHeaderPreText = '本体';
    } else {
      this.coopHeaderPreText = '総額';
    }
  }

  /**
   * 消費税区分入力後、消費税メッセージに、
   * 先頭最大文字をコピーする。(親切機能)
   * 消費税区分が変更時、税込価格の再計算
   */
  public eventConsumeTaxDivList(): void {
    // 税率区分と税率の表示更新
    this.setConsumeDivAndTax(this.cmb_ConsumeTaxDivList.selectedCodeValue, null);

    // 税率区分、税率の画面表示内容を保存
    this.kymw1100Model.saveConsumeTaxDivAndRate();

    // 利用生協タブの価格表をローカルに保存する。
    this.kymw1100Model.savedCoopConsumeTaxPrice();

    // 利用生協タブの価格表カラムヘッダー名更新
    this.updateUseCoopInfoListColumnHeader();

    // 税込価格計算定義
    this.kymw1100Model.setConsumeTaxPrice(this.kymw1100Model.getEditCoopInfoList());

    // 入力されている消費税区分が空の場合
    if (PlessViewUtilsSub.isEmpty(this.cmb_ConsumeTaxDivList.selectedCodeDiv)) {
      // 消費税区分が「01：増税まえ」の場合
      if (this.kymw1100Model.isSelectedRateChangeMaster()) {
        this.kymw1100Model.consumeTaxDivList = '';
      } else {
        // 消費税区分が「02：増税あと」の場合
        this.kymw1100Model.consumeTaxDivWk = '';
      }
    }
  }

  /**
   * 消費税率入力後、消費税メッセージに、
   * 先頭最大文字をコピーする。(親切機能)
   * 消費税率変更時、税込価格の再計算を行う。
   */
  public eventConsumeTaxDivRate(event: any): void {
    // 税率区分と税率の表示更新
    this.setConsumeDivAndTax(null, event.target.value.substr(0, 10));

    // 税率区分、税率の画面表示内容を保存
    this.kymw1100Model.saveConsumeTaxDivAndRate();

    // 利用生協タブの価格表をローカルに保存する。
    this.kymw1100Model.savedCoopConsumeTaxPrice();

    // 表示している税率切り替え区分を保存する
    this.kymw1100Model.setSelectedRateChange(this.cmb_RatechangeBox.selectedCodeValue);

    // 税込価格計算定義
    this.kymw1100Model.setConsumeTaxPrice(this.kymw1100Model.getEditCoopInfoList());

    // 入力されている消費税率が空の場合
    if (PlessViewUtilsSub.isEmpty(this.kymw1100Model.consumeTaxDivRateScreen)) {
      // 消費税区分が「01：増税まえ」の場合
      if (this.kymw1100Model.isSelectedRateChangeMaster()) {
        this.kymw1100Model.consumeTaxDivRate = '';
      } else {
        // 消費税区分が「02：増税あと」の場合
        this.kymw1100Model.consumeTaxRateWk = '';
      }
    }

    let def_Rate: string;									// 小分類に紐づくデフォルト消費税率
    let txt_Rate: string;												// 画面で入力された消費税率

    // 表示中の消費税区分のチェック
    if (this.kymw1100Model.selectedRateChange === '01') {					// マスタ画面の場合

      def_Rate = this.kymw1100Model.def_ConsumeTaxRate;			// 小分類に紐づくデフォルト消費税率
      txt_Rate = this.kymw1100Model.consumeTaxDivRate;			// 画面で入力された消費税率
    } else {															// ワーク画面の場合

      def_Rate = this.kymw1100Model.def_ConsumeTaxRate_2;			// 小分類に紐づくデフォルト消費税率
      txt_Rate = this.kymw1100Model.consumeTaxRateWk;				// 画面で入力された消費税率
    }

    // デフォルト消費税率と入力された消費税率のチェック
    if (!PlessViewUtilsSub.isEmpty(txt_Rate) && def_Rate !== txt_Rate) {		// デフォルトあり、値が異なる場合

      // フォーカスを移動する。
      this.txti_DeliveryGoodsNameKanji.input.nativeElement.focus();
      // メッセージを表示する。（メッセージID：I0110）
      this.dialogService.openAlertGetMessage('I0110');

      return;
    }

  }
  /**
   * 年を取得してカレンダーにセットする。
   */
  public eventSeasonConsumeTermHandler(event: any): void {
    const now: Date = new Date();

    event.target.displayedYear = now.getFullYear;
  }

  /**
* 『関連商品設定』画面を呼び出し、関連商品の設定を行う。
* ・関連商品設定インプットVOを作成し、『関連商品設定』画面を呼び出す。
* ・戻り情報より「関連Ｐコード（旧）」及び「関連Ｐコード（新）」をセットする。
*/
  public eventRelationPcode_CLICKHandler(): void {
    if (this.kymw0600InputVO === null) {
      this.kymw0600InputVO = new KYMW0600InputModel();
    }

    this.kymw0600InputVO.pCode = this.kymw1100Model.pCode;
    // 関連商品画面を起動
    const componentRef = this.dialogService.openModal(KYMW0600Component);
    const instance = componentRef.componentInstance as KYMW0600Component;
    instance.parent = this;
    instance.setInterfaceParam(this.kymw0600InputVO);
    instance.setKYMW0600Parameter = (outputVO: KYMW0600OutputModel) => this.setKYMW0600Parameter(outputVO);
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  public setKYMW0600Parameter(outputVO: KYMW0600OutputModel): void {
    if (!this.isEmpty(outputVO.relationPCodeOld)
      && this.kymw1100Model.relationPcodeOld !== outputVO.relationPCodeOld) {
       // タグ情報取得を実行
       this.getOldGoodsTagListService.execute(this.kymw1100Model, outputVO.relationPCodeOld);
    }

    this.kymw1100Model.relationPcodeOld = outputVO.relationPCodeOld;
    this.kymw1100Model.relationPcodeNew = outputVO.relationPCodeNew;
  }

  /**
   * 『文字情報選択』画面を呼び出す。
   * ・文字情報登録明細VOを作成し、『文字情報選択』画面を呼び出す。
   * 『文字情報選択』画面で選択された文字列を表示する。
   */
  public eventTextInfo_CLICKHandler(event: any): void {

    const componentRef = this.dialogService.openModal(KYMW0700Component);
    const instance = componentRef.componentInstance as KYMW0700Component;
    instance.parent = this;


    if (this.kymw0700InputVO === null) {
      this.kymw0700InputVO = new KYMW0700InputModel();
    }

    if (event.target.id === 'lnb_TextInfo1') {
      this.kymw0700InputVO.textKindId = '001';
    } else if (event.target.id === 'lnb_TextInfo2') {
      this.kymw0700InputVO.textKindId = '004';
    } else if (event.target.id === 'lnb_TextInfo3') {
      this.kymw0700InputVO.textKindId = '018';
    } else if (event.target.id === 'lnb_TextInfo8') {
      this.kymw0700InputVO.textKindId = '024';
    } else if (event.target.id === 'lnb_TextInfo9') {
      this.kymw0700InputVO.textKindId = '003';
    } else if (event.target.id === 'lnb_LicencedDescription') {
      this.kymw0700InputVO.textKindId = '033';
    }

    this.kymw0700InputVO.goodsCode = this.kymw1100Model.pCode;
    this.kymw0700InputVO.goodsName = this.kymw1100Model.guideGoodsName;
    this.kymw0700InputVO.guideGoodsName = this.kymw1100Model.guideStandardName;

    instance.setInterfaceParam(this.kymw0700InputVO);
    instance.setKYMW0700Parameter = (outputVO: KYMW0700OutputModel) => this.setKYMW0700Parameter(outputVO);

    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  public setKYMW0700Parameter(outputVO: KYMW0700OutputModel): void {
    switch (outputVO.textKindId) {
      case '001':
        this.kymw1100Model.textInfo1 = outputVO.stringValue;
        this.kymw1100Model.textInfoCnt1 = outputVO.textInfoCnt;
        break;
      case '004':
        this.kymw1100Model.textInfo2 = outputVO.stringValue;
        this.kymw1100Model.textInfoCnt2 = outputVO.textInfoCnt;
        break;
      case '018':
        this.kymw1100Model.textInfo3 = outputVO.stringValue;
        this.kymw1100Model.textInfoCnt3 = outputVO.textInfoCnt;
        break;
      case '024':
        this.kymw1100Model.textInfo8 = outputVO.stringValue;
        this.kymw1100Model.textInfoCnt8 = outputVO.textInfoCnt;
        break;
      case '003':
        this.kymw1100Model.textInfo9 = outputVO.stringValue;
        this.kymw1100Model.textInfoCnt9 = outputVO.textInfoCnt;
        break;
      case '033':
        this.kymw1100Model.licencedDescription = outputVO.stringValue;
        this.kymw1100Model.licencedDescriptionCnt = outputVO.textInfoCnt;
        break;
    }

    this.eventEditHandler();
  }

  /**
   * NGワードチェックを行う。
   */
  public eventTextInfo_FOCUSOUTHandler(event: any): void {
    if (PlessViewUtilsSub.trimDirection(event.target.value, 1)) {
      const vo = {
        itemName: '',
        string: event.target.value
      };

      if (event.target.id === 'txta_TextInfo4_sub') {
        vo.itemName = '便利情報(囲み)';
      } else if (event.target.id === 'txta_TextInfo5_sub') {
        vo.itemName = '便利情報(商品構成内容)';
      } else if (event.target.id === 'txta_TextInfo6_sub') {
        vo.itemName = '便利情報(その他)';
      } else if (event.target.id === 'txta_TextInfo7_sub') {
        vo.itemName = '便利情報(eフレンズ)';
      } else if (event.target.id === 'txta_TextInfo10_sub') {
        vo.itemName = 'EC用商品説明';
      } else if (event.target.id === 'txta_TextInfo11_sub') {
        vo.itemName = '月齢情報';
      } else if (event.target.id === 'txta_TextInfo12_sub') {
        vo.itemName = '健康管理情報';
      } else if (event.target.id === 'txta_TextInfo13_sub') {
        vo.itemName = '成分情報';
      } else if (event.target.id === 'txta_TextInfo14_sub') {
        vo.itemName = '吸水量';
      } else if (event.target.id === 'txta_TextInfo15_sub') {
        vo.itemName = '調理時間の目安';
      } else if (event.target.id === 'txta_TextInfo16_sub') {
        vo.itemName = '○人前情報';
      } else if (event.target.id === 'txta_TextInfo17_sub') {
        vo.itemName = '材料';
      } else if (event.target.id === 'txta_TextInfo18_sub') {
        vo.itemName = 'ご家庭で用意いただくもの';
      } else if (event.target.id === 'txta_TextInfo19_sub') {
        vo.itemName = '人気商品情報';
      }

      this.checkNgWordsService.execute(this.kymw1100Model, vo);

    } else {
      event.target.value = '';
    }
  }

  /**
   * 仕分温度帯ComboBoxを押した時の処理。
   * ①「00：冷凍」の場合
   * 「物流滞留日数」に"2"、「入荷許可品温」に"-10"を設定する。
   * ②「01：冷蔵」の場合
   * 「物流滞留日数」に"1"、「入荷許可品温」に"10"を設定する。
   * ③「02：常温」の場合
   * 「物流滞留日数」に"2"、「入荷許可品温」をクリアをする。
   * @param event 選択時イベント
   */
  public eventAssortTempdivListHandler(): void {
    const assortTempdiv: string = this.kymw1100Model.assortTempdivList;

    if (PlessViewUtilsSub.isEmpty(this.kymw1100Model.pdPilingUpDays)) {
      if (PlessViewUtilsSub.trim(assortTempdiv) === '00') {
        this.kymw1100Model.pdPilingUpDays = '2';
      } else if (PlessViewUtilsSub.trim(assortTempdiv) === '01') {
        this.kymw1100Model.pdPilingUpDays = '1';
      } else if (PlessViewUtilsSub.trim(assortTempdiv) === '02') {
        this.kymw1100Model.pdPilingUpDays = '2';
      }
    }

    if (PlessViewUtilsSub.isEmpty(this.kymw1100Model.arrivalGoodsTemp)) {
      if (PlessViewUtilsSub.trim(assortTempdiv) === '00') {
        this.kymw1100Model.arrivalGoodsTemp = '-10';
      } else if (PlessViewUtilsSub.trim(assortTempdiv) === '01') {
        this.kymw1100Model.arrivalGoodsTemp = '10';
      }
    }
  }

  /**
   * 印刷ボタン処理。
   *
   * @param event 選択時イベント
   */
  public eventPrint_CLICKHandler() {
    const kymw1102ComponentRef = this.dialogService.openModal(KYMW1102Component);
    const instance = kymw1102ComponentRef.componentInstance as KYMW1102Component;
    instance.parent = this;
    instance.closeFunction = () => {
      kymw1102ComponentRef.close();
    };
  }
  /**
   * 画像確認ボタン押下イベント
   *
   * @param event 選択時イベント
   */
  public eventImage_CLICKHandler(): void {
    if (PlessViewUtilsSub.isEmpty(this.kymw1100Model.pCode)) {
      this.dialogService.openAlertGetMessage('E0109');
      return;
    }

    this.kymw1600InputVO = new KYMW1600InputModel();
    this.kymw1600InputVO.pcode = this.kymw1100Model.pCode;
    // // 画像確認画面を起動
    const componentRef = this.dialogService.openModal(KYMW1600Component);
    const instance = componentRef.componentInstance as KYMW1600Component;
    instance.dispDialog = true; 
    instance.parent = this;
    instance.setInterfaceParam(this.kymw1600InputVO);
    instance.closeFunction = () => {
      componentRef.close();
    };
  }
  /**
   * 画像作成ボタン押下イベント
   *
   * @param event 選択時イベント
   */
  public eventImage2_CLICKHandler(): void {
    if (PlessViewUtilsSub.isEmpty(this.kymw1100Model.pCode)) {
      this.dialogService.openAlertGetMessage('E0109');
      return;
    }

    // 画像作成指示画面を呼び出す（編集モード）
    const kymw0C00InputVO: KYMW0C00InputModel = new KYMW0C00InputModel();
    kymw0C00InputVO.ProcessDiv = 1;
    kymw0C00InputVO.pcode = this.kymw1100Model.pCode;
    // // 画像作成画面を起動
    const componentRef = this.dialogService.openModal(KYMW0C00Component);
    const instance = componentRef.componentInstance as KYMW0C00Component;
    instance.parent = this;
    instance.setInterfaceParam(kymw0C00InputVO);
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 税率切替ボタンのイベント処理。
   *
   * @param event 選択時イベント
   */
  public eventRateChange_CLICKHandler(): void {
    let consumeTaxDivRate: string = <string>'';
    let consumeTaxDivList: string = <string>'';

    if (this.cmb_RatechangeBox.selectedCodeValue === '01') {
      consumeTaxDivList = this.kymw1100Model.consumeTaxDivList;
      consumeTaxDivRate = this.kymw1100Model.consumeTaxDivRate;
    } else if (this.cmb_RatechangeBox.selectedCodeValue === '02') {
      consumeTaxDivList = this.kymw1100Model.consumeTaxDivWk;
      consumeTaxDivRate = this.kymw1100Model.consumeTaxRateWk;
    }

    // 現在の利用生協の価格表を保存する
    this.kymw1100Model.savedCoopConsumeTaxPrice();

    // 税率区分と税率の表示更新
    this.setConsumeDivAndTax(consumeTaxDivList, consumeTaxDivRate);

    // 表示している税率切り替え区分を保存する
    this.kymw1100Model.setSelectedRateChange(this.cmb_RatechangeBox.selectedCodeValue);

    // 税込価格計算定義
    this.kymw1100Model.setConsumeTaxPrice(this.kymw1100Model.getEditCoopInfoList());
  }

  /**
   * ItemCodeComboBoxのイベント処理。
   *
   * @param event 選択時イベント
   */
  public eventItemCode_CHANGEHandler(event: any): void {
    // 「閲覧モードではない」かつ「排他失敗(他ユーザがロック)モードではない」かつ「内容が変更されている」時は確認メッセージを表示
    if (!this.isDispOnlyModeOrLockMode() && this.editFlag) {
      this.dialogService.openAlertGetMessage('Q0107', ['商品情報'],
        (closeEvent: any) => {
          if (closeEvent === PlessAlert.Yes) {
            this.itemCodeChang(event.target.value);
          } else if (closeEvent === PlessAlert.No) {
            this.cmb_ItemCode.nativeElement.selectedIndex = this.kymw1100Model.itemCode;
          }
        });
    } else {
      this.itemCodeChang(event.target.value);
    }
  }

  public itemCodeChang(itemCode: string): void {
    const Pcode: string = this.kymw1100Model.pCode;
    const ItemCode: string = itemCode;

    // PCodeがある時
    const vo: Array<any> = new Array<any>();

    vo[0] = Pcode;
    vo[1] = ItemCode;

    this.getGoodsDetailService.execute(this.kymw1100Model, vo);

  }

  /**
   * 発注先取引先検索画面
   *
   * @param event 選択時イベント
   */
  public eventOrderClient_CLICKHandler(event: any): void {
    if (this.kymw0400InputVO === null) {
      this.kymw0400InputVO = new KYMW0400InputModel();
    }
    // 取引先のボタン区分
    if (event.target.id === 'btn_OrderClient') {
      this.kymw0400InputVO.supplierFlg = '0';
    } else {
      this.kymw0400InputVO.supplierFlg = '1';
    }
    const componentRef = this.dialogService.openModal(KYMW0400Component);
    const instance = componentRef.componentInstance as KYMW0400Component;
    instance.parent = this;
    instance.setInterfaceParam(this.kymw0400InputVO);
    instance.setKYMW0400Parameter = (outputVO: KYMW0400OutputModel) => this.setKYMW0400Parameter(outputVO);
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  public setKYMW0400Parameter(outputVO: KYMW0400OutputModel): void {
    // 選択した商品がなければ以降の処理は行わない。
    if (PlessViewUtilsSub.isEmpty(outputVO.supplierCode)) {
      return;
    }

    if (outputVO.supplierFlg === '0') {
      this.kymw1100Model.orderClientCode = outputVO.supplierCode;
      this.kymw1100Model.orderClientName = outputVO.supplierNameKanji;
      this.kymw1100Model.tradeStopDivOrder = PlessViewUtilsSub.trim(outputVO.tradeStopDiv);
    } else {
      this.kymw1100Model.payeeClientCode = outputVO.supplierCode;
      this.kymw1100Model.payeeClientName = outputVO.supplierNameKanji;
      this.kymw1100Model.tradeStopDivPayee = PlessViewUtilsSub.trim(outputVO.tradeStopDiv);
    }

    this.eventEditHandler();
  }

  /**
   * 発注先取引先検索画面
   *
   * @param event 選択時イベント
   */
  public eventOrderClient_FOCUSOUTHandler(showMessageFlg = true): void {
    const supplierCode: string = this.kymw1100Model.orderClientCode;

    if (!PlessViewUtilsSub.isEmpty(supplierCode)) {
      new GetSupplierService(this.plessHttp, this.dialogService).execute(this.kymw1100Model, supplierCode, (data: any) => {
        // focusを検索ボタンに移動する。
        this.btn_OrderClient.nativeElement.focus();
        if (PlessViewUtilsSub.isEmpty(data.Supplier)) {
          if (showMessageFlg) {
            this.dialogService.openAlertGetMessage('E0100');
            this.kymw1100Model.orderClientCode = '';
          }
        } else {
          this.kymw1100Model.setSupplierOrder(data);
        }
      });
    }
  }
  /**
   * 支払先取引先検索画面
   *
   * @param event 選択時イベント
   */
  public eventPayeeClient__FOCUSOUTHandler(showMessageFlg = true): void {
    const supplierCode: string = this.kymw1100Model.payeeClientCode;

    if (!PlessViewUtilsSub.isEmpty(supplierCode)) {
      new GetSupplierService(this.plessHttp, this.dialogService).execute(this.kymw1100Model, supplierCode, (data: any) => {
        // focusを検索ボタンに移動する。
        this.btn_PayeeClient.nativeElement.focus();
        if (PlessViewUtilsSub.isEmpty(data.Supplier)) {
          if (showMessageFlg) {
            this.dialogService.openAlertGetMessage('E0100');
            this.kymw1100Model.payeeClientCode = '';
          }
        } else {
          this.kymw1100Model.setSupplierPayee(data);
        }
      });
    }
  }

  /**
   * 利用生協の一括反映ボタンのイベント処理。
   *
   * @param event 選択時イベント
   */
  public eventSupplyPrice_CLICKHandler(): void {
    const bundlePrice: string = this.kymw1100Model.bundlePrice;
    const costPricecoefficient: string = this.kymw1100Model.costPricecoefficient;
    const costPriceSpecial1: string = this.kymw1100Model.texi_costPriceSpecial1;
    const costPriceSpecial2: string = this.kymw1100Model.texi_costPriceSpecial2;

    if (!PlessViewUtilsSub.isEmpty(this.kymw1100Model.bundlePrice)) {

      const vo: Array<any> = ['', '', '', '', ''];

      vo[0] = bundlePrice;
      vo[1] = '';
      vo[2] = costPricecoefficient;
      vo[3] = costPriceSpecial1;
      vo[4] = costPriceSpecial2;

      this.getPurchasePriceService.execute(this.kymw1100Model, vo, (data: any) => {
        // item情報
        this.kymw1100Model.setPurchasePrice(data);

        if (this.btn_SupplyPrice != null) {
          this.btn_SupplyPrice.nativeElement.focus();
        }
      });


    }
  }

  /**
   * 価格バンドル変更時のイベント処理。
   *
   * @param event 変更時イベント
   */
  public eventBundlePrice_ChangeHandler(event: Event): void {
    // 表示中の価格表をローカルに保存
    this.kymw1100Model.savedCoopConsumeTaxPrice();
    let coopInfo = this.kymw1100Model.coopInfoList;
    if (coopInfo != null) {
      for (let i = Number(0); i < coopInfo.length; i++) {
        this.kymw1100Model.updateConsignPriceStandard(coopInfo, coopInfo[i], this.btn_SupplyPrice);
      }
    }

    // Wk表への反映
    if (this.isEnableChangeTax()) {
      coopInfo = this.kymw1100Model.coopInfoWkList;
      if (coopInfo != null) {
        for (let j = Number(0); j < coopInfo.length; j++) {
          this.kymw1100Model.updateConsignPriceStandard(coopInfo, coopInfo[j], this.btn_SupplyPrice);
        }
      }
    }
  }

  /**
   * 全生協一括設定チェック処理。
   *
   * @param event 選択時イベント
   */
  public eventAllCoop_CLICKHandler(event: Event): void {
    const coopInfo: Array<any> = this.kymw1100Model.coopInfoListScreen;
    const coopList32: Array<any> = new Array<any>();
    const classCheck: boolean = this.checkClassCode();
    let goodsXml: any;

    // 農産判定取得
    const checkClassCode = this.checkClassCode();

    if (coopInfo != null) {
      for (let i = Number(0); i < coopInfo.length; i++) {
        // 全生協一括設定チェック有の場合かつ、クルコ以外の生協の場合、設定をチェックする
        if (this.kymw1100Model.allCoop && coopInfo[i].CoopCode !== '454') {
          goodsXml = {
            Check: true,
            CoopCode: coopInfo[i].CoopCode.toString(),
            CoopName: coopInfo[i].CoopName.toString(),
            CoopShortName: coopInfo[i].CoopShortName.toString(),
            SupplyPriceStandard: coopInfo[i].SupplyPriceStandard.toString(),
            SupplyPriceSpecial1: coopInfo[i].SupplyPriceSpecial1.toString(),
            SupplyPriceSpecial2: coopInfo[i].SupplyPriceSpecial2.toString(),
            SupplyTaxWithStd: this.kymw1100Model.getConsumePrice(coopInfo[i].SupplyPriceStandard.toString()),
            SupplyTaxWithSpc1: this.kymw1100Model.getConsumePrice(coopInfo[i].SupplyPriceSpecial1.toString()),
            SupplyTaxWithSpc2: this.kymw1100Model.getConsumePrice(coopInfo[i].SupplyPriceSpecial2.toString()),
            CostPriceStandard: coopInfo[i].CostPriceStandard.toString(),
            CostPriceSpecial1: coopInfo[i].CostPriceSpecial1.toString(),
            CostPriceSpecial2: coopInfo[i].CostPriceSpecial2.toString(),
            ConsignPriceStandard: coopInfo[i].ConsignPriceStandard.toString(),
            ConsignPriceSpecial1: coopInfo[i].ConsignPriceSpecial1.toString(),
            ConsignPriceSpecial2: coopInfo[i].ConsignPriceSpecial2.toString(),
            ProducingAreaComment1: classCheck ?
              this.producingAreaComment(coopInfo[i].ProducingAreaComment1.toString()) : coopInfo[i].ProducingAreaComment1.toString(),
            ProducingAreaComment2: classCheck ?
              this.producingAreaComment(coopInfo[i].ProducingAreaComment2.toString()) : coopInfo[i].ProducingAreaComment2.toString(),
            Enabled: coopInfo[i].Enabled.toString(),
            ClassCode: coopInfo[i].ClassCode,
          };
        } else {
          // 全生協一括設定チェック無の場合、またはクルコの場合、設定をチェック解除する
          goodsXml = {
            Check: false,
            CoopCode: coopInfo[i].CoopCode.toString(),
            CoopName: coopInfo[i].CoopName.toString(),
            CoopShortName: coopInfo[i].CoopShortName.toString(),
            SupplyPriceStandard: '',
            SupplyPriceSpecial1: '',
            SupplyPriceSpecial2: '',
            SupplyTaxWithStd: '',
            SupplyTaxWithSpc1: '',
            SupplyTaxWithSpc2: '',
            CostPriceStandard: '',
            CostPriceSpecial1: '',
            CostPriceSpecial2: '',
            ConsignPriceStandard: '',
            ConsignPriceSpecial1: '',
            ConsignPriceSpecial2: '',
            ProducingAreaComment1: '',
            ProducingAreaComment2: '',
            Enabled: 0,
            ClassCode: coopInfo[i].ClassCode,
          };
        }
        coopList32.push(goodsXml);
        this.kymw1100Model.viewUpdateSelectedCoopInfoList(coopList32);
        this.editFlag = true;
      }
    }
  }

  /**
   * 税込みチェック処理。
   *
   * @param event 選択時イベント
   */
  public eventZeikomi_CLICKHandler(event: Event): void {
    // 現在の内容を保存
    this.kymw1100Model.savedCoopConsumeTaxPrice();

    const bernum: Array<any> = this.dtg_UseCoopInfoList.columns;

    // 税込チェック有の場合、税込み価格を表示する
    if (this.kymw1100Model.zeikomi) {
      bernum[3].visible = true;
      bernum[5].visible = true;
      bernum[7].visible = true;
    } else {
      bernum[3].visible = false;
      bernum[5].visible = false;
      bernum[7].visible = false;
    }
  }

  /**
   * 環境区分によってCheckBoxを使用するかどうか判断する。
   *
   * @param event 選択時イベント
   */
  public eventEcology1Handler(event: Event): void {

    const ecologyEnabledCheck: Array<any> = this.kymw1100Model.goodsEcologyList;

    let goodsXml: any;
    const markList32: Array<any> = new Array<any>();
    if (ecologyEnabledCheck != null) {
      for (let i = Number(0); i < ecologyEnabledCheck.length; i++) {
        goodsXml = {
          Check: false,
          EcologyDiv: ecologyEnabledCheck[i].EcologyDiv.toString(),
          EcologyName: ecologyEnabledCheck[i].EcologyName.toString(),
          Enabled: false
        };

        markList32.push(goodsXml);
      }

      this.kymw1100Model.goodsEcologyList = markList32;
    } else {
      this.kymw1100Model.goodsEcologyList = null;
    }
  }

  public eventEcology2Handler(event: Event): void {

    const ecologyEnabledCheck: Array<any> = this.kymw1100Model.goodsEcologyList;
    let goodsXml: any;
    const markList32: Array<any> = new Array<any>();
    if (ecologyEnabledCheck != null) {
      for (let i = Number(0); i < ecologyEnabledCheck.length; i++) {
        goodsXml = {
          Check: ecologyEnabledCheck[i].Check,
          EcologyDiv: ecologyEnabledCheck[i].EcologyDiv.toString(),
          EcologyName: ecologyEnabledCheck[i].EcologyName.toString(),
          Enabled: true
        };

        markList32.push(goodsXml);
      }

      this.kymw1100Model.goodsEcologyList = markList32;
    } else {
      this.kymw1100Model.goodsEcologyList = null;
    }
  }

  /**
   * 画面制御
   *
   * @param windowFlag (NEW:新規作成、REUSE:流用、CLEAR:クリア)
   */
  public setWindowVisible(mode: string): void {
    switch (mode) {
      case 'NEW':	// 新規作成
        this.getInitDataService.execute(this.kymw1100Model, (data: any) => {
          this.successGoodsPCodeInit(data, true);
        });

        this.setTabVisible();	// 全てのタブを表示する
        this.setNewButton();
        this.clearTabItems();	// 全ての項目を初期化する
        this.clearEditCount();	// 編集カウントをクリアする。
        this.initRatechangeBox();
        this.clearEbaseDataReflectionFlag();								// 仕様反映フラグをクリアする。
        break;

      case 'SEACH':			// 情報取得
        this.setTabVisible();	// 全てのタブを表示する
        this.clearTabItems();
        this.clearEditCount();	// 編集カウントをクリアする。
        this.clearEbaseDataReflectionFlag();								// 仕様反映フラグをクリアする。
        break;

      case 'ITEM_NEW':
        this.getInitDataService.execute(this.kymw1100Model, (data: any) => {
          this.successGoodsItemInit(data);
        });

        this.setItemNewButton();
        // this.cearItemDataGridInfo();				// Item_dataGrid情報
        // アイテムコード情報エリア
        this.clearDataItemInfo();				// Item情報
        this.clearDataItem();					// アイテムタブ
        this.clearDataUseCoopInfo();				// 利用生協タブ
        this.clearDataSpecifications1Info();		// 仕様書1タブ
        this.clearDataSpecifications2Info();		// 仕様書2タブ
        this.clearDataNutrientInfo();		// 誌面栄養成分タブ
        this.clearDataNutrientInfoMulti();	// 複数栄養成分タブ
        this.clearDataEcologyInfo();				// 環境関連タブ

        this.clearDataGoodsSpecificationInfo();							// 商品仕様書マスタ情報をクリアする
        this.clearEbaseDataReflectionFlag();								// 仕様反映フラグをクリアする。

        this.clearEditCount();					// 編集カウントをクリアする。
        break;

      case 'ITEM_CHANGE':
        // this.cearItemDataGridInfo();				// Item_dataGrid情報
        // アイテムコード情報エリア
        this.clearDataItemInfo();				// Item情報
        this.clearDataItem();					// アイテムタブ
        this.clearDataUseCoopInfo();				// 利用生協タブ
        this.clearDataSpecifications1Info();		// 仕様書1タブ
        this.clearDataSpecifications2Info();		// 仕様書2タブ
        this.clearDataNutrientInfo();		// 誌面栄養成分タブ
        this.clearDataNutrientInfoMulti();	// 複数栄養成分タブ
        this.clearDataEcologyInfo();				// 環境関連タブ

        this.clearDataGoodsSpecificationInfo();							// 商品仕様書マスタ情報をクリアする
        this.clearEbaseDataReflectionFlag();								// 仕様反映フラグをクリアする。

        this.clearEditCount();					// 編集カウントをクリアする。
        break;

      case 'EBASE':
        this.setEbaseBtnEnabled();										// eBASEデータボタンの活性制御
        break;

      default:
    }
  }
  public setTabVisible(): void {
    // 全部クリアしてしまうので一番左のタブに戻しておく
    this.kymw1100Model.enabledInfo1Flg = true;
    this.kymw1100Model.enabledInfo2Flg = true;
  }

  /**
   * 新規ボタンのボタン初期を表示する
   */
  public setNewButton(): void {
    this.btn_GoodsPCode.nativeElement.disabled = false;
    this.btn_Copy.nativeElement.disabled = true;
    this.btn_History.nativeElement.disabled = true;
    this.btn_himotuke.nativeElement.disabled = true;
    this.btn_Delete.nativeElement.disabled = true;
    this.btn_Image.nativeElement.disabled = true;
    this.btn_Image2.nativeElement.disabled = true;
    this.btn_GoodsInfoOut.nativeElement.disabled = true;
    this.btn_ProofOut.nativeElement.disabled = true;
    this.btn_RelationPcode.nativeElement.disabled = true;
    this.btn_MultiGoods.nativeElement.disabled = true;
    this.btn_MediumType.nativeElement.disabled = true;

    this.cmb_ItemCode.nativeElement.disabled = false;
    this.btn_ItemCopy.nativeElement.disabled = true;
    this.btn_GoodsItem.nativeElement.disabled = true;
    this.btn_Install.nativeElement.disabled = false;
    this.btn_OrderClient.nativeElement.disabled = false;
    this.btn_PayeeClient.nativeElement.disabled = false;
    this.btn_SupplyPrice.nativeElement.disabled = false;
    this.btn_StatusUpdate.nativeElement.disabled = false;
    this.btn_StatusDelete.nativeElement.disabled = true;

    this.lnb_TextInfo1.nativeElement.disabled = true;
    this.lnb_TextInfo2.nativeElement.disabled = true;
    this.lnb_TextInfo3.nativeElement.disabled = true;
    this.lnb_TextInfo8.nativeElement.disabled = true;
    this.lnb_TextInfo9.nativeElement.disabled = true;

    this.kymw1100Model.eFriendsSendDiv = false;
    this.kymw1100Model.endFlag = true;
    this.dtf_AppkyTermEnd.isDisabled = true;
    this.kymw1100Model.makerNamePublishType = true;
    this.kymw1100Model.packMaterialShowFlg = false;
    this.kymw1100Model.dummyGoods = false;
    this.kymw1100Model.seasonConsumeDiv = false;

    this.chk_JanCodeDiv.nativeElement.disabled = false;
    this.kymw1100Model.janCodeDiv = false;

    this.kymw1100Model.admitStatus = '1';
    this.chk_PackMaterialShowFlg.nativeElement.disabled = false;
    this.kymw1100Model.allCoopIsDisable = false;
    this.cmb_EcNonDispDiv.setCodeValue(EC_NON_DISP_PRICE);			// EC非表示区分「1:価格のみ非表示」
    this.lnb_LicencedDescription.nativeElement.disabled = true;
    this.unenabledNutrientUnitListContextMenu(this.cmDtgNutrientUnitList, false);
    this.unenabledNutrientUnitListContextMenu(this.cmDtgNutrientUnitListMulti, true);
  }
  /**
       * 検索ボタンのボタン初期を表示する
       */
  public setSeachButton(): void {
    // 閲覧モード
    if (this.funcPermission === '1') {
      this.btn_GoodsPCode.nativeElement.disabled = true;
      this.btn_Copy.nativeElement.disabled = true;
      this.btn_History.nativeElement.disabled = false;
      this.btn_himotuke.nativeElement.disabled = false;
      this.btn_Delete.nativeElement.disabled = true;
      this.btn_Image.nativeElement.disabled = false;
      this.btn_Image2.nativeElement.disabled = true;
      this.btn_GoodsInfoOut.nativeElement.disabled = false;
      this.btn_ProofOut.nativeElement.disabled = false;
      this.btn_RelationPcode.nativeElement.disabled = true;
      this.btn_MultiGoods.nativeElement.disabled = true;
      this.btn_MediumType.nativeElement.disabled = true;

      this.cmb_ItemCode.nativeElement.disabled = false;
      this.btn_ItemCopy.nativeElement.disabled = true;
      this.btn_GoodsItem.nativeElement.disabled = true;
      this.btn_Install.nativeElement.disabled = true;
      this.btn_OrderClient.nativeElement.disabled = true;
      this.btn_PayeeClient.nativeElement.disabled = true;
      this.btn_SupplyPrice.nativeElement.disabled = true;
      this.btn_StatusUpdate.nativeElement.disabled = true;
      this.btn_StatusDelete.nativeElement.disabled = true;

      // 文字情報選択
      this.lnb_TextInfo1.nativeElement.disabled = false;
      this.lnb_TextInfo2.nativeElement.disabled = false;
      this.lnb_TextInfo3.nativeElement.disabled = false;
      this.lnb_TextInfo8.nativeElement.disabled = false;
      this.lnb_TextInfo9.nativeElement.disabled = false;

      this.chk_JanCodeDiv.nativeElement.disabled = true;
      this.kymw1100Model.allCoopIsDisable = true;
      this.initUseCoopListColumn();

      this.initRatechangeBox();
      this.lnb_LicencedDescription.nativeElement.disabled = false;
      this.unenabledNutrientUnitListContextMenu(this.cmDtgNutrientUnitList, false);
      this.unenabledNutrientUnitListContextMenu(this.cmDtgNutrientUnitListMulti, true);
    } else if (this.funcPermission === '2') {
      // フルコントロールモード
      // ロック処理が失敗した場合ボタン制御する。
      if (this.lockNum === '1') {
        this.btn_GoodsPCode.nativeElement.disabled = false;
        this.btn_Copy.nativeElement.disabled = false;
        this.btn_History.nativeElement.disabled = false;
        this.btn_himotuke.nativeElement.disabled = true;
        this.btn_Delete.nativeElement.disabled = true;
        this.btn_RelationPcode.nativeElement.disabled = true;
        this.btn_Image.nativeElement.disabled = false;
        this.btn_Image2.nativeElement.disabled = true;
        this.btn_GoodsInfoOut.nativeElement.disabled = false;
        this.btn_ProofOut.nativeElement.disabled = false;
        this.btn_MultiGoods.nativeElement.disabled = false;
        this.btn_MediumType.nativeElement.disabled = false;

        this.cmb_ItemCode.nativeElement.disabled = false;
        this.btn_ItemCopy.nativeElement.disabled = true;
        this.btn_GoodsItem.nativeElement.disabled = true;
        this.btn_Install.nativeElement.disabled = true;
        this.btn_OrderClient.nativeElement.disabled = true;
        this.btn_PayeeClient.nativeElement.disabled = true;
        this.btn_SupplyPrice.nativeElement.disabled = true;
        this.btn_StatusUpdate.nativeElement.disabled = true;
        this.btn_StatusDelete.nativeElement.disabled = true;

        // 文字情報選択
        this.lnb_TextInfo1.nativeElement.disabled = true;
        this.lnb_TextInfo2.nativeElement.disabled = true;
        this.lnb_TextInfo3.nativeElement.disabled = true;
        this.lnb_TextInfo8.nativeElement.disabled = true;
        this.lnb_TextInfo9.nativeElement.disabled = true;

        this.chk_JanCodeDiv.nativeElement.disabled = true;
        this.kymw1100Model.allCoopIsDisable = true;
        this.initUseCoopListColumn();

        this.initRatechangeBox();
        this.kymw1100Model.enabledGoodsPcodeFlg = true;
        this.kymw1100Model.enabledGoodsSpecFlg = false;
        this.kymw1100Model.enabledGoodsKYMW1104Flg = false;

        this.lnb_LicencedDescription.nativeElement.disabled = true;
        this.unenabledNutrientUnitListContextMenu(this.cmDtgNutrientUnitList, false);
        this.unenabledNutrientUnitListContextMenu(this.cmDtgNutrientUnitListMulti, true);
      } else {
        // 承認状況が本登録の場合
        if (this.kymw1100Model.admitStatus === '2') {
          this.btn_GoodsPCode.nativeElement.disabled = false;
          this.btn_Copy.nativeElement.disabled = false;
          this.btn_History.nativeElement.disabled = false;
          this.btn_himotuke.nativeElement.disabled = false;
          this.btn_Delete.nativeElement.disabled = true;
          this.btn_Image.nativeElement.disabled = false;
          this.btn_Image2.nativeElement.disabled = false;
          this.btn_GoodsInfoOut.nativeElement.disabled = false;
          this.btn_ProofOut.nativeElement.disabled = false;
          this.btn_RelationPcode.nativeElement.disabled = false;
          this.btn_MultiGoods.nativeElement.disabled = false;
          this.btn_MediumType.nativeElement.disabled = false;

          this.cmb_ItemCode.nativeElement.disabled = false;
          this.btn_ItemCopy.nativeElement.disabled = true;
          this.btn_GoodsItem.nativeElement.disabled = true;
          this.btn_OrderClient.nativeElement.disabled = false;
          this.btn_PayeeClient.nativeElement.disabled = false;
          this.btn_SupplyPrice.nativeElement.disabled = false;
          this.btn_StatusUpdate.nativeElement.disabled = false;
          this.btn_StatusDelete.nativeElement.disabled = true;

          // 文字情報選択
          this.lnb_TextInfo1.nativeElement.disabled = false;
          this.lnb_TextInfo2.nativeElement.disabled = false;
          this.lnb_TextInfo3.nativeElement.disabled = false;
          this.lnb_TextInfo8.nativeElement.disabled = false;
          this.lnb_TextInfo9.nativeElement.disabled = false;

          this.chk_JanCodeDiv.nativeElement.disabled = false;
          this.kymw1100Model.allCoopIsDisable = true;
          this.lnb_LicencedDescription.nativeElement.disabled = false;
          this.enabledNutrientUnitListContextMenu();
          this.enabledNutrientUnitListMultiContextMenu();
          this.initUseCoopListColumn();

          this.initRatechangeBox();
          this.setItemInstallButton();

          this.kymw1100Model.enabledGoodsCopyFlg = true;
          this.kymw1100Model.enabledGoodsDeleteFlg = false;

          // アイテムコードがひとつ以上の時に「アイテム付替画面」を活性化する。ひとつの時は非活性する。
          if (this.kymw1100Model.itemList.length > 1) {
            this.kymw1100Model.enabledGoodsKYMW1104Flg = true;
          } else {
            this.kymw1100Model.enabledGoodsKYMW1104Flg = false;
          }
        } else {
          // 承認状況が本登録以外の場合
          this.btn_GoodsPCode.nativeElement.disabled = false;
          this.btn_Copy.nativeElement.disabled = false;
          this.btn_History.nativeElement.disabled = false;
          this.btn_himotuke.nativeElement.disabled = true;
          this.btn_Delete.nativeElement.disabled = false;
          this.btn_Image.nativeElement.disabled = false;
          this.btn_Image2.nativeElement.disabled = true;
          this.btn_GoodsInfoOut.nativeElement.disabled = false;
          this.btn_ProofOut.nativeElement.disabled = false;
          this.btn_RelationPcode.nativeElement.disabled = false;
          this.btn_MultiGoods.nativeElement.disabled = false;
          this.btn_MediumType.nativeElement.disabled = false;

          this.cmb_ItemCode.nativeElement.disabled = false;
          this.btn_ItemCopy.nativeElement.disabled = false;
          this.btn_GoodsItem.nativeElement.disabled = false;
          this.btn_OrderClient.nativeElement.disabled = false;
          this.btn_PayeeClient.nativeElement.disabled = false;
          this.btn_SupplyPrice.nativeElement.disabled = false;
          this.btn_StatusUpdate.nativeElement.disabled = false;
          this.btn_StatusDelete.nativeElement.disabled = false;

          // 文字情報選択
          this.lnb_TextInfo1.nativeElement.disabled = false;
          this.lnb_TextInfo2.nativeElement.disabled = false;
          this.lnb_TextInfo3.nativeElement.disabled = false;
          this.lnb_TextInfo8.nativeElement.disabled = false;
          this.lnb_TextInfo9.nativeElement.disabled = false;

          this.chk_JanCodeDiv.nativeElement.disabled = false;

          // 承認状況がeBASE取込後の場合 disabled=false, 承認状況が仮登録の場合 disabled=true
          this.kymw1100Model.allCoopIsDisable = !(this.kymw1100Model.admitStatus === '0' && !this.rdb_AdmitStatus0.disabled);
          this.lnb_LicencedDescription.nativeElement.disabled = false;
          this.enabledNutrientUnitListContextMenu();
          this.enabledNutrientUnitListMultiContextMenu();

          this.initUseCoopListColumn();

          this.initRatechangeBox();

          this.setItemInstallButton();

          this.kymw1100Model.enabledGoodsCopyFlg = true;
          this.kymw1100Model.enabledGoodsDeleteFlg = true;
          this.kymw1100Model.enabledGoodsKYMW1104Flg = false;
        }
      }
    }
    if(this.fmenuService.menus?.[1])
      this.fmenuService.menus[1].itemSources[1].enabled = this.kymw1100Model.enabledGoodsKYMW1104Flg;
  }

  /**
   * janCodeDivによるインストア採番ボタン制御。
   */
  public setItemInstallButton(): void {
    // 閲覧モード・排他モードの時はボタンを非活性にする
    if (this.isDispOnlyModeOrLockMode() || this.kymw1100Model.janCodeDiv) {
      this.btn_Install.nativeElement.disabled = true;
    } else {
      this.btn_Install.nativeElement.disabled = false;
    }
  }

  /**
   * Item新規作成ボタンのボタン設定する。
   */
  public setItemNewButton(): void {
    this.btn_GoodsPCode.nativeElement.disabled = false;
    this.btn_Copy.nativeElement.disabled = false;
    this.btn_History.nativeElement.disabled = false;
    this.btn_himotuke.nativeElement.disabled = true;
    this.btn_Delete.nativeElement.disabled = false;
    this.btn_Image.nativeElement.disabled = false;
    this.btn_Image2.nativeElement.disabled = false;
    this.btn_GoodsInfoOut.nativeElement.disabled = false;
    this.btn_ProofOut.nativeElement.disabled = false;
    this.btn_RelationPcode.nativeElement.disabled = false;
    this.btn_MultiGoods.nativeElement.disabled = false;
    this.btn_MediumType.nativeElement.disabled = false;

    this.cmb_ItemCode.nativeElement.disabled = false;
    this.btn_ItemCopy.nativeElement.disabled = true;
    this.btn_GoodsItem.nativeElement.disabled = true;
    this.btn_Install.nativeElement.disabled = false;
    this.btn_OrderClient.nativeElement.disabled = false;
    this.btn_PayeeClient.nativeElement.disabled = false;
    this.btn_SupplyPrice.nativeElement.disabled = false;
    this.btn_StatusUpdate.nativeElement.disabled = false;
    this.btn_StatusDelete.nativeElement.disabled = true;

    // 文字情報選択
    this.lnb_TextInfo1.nativeElement.disabled = false;
    this.lnb_TextInfo2.nativeElement.disabled = false;
    this.lnb_TextInfo3.nativeElement.disabled = false;
    this.lnb_TextInfo8.nativeElement.disabled = false;
    this.lnb_TextInfo9.nativeElement.disabled = false;

    // janCodeDiv制限
    this.kymw1100Model.janCodeDiv = false;
    this.chk_JanCodeDiv.nativeElement.disabled = false;

    this.lnb_LicencedDescription.nativeElement.disabled = false;
    this.enabledNutrientUnitListContextMenu();
    this.enabledNutrientUnitListMultiContextMenu();
  }

  public clearTabItems(): void {
    // 全部クリアしてしまうので一番左のタブに戻しておく
    // dataGrid情報初期表示
    this.cearPCodeDataGridInfo();			// PCode_dataGrid情報
    this.cearItemDataGridInfo();				// Item_dataGrid情報
    // Pコード情報エリア
    this.clearDataPCodeInfo();				// PCode情報
    this.clearDataGoodsBaseInfo();			// 基本情報タブ
    this.clearDataAdditionInfo();			// 付加情報タブ
    this.clearDataOrderDistributeInfo();		// 発注情報タブ
    this.clearDataGoodsListingInfo();		// 表組情報タブ
    this.clearDataHealthPromotionInfo();		// 保健機能情報タブ
    this.clearDataPageInfo();		// 関連ページタブ

    // // アイテムコード情報エリア
    this.clearDataItemInfo();				// Item情報
    this.clearDataItem();					// アイテムタブ
    this.clearDataUseCoopInfo();				// 利用生協タブ
    this.clearDataSpecifications1Info();		// 仕様書1タブ
    this.clearDataSpecifications2Info();		// 仕様書2タブ
    this.clearDataNutrientInfo();		// 誌面栄養成分タブ
    this.clearDataNutrientInfoMulti();	// 複数栄養成分タブ
    this.clearDataEcologyInfo();				// 環境関連タブ
    this.clearDataGoodsSpecificationInfo();									// 商品仕様書マスタ情報をクリアする
  }

  public cearPCodeDataGridInfo(): void {
    this.dtg_Mark.itemsSource = this.kymw1100Model.markList;
    this.dtg_SelectedMark.itemsSource = null;
    this.dtg_ListingList.itemsSource = this.kymw1100Model.listingList;
    this.dtg_UseCoopInfoList.itemsSource = this.kymw1100Model.coopInfoListScreen;
    this.dtg_DnaInfoList.itemsSource = this.kymw1100Model.dnaList;
    this.dtg_Tag.itemsSource = null;
  }

  public cearItemDataGridInfo(): void {
    this.dtg_GoodsAllergenList.itemsSource = this.kymw1100Model.coopInfoListScreen;
    this.dtg_GoodsEcologyList.itemsSource = this.kymw1100Model.goodsEcologyList;
    this.dtg_GoodsGWStopList.itemsSource = this.kymw1100Model.goodsGWStopList;
    this.dtg_ContainPackingList.itemsSource = this.kymw1100Model.containPackingList;
  }

  /**
   * PCode情報のクリア
   */
  public clearDataPCodeInfo(): void {
    this.kymw1100Model.pCode = '';

    /**
     * CodeComboboxのコードでCodeValueをセットする。
     * 下の項目がセットされる。''→空白、'0'→コード0を探して設定
     * this.selectedCodeDiv
     * this.selectedCodeValue
     * this.selectedCodeName
     * this.selectedCodeDivName
    **/
    this.cmb_BuyerCode.setCodeValue('');

    this.cmb_ClassCode.setClassCode('');
    this.cmb_LargeClassCode.setLargeClassCode('');
    this.cmb_MiddleClassCode.setMiddleClassCode('');
    this.cmb_SmallClassCodeList.setSmallClassCode('');
    this.kymw1100Model.admitStatus = '1';
    this.rdb_AdmitStatus0.disabled = true;
    this.rdb_AdmitStatus1.disabled = false;
    this.rdb_AdmitStatus2.disabled = true;
    this.cmb_CategoryCode.setCategoryCode('');

    this.kymw1100Model.packMaterialShowFlg = false;
    this.kymw1100Model.packMaterialShowFlg = false;
    this.chk_PackMaterialShowFlg.nativeElement.disabled = true;

    this.kymw1100Model.dummyGoods = false;

    this.kymw1100Model.appkyTermEnd = '';
    const today = PlessViewUtilsSub.editDate(
      String(new Date().getFullYear()) +
      PlessViewUtilsSub.padding(String(new Date().getMonth() + 1), 2, '0') +
      PlessViewUtilsSub.padding(String(new Date().getDate()), 2, '0'), '2');
    this.kymw1100Model.appkyTermStart = today;
    this.kymw1100Model.appkyTermEnd = '';

    this.kymw1100Model.guideGoodsName = '';
    this.kymw1100Model.guideStandardName = '';

    this.kymw1100Model.janCodeDiv = false;

  }
  /**
   * 基本情報タブのクリア
   */
  public clearDataGoodsBaseInfo(): void {
    this.kymw1100Model.deliveryGoodsNameKanji = '';
    this.kymw1100Model.deliveryGoodsNameKana = '';
    this.kymw1100Model.deliveryStandardNameKanji = '';
    this.kymw1100Model.deliveryStandardNameKana = '';
    this.kymw1100Model.ocrGoodsName = '';

    // 税率区分と税率の表示更新
    this.kymw1100Model.consumeTaxDivList = '';
    this.cmb_ConsumeTaxDivList.setCodeValue('');
    this.kymw1100Model.consumeTaxDivRate = '';
    this.kymw1100Model.consumeTaxDivRateScreen = '';
    this.kymw1100Model.consumeTaxRateWk = '';
    this.kymw1100Model.consumeTaxDivWk = '';
    this.setConsumeDivAndTax('', '');

    // 利用生協タブの価格表カラムヘッダー更新
    this.updateUseCoopInfoListColumnHeader();

    this.cmb_CycleTerm.setCodeValue('');
    this.cmb_EdlpDiv.setCodeValue('0');
    this.cmb_UnitPriceDiv.setCodeValue('0');

    this.kymw1100Model.unitPriceUnit = '';
    this.kymw1100Model.unitPriceCoefficient = '0.00';

    this.kymw1100Model.consumeTerm = '0';
    this.kymw1100Model.consumeByDate = '0';

    this.kymw1100Model.seasonConsumeDiv = false;

    this.txti_SeasonConsumeTerm.nativeElement.disabled = true;
    this.dtf_SeasonConsumeTermFrom.isDisabled = true;
    this.dtf_SeasonConsumeTermTo.isDisabled = true;

    this.kymw1100Model.seasonConsumeTerm = '';
    this.kymw1100Model.seasonConsumeTermFrom = null;
    this.kymw1100Model.seasonConsumeTermTo = null;

    this.kymw1100Model.leaveConsumeTerm = '';
    this.cmb_GuideTempZoneDiv.setCodeValue('');

    this.kymw1100Model.relationPcodeOld = '';
    this.kymw1100Model.relationPcodeNew = '';

    this.cmb_BlindDiv.setCodeValue('');
    this.kymw1100Model.eFriendsSendDiv = false;

    this.cmb_LiquorCode.setCodeValue('');

    this.kymw1100Model.alocoholType = '';
    this.cmb_ContainerForm.setCodeValue('');
    this.kymw1100Model.containerCapacity = '';
    this.kymw1100Model.mediumText = '';
  }

  /**
   * 付加情報タブのクリア
   */
  public clearDataAdditionInfo(): void {
    this.kymw1100Model.textInfo1 = '';							// 「001：商品説明」
    this.kymw1100Model.textInfo2 = '';							// 「004：キャッチコピー」
    this.kymw1100Model.textInfo3 = '';							// 「018：おすすめコメント（吹き出し）」
    this.kymw1100Model.textInfo4 = '';							// 「019：便利情報（囲み）」
    this.kymw1100Model.textInfo5 = '';							// 「008：便利情報（商品構成内容）」
    this.kymw1100Model.textInfo6 = '';							// 「023：便利情報（その他）」
    this.kymw1100Model.textInfo7 = '';							// 「022：便利情報（ｅフレンズ）」
    this.kymw1100Model.textInfo8 = '';							// 「024：便利情報（サイズ・他）」
    this.kymw1100Model.textInfo9 = '';							// 「003：取扱注意」
    this.kymw1100Model.textInfoCnt1 = '0件';						// 「001：商品説明」
    this.kymw1100Model.textInfoCnt2 = '0件';						// 「004：キャッチコピー」
    this.kymw1100Model.textInfoCnt3 = '0件';						// 「018：おすすめコメント（吹き出し）」
    this.kymw1100Model.textInfoCnt8 = '0件';						// 「024：便利情報（サイズ・他）」
    this.kymw1100Model.textInfoCnt9 = '0件';						// 「003：取扱注意」
    this.kymw1100Model.textInfo10 = '';							// 「034：EC用商品説明」
    this.kymw1100Model.textInfo11 = '';							// 「035：月齢情報」
    this.kymw1100Model.textInfo12 = '';							// 「036：健康管理情報」
    this.kymw1100Model.textInfo13 = '';							// 「037：成分情報」
    this.kymw1100Model.textInfo14 = '';							// 「038：吸水量」
    this.kymw1100Model.textInfo15 = '';							// 「040：調理時間の目安」
    this.kymw1100Model.textInfo16 = '';							// 「041：○人前情報」
    this.kymw1100Model.textInfo17 = '';							// 「042：材料」
    this.kymw1100Model.textInfo18 = '';							// 「043：ご家庭で用意いただくもの」
    this.kymw1100Model.textInfo19 = '';							// 「039：人気商品情報」
  }

  /**
   * 発注情報タブのクリア
   */
  public clearDataOrderDistributeInfo(): void {
    this.cmb_StinkGoodsDivList.setCodeValue('0');
    this.cmb_SetDivList.setCodeValue('');
    this.cmb_CaseSupplyDivList.setCodeValue('0');
    this.cmb_LongKeepDivList.setCodeValue('0');
    this.cmb_AssortTempdivList.setCodeValue('');
    this.cmb_ArrivalAreaDivList.setCodeValue('');
    // 初期表示値「00：掲載なし」を設定
    this.cmb_DutiesFormDailyDivList.setCodeValue('00');
    // 初期表示値「0:割れ物ではないを設定
    this.cmb_FragileFlgList.setCodeValue('0');
    this.kymw1100Model.arrivalGoodsTemp = '';
    this.kymw1100Model.arrivalAdminDays = '';
    this.kymw1100Model.arrivalGoodsTemp = '';
    this.kymw1100Model.arrivalAdminDays = '';
  }

  /**
   * 表組情報タブのクリア
   */
  public clearDataGoodsListingInfo(): void {
    this.kymw1100Model.listingGoodsName = '';
  }

  /**
   * 保健機能情報タブのクリア
   */
  public clearDataHealthPromotionInfo(): void {
    this.kymw1100Model.licencedNo = '';
    this.kymw1100Model.licencedDescription = '';
    this.kymw1100Model.licencedDescriptionCnt = '0件';
  }

  /**
   * 関連ページタブのクリア
   */
  public clearDataPageInfo(): void {
    this.kymw1100Model.coopGoodsTitle = '';
    this.kymw1100Model.coopGoodsUrl = '';
    this.kymw1100Model.pageTitle = '';
    this.kymw1100Model.pageUrl = '';
  }

  /**
   * アイテム情報のクリア
   */
  public clearDataItemInfo(): void {
    // ItemCodeの情報を初期化する。
    this.kymw1100Model.itemList = new Array<any>();
    this.kymw1100Model.itemCode = '';

    // 閲覧・排他モードで開いている場合は、非活性とする
    this.chk_JanCodeDiv.nativeElement.enabled = !this.isDispOnlyModeOrLockMode();
  }

  /**
   * アイテム情報タブのクリア
   */
  public clearDataItem(): void {
    this.kymw1100Model.janCode = '';

    this.cmb_BrandType.setCodeValue('');

    this.kymw1100Model.fcmcFee = '';

    this.cmb_SpecialOrderTypeList.setCodeValue('00');
    this.cmb_StockTypeList.setCodeValue('0');

    this.kymw1100Model.installmentTimes = '1';
    this.kymw1100Model.pdPilingUpDays = '';
    this.kymw1100Model.itfCode = '';
    this.kymw1100Model.installmentTimes = '1';
    this.kymw1100Model.pdPilingUpDays = '';
    this.kymw1100Model.itfCode = '';

    this.cmb_OrderUnitType.setCodeValue('0');
    this.cmb_PriceType.setCodeValue('');

    this.kymw1100Model.makerPrice = '0';
    this.kymw1100Model.orderClientCode = '';
    this.kymw1100Model.tradeStopDivOrder = '';
    this.kymw1100Model.orderClientName = '';
    this.kymw1100Model.payeeClientCode = '';
    this.kymw1100Model.tradeStopDivPayee = '';
    this.kymw1100Model.payeeClientName = '';

    this.kymw1100Model.makerPrice = '0';
    this.kymw1100Model.orderClientCode = '';
    this.kymw1100Model.orderClientName = '';

    this.kymw1100Model.fixContainNum = '';
    this.kymw1100Model.setQuantity = '';

    this.kymw1100Model.updateDate = '';
    this.kymw1100Model.registDate = '';
  }

  /**
   * 利用生協情報タブのクリア
   */
  public clearDataUseCoopInfo(): void {
    this.kymw1100Model.supplyPriceCoefficient = '';
    this.kymw1100Model.supplyPriceSpecial1 = '';
    this.kymw1100Model.supplyPriceSpecial2 = '';
    this.kymw1100Model.costPricecoefficient = '';
    this.kymw1100Model.texi_costPriceSpecial1 = '';
    this.kymw1100Model.texi_costPriceSpecial2 = '';

    this.kymw1100Model.bundlePrice = '';
    this.kymw1100Model.allCoop = false;

  }
  /**
   * 仕様書1情報タブのクリア
   */
  public clearDataSpecifications1Info(): void {
    this.kymw1100Model.ebaseSpecCode = '';
    this.kymw1100Model.specApplyDate = '';
    this.kymw1100Model.registCatalogRound = '';
    this.kymw1100Model.ebaseGetDate = '';
    this.kymw1100Model.makerName = '';

    this.kymw1100Model.peaceSizeLength = '1';
    this.kymw1100Model.peaceSizeWidth = '1';
    this.kymw1100Model.peaceSizeHight = '1';
    this.kymw1100Model.peaceSizeWeight = '1';
    this.kymw1100Model.caseSizeLength = '1';
    this.kymw1100Model.caseSizeWidth = '1';
    this.kymw1100Model.caseSizeHight = '1';
    this.kymw1100Model.caseSizeWeight = '1';

    this.kymw1100Model.stringValue1 = '';
    this.kymw1100Model.stringValue2 = '';
    this.kymw1100Model.stringValue3 = '';
    this.kymw1100Model.stringValue4 = '';
    this.kymw1100Model.stringValue5 = '';
    this.kymw1100Model.stringValue6 = '';

    this.cmb_GeneRecombinationDiv.setCodeValue('0');

    this.kymw1100Model.ebaseSpecCodeRev = '';

  }
  /**
   * 仕様書2情報タブのクリア
   */
  public clearDataSpecifications2Info(): void {
    this.cmb_AllergenTargetType.setCodeValue('1');

    this.kymw1100Model.analysisUnit = '';
    this.kymw1100Model.calorie = '';
    this.kymw1100Model.protein = '';
    this.kymw1100Model.lipid = '';
    this.kymw1100Model.carbohydrate = '';
    this.kymw1100Model.sodium = '';
  }

  /**
   * 誌面栄養成分タブのクリア
   */
  public clearDataNutrientInfo(): void {
    // DataGridのクリアはcearItemDataGridInfo()に書かずにここに書く。
    this.kymw1100Model.nutrientUnitList = new Array<any>();
    this.kymw1100Model.nutrientDetailList = new Array<any>();
    this.kymw1100Model.nutritionalNote = '';
    this.kymw1100Model.hasMultiNutrientInfo = false;
  }
  /**
   * 複数栄養成分タブのクリア
   */
  public clearDataNutrientInfoMulti(): void {
    // DataGridのクリアはcearItemDataGridInfo()に書かずにここに書く。
    this.kymw1100Model.nutrientUnitListMulti = new Array<any>();
    this.kymw1100Model.nutrientDetailListMulti = new Array<any>();
    this.kymw1100Model.nutritionalNoteMulti = '';
    this.kymw1100Model.hiddenNutrientComponentList = new Array<any>();
  }

  /**
   * 環境関連タブのクリア
   */
  public clearDataEcologyInfo(): void {
    this.kymw1100Model.ecology = null;
  }

  /**
   * 商品仕様書マスタ情報のクリア
   */
  public clearDataGoodsSpecificationInfo(): void {

    this.kymw1100Model.pieceSizeLength = '';					// ピースサイズ(縦)
    this.kymw1100Model.pieceSizeWidth = '';						// ピースサイズ(横)
    this.kymw1100Model.pieceSizeHeight = '';						// ピースサイズ(高)
    this.kymw1100Model.pieceWeight = '';					// ピース重量
    this.kymw1100Model.pieceContainNum = '';						// ピース入数
    this.kymw1100Model.pieceJanCode = '';						// ピースＪＡＮコード

    this.kymw1100Model.packSizeLength = '';						// パックサイズ(縦)
    this.kymw1100Model.packSizeWidth = '';						// パックサイズ(横)
    this.kymw1100Model.packSizeHeight = '';						// パックサイズ(高)
    this.kymw1100Model.packWeight = '';					// パック重量
    this.kymw1100Model.packContainNum = '';						// パック入数
    this.kymw1100Model.packJanCode = '';					// パックＪＡＮコード

    this.kymw1100Model.bowlSizeLength = '';						// ボールサイズ(縦)
    this.kymw1100Model.bowlSizeWidth = '';						// ボールサイズ(横)
    this.kymw1100Model.bowlSizeHeight = '';						// ボールサイズ(高)
    this.kymw1100Model.bowlWeight = '';					// ボール重量
    this.kymw1100Model.bowlContainNum = '';						// ボール入数
    this.kymw1100Model.bowlJanCode = '';					// ボールＪＡＮコード

    this.kymw1100Model.caseSizeLengthEbase = '';					// ケースサイズ(縦)
    this.kymw1100Model.caseSizeWidthEbase = '';					// ケースサイズ(横)
    this.kymw1100Model.caseSizeHeightEbase = '';					// ケースサイズ(高)
    this.kymw1100Model.caseWeightEbase = '';				// ケース重量
    this.kymw1100Model.caseContainNumEbase = '';					// ケース入数
    this.kymw1100Model.caseJanCodeEbase = '';					// ケースＪＡＮコード

    this.kymw1100Model.factoryAddress = '';							// 工場住所

  }

  /**
   * 仕様反映フラグの設定
   */
  public eventEbaseDataComplete(): void {
    this.kymw1100Model.ebaseDataReflectionFlag = true;
  }

  /**
   * 仕様反映フラグのクリア
   */
  public clearEbaseDataReflectionFlag(): void {
    this.kymw1100Model.ebaseDataReflectionFlag = false;
  }

  /**
   * 「eBASEデータ」ボタンの活性/非活性制御
   */
  public setEbaseBtnEnabled(): void {
    if(this.btn_eBASE)
      this.btn_eBASE.nativeElement.disabled = !this.isEbaseBtnEnabled();
  }

  /**
   * 「eBASEデータ」ボタンの活性/非活性判定
   *  eBASE取込日を判定し、活性化するか判定する。
   *   -eBASE取込日設定済み ：活性化する
   *   -eBASE取込日未設定   ：非活性にする。
   *
   *  @return true :活性
   *          false:非活性
   */
  public isEbaseBtnEnabled(): boolean {
    if (!PlessViewUtilsSub.isEmpty(this.kymw1100Model.ebaseGetDate)) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * 「アレルゲン調査対象区分」の選択値制御
   *   7大アレルゲンのいずれかが選択された場合 ：「0:対象」を設定する
   *   7大アレルゲンが全て選択解除された場合    ：「1:対象外」を設定する
   *   （AllergenCheckRendererからのコールバック）
   */
  // 項番2231 START 障害管理NO.U01444対応
  // public editAllergenTargetType(selected: boolean): void {
  public editAllergenTargetType(selected: boolean, publishDiv: string): void {
    if (publishDiv === '1') {

      // 「アレルゲン調査対象区分」初期化
      let allergenTargetType: string = <string>'1';	// 「1:対象外」
      if (selected) {

        // 7大アレルゲンのいずれかが選択された場合「0:対象」
        allergenTargetType = '0';
      } else {
        // 7大アレルゲンのいずれかが選択解除された場合
        const allergenCheck: Array<any> = this.kymw1100Model.allergenList;
        // その他の7大アレルゲンの選択状態をチェック
        for (let i = Number(0); i < allergenCheck.length; i++) {
          if (allergenCheck[i].PublishDiv === '1' && allergenCheck[i].Check) {
            // 7大アレルゲンのいずれかが選択されている場合「0:対象」
            allergenTargetType = '0';
            break;
          }
        }
      }

      const currentAllergenType = this.cmb_AllergenTargetType.selectedCodeValue;
      // アレルゲン調査対象区分が変更されたらコンボボックスの表示を更新する
      if (currentAllergenType !== allergenTargetType) {
        // 「アレルゲン調査対象区分」設定
        this.cmb_AllergenTargetType.setCodeValue(allergenTargetType);

        this.dtg_GoodsAllergenList.refreshCells(true);
      }

    }
  }

  /**
   * 税率切り替えコンボボックスの初期化
   */
  public initRatechangeBox(): void {
    const initCodeValue: string = <string>'01';
    this.cmb_RatechangeBox.setCodeValue(initCodeValue);

    // 税率区分と税率の表示更新
    this.setConsumeDivAndTax(this.kymw1100Model.consumeTaxDivList, this.kymw1100Model.consumeTaxDivRate);

    this.kymw1100Model.setSelectedRateChange(initCodeValue);
    // 表示更新
    this.kymw1100Model.setConsumeTaxPrice(this.kymw1100Model.coopInfoList);
  }


  /**
   * 	利用生協タブ内の価格表のカラム初期化
   */
  public initUseCoopListColumn(): void {
    const bernum: Array<any> = this.dtg_UseCoopInfoList.columns;

    this.chk_Zeikomi.nativeElement.disabled = false;
    this.kymw1100Model.zeikomi = false;

    if (!PlessViewUtilsSub.isEmptyArray(bernum)) {
      bernum[3].visible = false;
      bernum[5].visible = false;
      bernum[7].visible = false;
    }
  }

  /**
   * 利用生協の金額表の選択行を取得
   */
  public getUseCoopInfoListSelectedIntede(): number {
    return this.dtg_UseCoopInfoList.selection.row;
  }
  /**
   * 利用生協の金額表の入力処理
   */
  public eventEditHandlerCoopInfoList(selectedIndex: number, colId: string, text: string): void {
    if (selectedIndex >= 0) {
      const obj: any = this.dtg_UseCoopInfoList.itemsSource[selectedIndex];

      // 利用生協タブの価格表をローカルに保存する。
      this.kymw1100Model.savedCoopConsumeTaxPrice();

      if (obj.Check) {
        if (colId === 'SupplyPriceStandard') {
          obj['SupplyTaxWithStd'] = this.kymw1100Model.getConsumePrice(text);
        }
        if (colId === 'SupplyPriceSpecial1') {
          obj['SupplyTaxWithSpc1'] = this.kymw1100Model.getConsumePrice(text);
        }
        if (colId === 'SupplyPriceSpecial2') {
          obj['SupplyTaxWithSpc2'] = this.kymw1100Model.getConsumePrice(text);
        }
      }
    }

  }

  /**
   * 消費税率切り替えが無効か判定する。
   *
   * @return 切り替え不可ならtrue
   */
  public isDisableChangeTax(): boolean {
    return !this.isEnableChangeTax();
  }

  /**
   * 消費税率切り替えが有効か判定する。
   *
   * @return 切り替え可能ならtrue
   */
  public isEnableChangeTax(): boolean {
    const taxChangeFlg: string = CommonSetting.getVal(KEY_TAX_CHANGE_FLG);

    if (taxChangeFlg != null && taxChangeFlg === '1') {
      return true;
    }

    return false;
  }

  /**
   * 編集カウントをカウントする。
   */
  public eventEditHandler(): void {
    this.editFlag = true;
  }
  /**
   * 編集カウントをクリアする。
   */
  public clearEditCount(): void {
    this.editFlag = false;
  }

  /**
   * 閲覧モードであるか、排他失敗(他ユーザがロック)モードであるか判断する
   * @return 閲覧モードか、排他失敗モードであればtrue
   *
   */
  public isDispOnlyModeOrLockMode(): boolean {
    return this.funcPermission === '1' || this.lockNum === '1';
  }

  /**
   * マークコードソート
   * 数値としてソートする。
   */
  public sortMarkCode(obj1: any, obj2: any): number {
    const value1: number = obj1.MarkCode;
    const value2: number = obj2.MarkCode;

    if (value1 < value2) {
      return -1;
    } else if (value1 > value2) {
      return 1;
    } else {
      return 0;
    }
  }

  /**
   * プルーフボタンを押下した時に呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   */
  public eventStatusProofOut_CLICKHandler(): void {
    const voList: Array<any> = new Array<any>();

    for (let i = Number(0); i < this.kymw1100Model.itemList.length; i++) {
      const vo: KYMW1100ProofOutputModel = new KYMW1100ProofOutputModel();
      const itemCode: string = PlessViewUtilsSub.trim(this.kymw1100Model.itemList[i].ItemCode);
      vo.pcode = this.kymw1100Model.pCode;
      vo.itemCode = itemCode;

      voList.push(vo);
    }

    // 商品マスタプルーフ出力API実行f
    this.outputGoodsMasterProofService.execute(this.kymw1100Model, voList, (data: any) => {

      // ファイル名の設定
      const fileName = '商品マスタプルーフ_' + PlessViewUtilsSub.formatedNowDate('YYYYMMDD_hhmmss') + '.zip';

      this.fileDownloadConfirmService.show(data.FileName, fileName);
    });
  }

  /**
   * 複数栄養成分タブの分析単位選択変更時に呼び出されるイベントハンドラ
   * @param event
   *
   */
  public eventNutrientUnitListMulti_CHANGEHandler(): void {
    if(this.dtg_NutrientUnitListMulti)
      this.kymw1100Model.changeNutrientInfoListMulti(this.dtg_NutrientUnitListMulti.selection.row);
  }

  /**
   * 栄養成分タブ　分析単位コンテキストメニュー作成
   */
  public createNutrientUnitListContextMenu(): void {
    this.cmDtgNutrientUnitList = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          {
            header: '栄養成分新規登録', caption: '栄養成分新規登録', cmd: 'nutrientUnitAdd',
            enabled: this.kymw1100Model.enabledNutrientUnitAddFlg
          },
          {
            header: '栄養成分メンテナンス', caption: '栄養成分メンテナンス', cmd: 'nutrientUnitUpdate',
            enabled: this.kymw1100Model.enabledNutrientUnitUpdateFlg
          },
          {
            header: '栄養成分削除', caption: '栄養成分削除', cmd: 'nutrientUnitRemove',
            enabled: this.kymw1100Model.enabledNutrientUnitRemoveFlg
          },
        ],
        command: this.getFormatContextMenuCommand(),
        // イベント設定
        itemClicked: () => {
          switch (this.cmDtgNutrientUnitList.selectedValue) {
            case 'nutrientUnitAdd':
              this.eventAddNutrientContextMenu_CLICKHandler(this.dtg_NutrientUnitList);
              break;
            case 'nutrientUnitUpdate':
              this.eventUpdateNutrientContextMenu_CLICKHandler(this.dtg_NutrientUnitList);
              break;
            case 'nutrientUnitRemove':
              this.eventRemoveNutrientContextMenu_CLICKHandler(this.dtg_NutrientUnitList);
              break;
          }
        }
      }
    );

    // 右クリック押下時 コンテキストメニュー表示処理
    this.dtg_NutrientUnitList.hostElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      // 活性非活性設定
      this.eventContextMenu_Handler(this.cmDtgNutrientUnitList, e.currentTarget.id);
      this.cmDtgNutrientUnitList.show(e);
    });
    // 活性制御用のリストに項目を追加
    this.initForcedEnabledForContextMenuItemByScreenMode(this.cmDtgNutrientUnitList.itemsSource[0], 'none');
    this.initForcedEnabledForContextMenuItemByScreenMode(this.cmDtgNutrientUnitList.itemsSource[1], 'none');
    this.initForcedEnabledForContextMenuItemByScreenMode(this.cmDtgNutrientUnitList.itemsSource[2], 'none');
  }

  /**
   * 複数栄養成分タブ　分析単位コンテキストメニュー作成
   */
  public createNutrientUnitListMultiContextMenu(): void {
    this.cmDtgNutrientUnitListMulti = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          {
            header: '栄養成分新規登録', caption: '栄養成分新規登録', cmd: 'nutrientUnitAdd',
            enabled: this.kymw1100Model.enabledNutrientUnitMultiAddFlg
          },
          {
            header: '栄養成分メンテナンス', caption: '栄養成分メンテナンス', cmd: 'nutrientUnitUpdate',
            enabled: this.kymw1100Model.enabledNutrientUnitMultiUpdateFlg
          },
          {
            header: '栄養成分削除', caption: '栄養成分削除', cmd: 'nutrientUnitRemove',
            enabled: this.kymw1100Model.enabledNutrientUnitMultiRemoveFlg
          },
        ],
        command: this.getFormatContextMenuCommand(),
        // イベント設定
        itemClicked: (s, e) => {
          switch (this.cmDtgNutrientUnitListMulti.selectedValue) {
            case 'nutrientUnitAdd':
              this.eventAddNutrientContextMenu_CLICKHandler(this.dtg_NutrientUnitListMulti);
              break;
            case 'nutrientUnitUpdate':
              this.eventUpdateNutrientContextMenu_CLICKHandler(this.dtg_NutrientUnitListMulti);
              break;
            case 'nutrientUnitRemove':
              this.eventRemoveNutrientContextMenu_CLICKHandler(this.dtg_NutrientUnitListMulti);
              break;
          }
        }
      }
    );

    // 右クリック押下時 コンテキストメニュー表示処理
    this.dtg_NutrientUnitListMulti.hostElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.cmDtgNutrientUnitListMulti !== undefined) {
        // 活性非活性設定
        this.eventContextMenu_Handler(this.cmDtgNutrientUnitListMulti, e.currentTarget.id);
        this.cmDtgNutrientUnitListMulti.show(e);
      }
    });

    // 活性制御用のリストに項目を追加
    this.initForcedEnabledForContextMenuItemByScreenMode(this.cmDtgNutrientUnitListMulti.itemsSource[0], 'none');
    this.initForcedEnabledForContextMenuItemByScreenMode(this.cmDtgNutrientUnitListMulti.itemsSource[1], 'none');
    this.initForcedEnabledForContextMenuItemByScreenMode(this.cmDtgNutrientUnitListMulti.itemsSource[2], 'none');
  }

  /**
   * 栄養成分 コンテキストメニュー項目活性・非活性制御
   *
   * @private
   * @returns
   * @memberof KYMW1100Component
   */
  public eventContextMenu_Handler(contextMenu: Menu, id: string): any {
    if (id === 'dtg_NutrientUnitList') {
      contextMenu.itemsSource.forEach(item => {
        item.enabled = true;
        if (item.caption === '栄養成分新規登録') {
          item.enabled = this.kymw1100Model.enabledNutrientUnitAddFlg;
        }
        if (item.caption === '栄養成分メンテナンス') {
          item.enabled = this.kymw1100Model.enabledNutrientUnitUpdateFlg;
        }
        if (item.caption === '栄養成分削除') {
          item.enabled = this.kymw1100Model.enabledNutrientUnitRemoveFlg;
        }
      });
    } else {
      contextMenu.itemsSource.forEach(item => {
        item.enabled = true;
        if (item.caption === '栄養成分新規登録') {
          item.enabled = this.kymw1100Model.enabledNutrientUnitMultiAddFlg;
        }
        if (item.caption === '栄養成分メンテナンス') {
          item.enabled = this.kymw1100Model.enabledNutrientUnitMultiUpdateFlg;
        }
        if (item.caption === '栄養成分削除') {
          item.enabled = this.kymw1100Model.enabledNutrientUnitMultiRemoveFlg;
        }
      });
    }
  }

  /**
   * 誌面用栄養成分タブ分析単位リストのコンテキストメニューアイテムの活性化
   * @param cm:ContextMenu
   */
  public enabledNutrientUnitListContextMenu(): void {
    if (!PlessViewUtilsSub.isEmptyArray(this.kymw1100Model.nutrientUnitList)) {
      // 誌面栄養成分情報がある場合
      this.kymw1100Model.enabledNutrientUnitAddFlg = false;		// 誌面栄養成分情報登録は非活性
      this.kymw1100Model.enabledNutrientUnitUpdateFlg = true;		// 誌面栄養成分情報メンテナンスは活性
      this.kymw1100Model.enabledNutrientUnitRemoveFlg = true;		// 誌面栄養成分情報削除は活性
    } else {
      // 誌面栄養成分情報がない場合
      this.kymw1100Model.enabledNutrientUnitAddFlg = true;		// 誌面栄養成分情報登録は活性
      this.kymw1100Model.enabledNutrientUnitUpdateFlg = false;		// 誌面栄養成分情報メンテナンスは非活性
      this.kymw1100Model.enabledNutrientUnitRemoveFlg = false;		// 誌面栄養成分情報削除は非活性
    }
  }

  /**
   * 複数栄養成分タブ分析単位リストのコンテキストメニューアイテムの活性化
   * @param cm:ContextMenu
   */
  public enabledNutrientUnitListMultiContextMenu(): void {
    if (!PlessViewUtilsSub.isEmptyArray(this.kymw1100Model.nutrientUnitListMulti)) {
      this.kymw1100Model.enabledNutrientUnitMultiAddFlg = true;
      this.kymw1100Model.enabledNutrientUnitMultiUpdateFlg = true;
      this.kymw1100Model.enabledNutrientUnitMultiRemoveFlg = true;
    } else {
      this.kymw1100Model.enabledNutrientUnitMultiAddFlg = true;
      this.kymw1100Model.enabledNutrientUnitMultiUpdateFlg = false;
      this.kymw1100Model.enabledNutrientUnitMultiRemoveFlg = false;
    }
  }
  /**
   * 分析単位リストのコンテキストメニューアイテムの活性化
   * @param cm:ContextMenu
   */
  public unenabledNutrientUnitListContextMenu(cm: Menu, isMulti: boolean): void {
    // 複数
    if (isMulti) {
      this.kymw1100Model.enabledNutrientUnitMultiAddFlg = false;		// 誌面栄養成分情報登録は非活性
      this.kymw1100Model.enabledNutrientUnitMultiUpdateFlg = false;		// 誌面栄養成分情報メンテナンスは非活性
      this.kymw1100Model.enabledNutrientUnitMultiRemoveFlg = false;		// 誌面栄養成分情報削除は非活性
      // 単数
    } else {
      this.kymw1100Model.enabledNutrientUnitAddFlg = false;		// 誌面栄養成分情報登録は非活性
      this.kymw1100Model.enabledNutrientUnitUpdateFlg = false;		// 誌面栄養成分情報メンテナンスは非活性
      this.kymw1100Model.enabledNutrientUnitRemoveFlg = false;		// 誌面栄養成分情報削除は非活性
    }
  }

  /**
   * 商品栄養成分情報メンテナンス画面起動時の入力情報を作成する。
   */
  public createKYMW1107InputVO(): KYMW1107InputModel {
    const kymw1107InputVO: KYMW1107InputModel = new KYMW1107InputModel();
    kymw1107InputVO.pCode = this.kymw1100Model.pCode;
    kymw1107InputVO.itemCode = this.kymw1100Model.itemCode;
    kymw1107InputVO.guideGoodsName = this.kymw1100Model.guideGoodsName;
    kymw1107InputVO.guideStandardName = this.kymw1100Model.guideStandardName;

    return kymw1107InputVO;
  }
  public eventAddNutrientContextMenu_CLICKHandler(dtg: FlexGrid): void {
    const kymw1107InputVO: KYMW1107InputModel = this.createKYMW1107InputVO();

    if (dtg.hostElement.id === 'dtg_NutrientUnitListMulti') {
      // 複数用
      kymw1107InputVO.analysisSeqNo = '';

    } else {
      // 誌面用
      kymw1107InputVO.analysisSeqNo = '0';
    }
    if ((!PlessViewUtilsSub.isEmptyArray(this.kymw1100Model.nutrientUnitList) &&
      this.kymw1100Model.hiddenNutrientComponentList.length >= 19)
      || (PlessViewUtilsSub.isEmptyArray(this.kymw1100Model.nutrientUnitList) &&
        this.kymw1100Model.hiddenNutrientComponentList.length >= 20)) {
      this.dialogService.openAlertGetMessage('E0221', ['分析単位', '20']);
      return;
    }

    const componentRef = this.dialogService.openModal(KYMW1107Component);
    const instance = componentRef.componentInstance as KYMW1107Component;
    instance.parent = this;
    instance.setInterfaceParam(kymw1107InputVO);
    instance.setKYMW1107Parameter = (outputVO: KYMW1107OutputModel) => this.setKYMW1107Parameter(outputVO);
    instance.closeFunction = () => {
      componentRef.close();
    };
  }
  /**
       * 栄養成分メンテナンス
       */
  public eventUpdateNutrientContextMenu_CLICKHandler(dtg: FlexGrid): void {
    const kymw1107InputVO: KYMW1107InputModel = this.createKYMW1107InputVO();
    if (dtg.hostElement.id === 'dtg_NutrientUnitListMulti') {
      if (dtg.selection.row < 0) {
        this.dialogService.openAlertGetMessage('E0103', ['分析単位']);			// 「分析単位が選択されていません」
      } else {
        // 複数用
        const idx: number = dtg.selection.row;
        kymw1107InputVO.analysisSeqNo = this.kymw1100Model.hiddenNutrientComponentList[idx].analysisSeqNo;
      }
    } else {
      // 誌面用
      kymw1107InputVO.analysisSeqNo = '0';
    }

    const componentRef = this.dialogService.openModal(KYMW1107Component);
    const instance = componentRef.componentInstance as KYMW1107Component;
    instance.parent = this;
    instance.setInterfaceParam(kymw1107InputVO);
    instance.setKYMW1107Parameter = (outputVO: KYMW1107OutputModel) => this.setKYMW1107Parameter(outputVO);
    instance.closeFunction = () => {
      componentRef.close();
    };
  }
  /**
   * 栄養成分削除
   */
  public eventRemoveNutrientContextMenu_CLICKHandler(dtg: FlexGrid): void {
    // 項番2231 START 障害管理NO.U01813対応
    if (dtg.hostElement.id === 'dtg_NutrientUnitListMulti') {
      if (dtg.selection.row < 0) {
        this.dialogService.openAlertGetMessage('E0103', ['分析単位']);			// 「分析単位が選択されていません」
      } else {
        // 削除確認メッセージを表示
        const idx: number = dtg.selection.row;
        const list: Array<any> = Array<any>(dtg.itemsSource);
        this.dialogService.openAlertGetMessage('Q0106', ['選択した分析単位の栄養成分情報'], (closeEvent: any) => {
          if (closeEvent === PlessAlert.Yes) {
            this.removeNutrientInfoListMulti(idx);
          }
        });
      }
    } else {
      this.dialogService.openAlertGetMessage('Q0106', ['選択した分析単位の栄養成分情報'], (closeEvent: any) => {
        if (closeEvent === PlessAlert.Yes) {
          this.removeNutrientInfoList();
        }
      });
    }
  }

  /**
   * 誌面栄養成分タブの栄養成分削除
   */
  public removeNutrientInfoList(): void {
    const vo = {
      pCode: this.kymw1100Model.pCode,
      itemCode: this.kymw1100Model.itemCode,
      analysisSeqNo: '0'
    };

    this.deleteNutrientCompositionService.execute(this.kymw1100Model, vo);
  }

  /**
   * 複数栄養成分タブの栄養成分削除
   * @param idx
   */
  public removeNutrientInfoListMulti(idx: number): void {
    const vo = {
      pCode: this.kymw1100Model.pCode,
      itemCode: this.kymw1100Model.itemCode,
      analysisSeqNo: this.kymw1100Model.hiddenNutrientComponentList[idx].analysisSeqNo
    };

    this.deleteNutrientCompositionService.execute(this.kymw1100Model, vo);
  }

  /**
   * 複数栄養成分タブの栄養成分全削除
   */
  public removeAllNutrientInfoListMulti(): void {

    // 分析連番
    let buf: string = <string>'';
    for (let i = Number(0); i < this.kymw1100Model.hiddenNutrientComponentList.length; i++) {
      const analysisSeqNo: string = this.kymw1100Model.hiddenNutrientComponentList[i].analysisSeqNo;
      buf = buf += (analysisSeqNo + ',');
    }

    const vo = {
      pCode: this.kymw1100Model.pCode,
      itemCode: this.kymw1100Model.itemCode,
      analysisSeqNo: buf
    };

    this.deleteNutrientCompositionService.execute(this.kymw1100Model, vo);
  }

  /**
   * tab_pCodeのタブ選択変更時処理
   *
   * wj-tabタグへのフォーカス充てがうまくできなかったので
   * タブ内で最初に出てくるdiv(枠線を引くのに使用されている)に参照変数を設定して
   * タブ遷移時にフォーカスを充てている
   */
  public selectedTabPCodeChange(): void {
    const selectedIndex = this.tab_pCode?.selectedIndex;
    if (selectedIndex === 0) {
      this.a_BaseInfoTab.nativeElement.focus();
    } else if (selectedIndex === 1) {
      this.a_MarkInfoTab.nativeElement.focus();
    } else if (selectedIndex === 2) {
      this.a_AddInfoTab.nativeElement.focus();
    } else if (selectedIndex === 3) {
      this.a_DivInfoTab.nativeElement.focus();
    } else if (selectedIndex === 4) {
      this.a_GoodsListingTab.nativeElement.focus();
    } else if (selectedIndex === 5) {
      this.a_DnaInfoTab.nativeElement.focus();
    } else if (selectedIndex === 6) {
      this.a_HealthPromotionTab.nativeElement.focus();
    } else if (selectedIndex === 7) {
      this.a_TagInfoTab.nativeElement.focus();
    }
  }

  /**
   * tab_itemのタブ選択変更時処理
   *
   * wj-tabタグへのフォーカス充てがうまくできなかったので
   * タブ内で最初に出てくるdiv(枠線を引くのに使用されている)に参照変数を設定して
   * タブ遷移時にフォーカスを充てている
   */
  public selectedTabItemChange(): void {
    const selectedIndex = this.tab_item?.selectedIndex;
    if (selectedIndex === 0) {
      this.a_itemTab.nativeElement.focus();
    } else if (selectedIndex === 1) {
      this.a_CoopInfoTab.nativeElement.focus();
    } else if (selectedIndex === 2) {
      this.a_Spec1Tab.nativeElement.focus();
    } else if (selectedIndex === 3) {
      this.a_Spec2Tab.nativeElement.focus();
    } else if (selectedIndex === 4) {
      this.a_NutrientTab.nativeElement.focus();
    } else if (selectedIndex === 5) {
      this.a_MultiNutrientTab.nativeElement.focus();
    } else if (selectedIndex === 6) {
      this.a_EcologyTab.nativeElement.focus();
    }
  }

  /**
   * initData取得成功時処理
   */
  private successGoodsPCodeInit(data: any, newFlag = false) {
    // 商品マスタの情報を初期化する。
    this.kymw1100Model.updateMarkInfoList(data);

    this.kymw1100Model.updateListingInfoList(data);

    // 利用生協タブ生協一覧の設定をチェック済みで表示する
    this.kymw1100Model.updateCheckCoopInfoList(data);

    // 利用生協タブ生協一覧の設定をチェック済みで表示する(WK)
    this.kymw1100Model.updateCheckCoopWkInfoList(data);

    // 表示更新
    this.kymw1100Model.setConsumeTaxPrice(this.kymw1100Model.coopInfoList);
    // 商品DNA情報更新
    this.kymw1100Model.updateDnaInfoList(data);

    this.kymw1100Model.updateAllergenInfoList(data);

    this.kymw1100Model.updateEcologyInfoList(data);

    this.kymw1100Model.updateGWStopInfoList(data);

    this.kymw1100Model.updateContainPackingInfoList(data);

    // メニュ項目を初期化する。
    this.kymw1100Model.enabledGoodsCopyFlg = false;
    this.kymw1100Model.enabledGoodsDeleteFlg = false;
    this.kymw1100Model.enabledGoodsKYMW1104Flg = false;
    if(this.fmenuService.menus?.[1])
      this.fmenuService.menus[1].itemSources[1].enabled = this.kymw1100Model.enabledGoodsKYMW1104Flg;

    setTimeout(() => {
      if(this.btn_GoodsPCode)
        this.btn_GoodsPCode.nativeElement.focus();
    }, 100);

    if (newFlag) {
      this.kymw1100Model.ecology = null;
    }

    // 仕様反映フラグを初期化する
    this.clearEbaseDataReflectionFlag();

    // 「eBASEデータ」ボタンの活性制御を行う。
    this.setWindowVisible('EBASE');

  }

  private successGoodsItemInit(data: any) {
    // Item情報初期化。
    this.setItemNewButton();
    this.clearEditCount();

    this.kymw1100Model.updateCoopInfoList(data);

    this.kymw1100Model.updateGoodsCoopWkList(data);

    // 表示更新(税率切り替えはアイテム新規作成では初期化しないため、現在編集中の表を取得し表示）
    this.kymw1100Model.setConsumeTaxPrice(this.kymw1100Model.getEditCoopInfoList());
    this.kymw1100Model.updateAllergenInfoList(data);

    this.kymw1100Model.updateEcologyInfoList(data);

    this.kymw1100Model.updateGWStopInfoList(data);

    this.kymw1100Model.updateContainPackingInfoList(data);

    // 仕様反映フラグを初期化する
    this.clearEbaseDataReflectionFlag();

    // 「eBASEデータ」ボタンの活性制御を行う。
    this.setWindowVisible('EBASE');
  }

  public onSourceChangeSelectedMark() {
    this.dtg_SelectedMark?.autoSizeRows();
  }
  public onResizedColumn(grid: FlexGrid, e: CellRangeEventArgs) {
    if (grid.columns[e.col].wordWrap) {
      grid.autoSizeRows();
    }
  }

  public checkBoxMouseClick(data: any) {
    this.kymw1100Model.updateSelectedCoopInfo(data, this.kymw1100Model.coopInfoListScreen);
    this.dtg_UseCoopInfoList.refreshCells(true);
  }

  /**
   * 画面初期表示時の新規作成ボタン、終了ボタンにおけるtabキー動作処理
   *
   * @param event
   */
  initTabKey(event: any) {
    const target = event.target as HTMLElement;
    const enableInfoFlg = this.kymw1100Model.enabledInfo1Flg && this.kymw1100Model.enabledInfo2Flg
    if (event.key !== 'Tab') {
      return;
    }
    // 新規作成ボタンにフォーカス移動
    if (event.shiftKey) {
      switch (target.id) {
        case 'btn_Print':
          if (enableInfoFlg) {
            return;
          }
          // 「新規作成」にフォーカスが当たるようにする
          this.btn_GoodsPCode.nativeElement.focus();
          event.preventDefault();
          event.stopPropagation();
          return;
        case 'btn_GoodsPCode':
          return;
      }
    }
    if (target.id === 'btn_GoodsPCode') {
      if (!enableInfoFlg) {
        // 「印刷」にフォーカスが当たるようにする
        this.btn_Print.nativeElement.focus();
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      // 活性化しているボタンにフォーカスする
      if (!this.btn_Copy.nativeElement.disabled) {
        this.btn_Copy.nativeElement.focus();
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      if (!this.btn_History.nativeElement.disabled) {
        this.btn_History.nativeElement.focus();
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      if (!this.btn_himotuke.nativeElement.disabled) {
        this.btn_himotuke.nativeElement.focus();
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      if (!this.btn_Image.nativeElement.disabled) {
        this.btn_Image.nativeElement.focus();
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      if (!this.btn_Image2.nativeElement.disabled) {
        this.btn_Image2.nativeElement.focus();
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      if (!this.btn_GoodsInfoOut.nativeElement.disabled) {
        this.btn_GoodsInfoOut.nativeElement.focus();
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      if (!this.btn_ProofOut.nativeElement.disabled) {
        this.btn_ProofOut.nativeElement.focus();
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      if (!this.btn_MultiGoods.nativeElement.disabled) {
        this.btn_MultiGoods.nativeElement.focus();
        event.preventDefault();
        event.stopPropagation();
        return;
      }
    }
  }

  /**
   * tab_KYMW1100のタブ選択変更時処理
   *
   * wj-tabタグへのフォーカス充てがうまくできなかったので
   * タブ内で最初に出てくるdiv(枠線を引くのに使用されている)に参照変数を設定して
   * タブ遷移時にフォーカスを充てている
   */
  public selectedTabKymw1100Change(): void {
    const selectedIndex = this.tab_KYMW1100?.selectedIndex;
    if (selectedIndex === 0) {
      this.btn_Delete.nativeElement.hidden = true;
      this.btn_eBASE.nativeElement.hidden = true;
      this.btn_Print.nativeElement.hidden = true;
      this.btn_StatusUpdate.nativeElement.hidden = true;
      this.btn_Out.nativeElement.hidden = false;
      this.a_CandidateGoodsListTab.nativeElement.focus();

      if (!this.isDispOnlyModeOrLockMode() && this.editFlag) {
        this.dialogService.openAlertGetMessage(
          'Q0107', ['商品情報'], (closeEvent: any): void => {
            if (closeEvent === PlessAlert.Yes) {
              super.LockUtilForGoods('RELEASE', this.kymw1100Model.pCode, null, null, null, null, false);
            } else if (closeEvent === PlessAlert.No) {
              this.tab_KYMW1100.selectedIndex = 1;
            }
          });
      } else {
        super.LockUtilForGoods('RELEASE', this.kymw1100Model.pCode, null, null, null, null, false);
      }
    } else if (selectedIndex === 1) {
      this.btn_Delete.nativeElement.hidden = false;
      this.btn_eBASE.nativeElement.hidden = false;
      this.btn_Print.nativeElement.hidden = false;
      this.btn_StatusUpdate.nativeElement.hidden = false;
      this.btn_Out.nativeElement.hidden = true;
      this.a_GoodsMasterTab.nativeElement.focus();

      if (!this.isEmpty(this.kymw1100Model.pCode)) {
        super.LockUtilForGoods('REGIST', this.kymw1100Model.pCode, null, null, null, null, false);
      }
    }
  }

  /**
   * 出力をクリックした時に呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   */
  public eventOutHandler(): void {
    // // 候補リスト件数チェック
    if (this.checkCandidateGoodsListCount()) {
      // リスト件数が出力最大件数より多い場合、メッセージを表示して処理を終了する。
      const msgStr = ['候補リストの件数が' + this.kymw1100Model.goodsFileMaxCount + '件'];
      this.dialogService.openAlertGetMessage('E0182', msgStr);
    } else {
      // 候補リストを出力
      this.outCandidateGoodsList();
    }
  }

  /**
   * 候補リスト件数チェック
   * 最大出力件数を超えている場合、判定結果true
   */
  private checkCandidateGoodsListCount(): boolean {
    const totalNum: number = this.kymw1100Model.totalNum; // 候補リスト件数
    const goodsFileMaxCount: number = parseInt(this.kymw1100Model.goodsFileMaxCount, 10);	// 候補リスト出力最大件数
    return (totalNum > goodsFileMaxCount) ? true : false;
  }

  /**
   * 候補リストを出力する
   */
  private outCandidateGoodsList(): void {
    // 検索条件を設定
    const searchVo: CandidateGoodsSearchConditionModel = new CandidateGoodsSearchConditionModel();
    searchVo.pcode = this.kymw0300InputVO.pcode;
    searchVo.itemCode = this.kymw0300InputVO.itemCode;
    searchVo.janCode = this.kymw0300InputVO.janCode;
    searchVo.makerName = this.kymw0300InputVO.makerName;
    searchVo.guideGoodsNameList = this.kymw0300InputVO.guideGoodsNameList;
    searchVo.guideStandardNameList = this.kymw0300InputVO.guideStandardNameList;
    searchVo.tagIdList = this.kymw0300InputVO.tagId;
    searchVo.tagSearchType = this.kymw0300InputVO.tagSearchType;
    searchVo.goodsMarkCodeList = this.kymw0300InputVO.goodsMark;
    searchVo.goodsMarkSearchType = this.kymw0300InputVO.goodsMarkSearchType;
    searchVo.dataKbnFlg = this.kymw0300InputVO.dataKbnFlg;
    searchVo.goodsDiv = this.kymw0300InputVO.goodsDiv;
    searchVo.coopCodeList = this.kymw0300InputVO.coopCodeList;
    searchVo.buyerCode = this.kymw0300InputVO.buyerCode;
    searchVo.admitStatus = this.kymw0300InputVO.admitStatus;
    searchVo.registDateFrom = PlessViewUtilsSub.nullToBlank(this.kymw0300InputVO.registDateFrom);
    searchVo.registDateTo = PlessViewUtilsSub.nullToBlank(this.kymw0300InputVO.registDateTo);
    searchVo.updateDateFrom = PlessViewUtilsSub.nullToBlank(this.kymw0300InputVO.updateDateFrom);
    searchVo.updateDateTo = PlessViewUtilsSub.nullToBlank(this.kymw0300InputVO.updateDateTo);
    searchVo.classCode = this.kymw0300InputVO.classCode;
    searchVo.middleClassCode = this.kymw0300InputVO.middleClassCode;
    searchVo.smallClassCode = this.kymw0300InputVO.smallClassCode;
    searchVo.ordrClientCode = this.kymw0300InputVO.ordrClientCode;
    searchVo.ordrClientKanji = this.kymw0300InputVO.ordrClientKanji;
    searchVo.payeeClientCode = this.kymw0300InputVO.payeeClientCode;
    searchVo.payeeClientKanji = this.kymw0300InputVO.payeeClientKanji;
    searchVo.dutiesList = this.kymw0300InputVO.duties;
    searchVo.pcodeList = this.kymw0300InputVO.pcodeList;
    searchVo.itemCodeList = this.kymw0300InputVO.itemCodeList;

    this.makeCandidateGoodsFileService.execute(searchVo, (data: any) => {
      this.kymw1100Model.updateFileUrl(data);
      // ローカルファイル名の作成   商品情報_YYYYMMDD_HHMMSS.txt
      const idx = this.kymw1100Model.fileUrl.lastIndexOf('_');
      const fileName = '商品情報' + this.kymw1100Model.fileUrl.substr(idx);
      // ダウンロードするURL、ファイル名を画面起動のパラメタとして渡すため
      this.fileDownloadConfirmService.show(this.kymw1100Model.fileUrl, fileName);
    });
  }

  /**
   * 『タグ選択』画面を呼び出し、タグ情報の設定を行う。
   */
  public eventTagSelect_CLICKHandler(): void {
    const selectedTagIdList: string[] = [];
    for (let loop = Number(0); loop < this.kymw1100Model.tagInfo.length; loop++) {
      selectedTagIdList.push(this.kymw1100Model.tagInfo[loop].TagId);
    }

    // タグ選択画面を起動
    const componentRef = this.dialogService.openModal(KYMW0002Component);
    const instance = componentRef.componentInstance as KYMW0002Component;
    instance.parent = this;
    instance.setParams(selectedTagIdList);
    instance.closeFunction = () => {
      const params = instance.getParams();

      // 未設定の場合はそのままダイアログを閉じる
      if (!params) {
        componentRef.close();
        return;
      }

      if (params.length !== selectedTagIdList.length){
        // タグ選択画面に渡した配列とタグ選択画面から取得した配列の要素数で比較し要素数が異なれば変更あり
        this.eventEditHandler();
      } else {
        // 要素数が同じであれば中身が異なれば変更あり
        for (const e of params) {
          if (!selectedTagIdList.includes(e.tagId)) {
            this.eventEditHandler();
            break;
          }
        }
      }

      if (params.length > 0) {
        // タグ情報取得を実行
        this.getTagListService.execute(this.kymw1100Model, params);
      } else {
        this.kymw1100Model.tagInfo = [];
      }
      componentRef.close();
    };
  }

  /**
   * 『掲載媒体設定』画面を呼び出し、掲載媒体情報の設定を行う。
   */
  public eventMediumType_CLICKHandler(): void {
    if (PlessViewUtilsSub.isEmpty(this.kymw1100Model.pCode)) {
      this.dialogService.openAlertGetMessage('E0109');
      return;
    }

    // 掲載媒体設定画面を起動
    const componentRef = this.dialogService.openModal(KYMW1202Component);
    const instance = componentRef.componentInstance as KYMW1202Component;
    instance.parent = this;
    instance.setParams({ pCode: this.kymw1100Model.pCode });
    instance.closeFunction = () => {
      // 掲載媒体情報取得を実行
      this.getPublishMediumInfoService.execute(this.kymw1100Model, this.kymw1100Model.pCode);
      componentRef.close();
    };
  }

  /**
   * マルチ設定ボタン押下イベント
   *
   * @param event 選択時イベント
   */
  public eventMultiGoods_CLICKHandler(): void {
    if (PlessViewUtilsSub.isEmpty(this.kymw1100Model.pCode)) {
      this.dialogService.openAlertGetMessage('E0109');
      return;
    }

    // マルチ商品設定画面を起動
    const componentRef = this.dialogService.openModal(KYMW4701Component);
    const instance = componentRef.componentInstance as KYMW4701Component;
    instance.parent = this;
    instance.setInterfaceParam({ pcode: this.kymw1100Model.pCode });
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * コープ商品URL取込(食品)を行う。
   */
  public eventCoopGoodsUrlFoodsHandler(): void {
    // ファイル選択ダイアログを開く
    // ファイルはmultipleの場合を考慮して配列で保持、１件のみならselectedFiles[0]で使用
    this.fileUploadService.upload((selectedFiles: File[]) => {
      // コープ商品URL取込を実行
      this.updateCoopGoodsUrlDataService.execute(this.kymw1100Model, selectedFiles[0], "1", () => {
        if (!this.isEmpty(this.kymw1100Model.pCode)) {
          // 検索実行
          this.getCoopGoodsUrlDataService.execute(this.kymw1100Model, this.kymw1100Model.pCode);
        }
      });
    }, [FileAccept.CSV]);
  }

  /**
   * コープ商品URL取込(日用品)を行う。
   */
  public eventCoopGoodsUrlHouseholdHandler(): void {
    // ファイル選択ダイアログを開く
    // ファイルはmultipleの場合を考慮して配列で保持、１件のみならselectedFiles[0]で使用
    this.fileUploadService.upload((selectedFiles: File[]) => {
      // コープ商品URL取込を実行
      this.updateCoopGoodsUrlDataService.execute(this.kymw1100Model, selectedFiles[0], "2", () => {
        if (!this.isEmpty(this.kymw1100Model.pCode)) {
          // 検索実行
          this.getCoopGoodsUrlDataService.execute(this.kymw1100Model, this.kymw1100Model.pCode);
        }
      });
    }, [FileAccept.CSV]);
  }

  /**
   * コープ商品URL取込(化粧品)を行う。
   */
  public eventCoopGoodsUrlCosmeticsHandler(): void {
    // ファイル選択ダイアログを開く
    // ファイルはmultipleの場合を考慮して配列で保持、１件のみならselectedFiles[0]で使用
    this.fileUploadService.upload((selectedFiles: File[]) => {
      // コープ商品URL取込を実行
      this.updateCoopGoodsUrlDataService.execute(this.kymw1100Model, selectedFiles[0], "3", () => {
          if (!this.isEmpty(this.kymw1100Model.pCode)) {
            // 検索実行
            this.getCoopGoodsUrlDataService.execute(this.kymw1100Model, this.kymw1100Model.pCode);
          }
        });
      }, [FileAccept.CSV]
    );
  }
    
  /**
   * モーダル表示 Xボタン押下
  */
  public onClickWindowClose(){
    const close  = this.canDeactivate();
    if (close instanceof Subject) {
      close.subscribe(_=> {
        if (_) super.onClickWindowClose()
      })
    } else if (close) {
      super.onClickWindowClose();
    }
  }

  public setParams(data: KYMW1100InputModel) {
    this.kymw1100InputVO = data;
    this.kymw1100Model.pCode = data.pCode;

    // 本メソッドの呼び出し元はサイクル設定（KYMW1200）のみ
    // 画面遷移時に商品マスタメンテナンスタブを開いた状態としたいとの要望対応
    this.searchPCode = data.pCode;
  }

  public getParams(): KYMW1100OutputModel {
    return { procDone: this._procDone };
  }

  /**
   * 発注用商品名(カナ)の入力から半角カンマを削除
   */
  public eventDeliveryGoodsNameKana_deleteCommaHandler(): void {
    this.kymw1100Model.deliveryGoodsNameKana = this.kymw1100Model.deliveryGoodsNameKana.replace(/,/g, '');
  }

  /**
   * 発注用規格名(カナ)の入力から半角カンマを削除
   */
  public eventDeliveryStandardNameKana_deleteCommaHandler(): void {
    this.kymw1100Model.deliveryStandardNameKana = this.kymw1100Model.deliveryStandardNameKana.replace(/,/g, '');
  }

  /**
   * 関連情報URLの入力から半角カンマを削除
   */
  public eventPageUrl_deleteCommaHandler(): void {
    this.kymw1100Model.pageUrl = this.kymw1100Model.pageUrl.replace(/,/g, '');
  }

  onCompStart() {
    this.isComposing = true;
  }
  // 全角入力から半角カンマに変換した時に削除するためのメソッド
  onCompDeleteCommaEnd(e: Event) {
    this.isComposing = false;
    (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.replace(/,/g, '');
  }
}
